import * as React from 'react';
import React__default, { useRef, useDebugValue, useContext, createElement as createElement$1, forwardRef, useState, useEffect, createContext, useMemo, useImperativeHandle, useCallback, useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$F = "@font-face {\n  font-family: \"Matter\";\n  font-weight: normal;\n  src: local(\"Matter\"), url(../fonts/Matter-ChowNow-Regular.woff2) format(\"woff2\");\n}\n@font-face {\n  font-family: \"Matter\";\n  font-weight: 500;\n  src: local(\"Matter\"), url(../fonts/Matter-ChowNow-Medium.woff2) format(\"woff2\");\n}\n@font-face {\n  font-family: \"Matter\";\n  font-weight: 600;\n  src: local(\"Matter\"), url(../fonts/Matter-ChowNow-SemiBold.woff2) format(\"woff2\");\n}\n@font-face {\n  font-family: \"Matter\";\n  font-weight: 700;\n  src: local(\"Matter\"), \"Matter\", url(../fonts/Matter-ChowNow-Bold.woff2) format(\"woff2\");\n}";
styleInject(css_248z$F);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var classnames = {exports: {}};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames));

var classNames = classnames.exports;

var _path$s, _path2$i;
function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
function SvgIconClose24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$w({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$s || (_path$s = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.146 4.146a.5.5 0 01.708 0l15 15a.5.5 0 01-.708.708l-15-15a.5.5 0 010-.708z",
    fill: "#1F1F1F"
  })), _path2$i || (_path2$i = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.854 4.146a.5.5 0 010 .708l-15 15a.5.5 0 01-.708-.708l15-15a.5.5 0 01.708 0z",
    fill: "#1F1F1F"
  })));
}

var css_248z$E = ".Alert_alertWrapper__vYypu {\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.Alert_alert__tyPns {\n  background-color: #fff;\n  border-radius: 16px;\n  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);\n  box-sizing: border-box;\n  color: #142138;\n  font: 400 14px/20px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  max-height: calc(100vh - 160px);\n  max-width: 460px;\n  overflow: scroll;\n  padding: 56px 24px 40px;\n  width: calc(100vw - 32px);\n}\n.Alert_alert__tyPns.Alert_center__Yflr6 {\n  text-align: center;\n}\n\n.Alert_iconWrapper__TabR7 {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  position: absolute;\n  right: 16px;\n  top: 16px;\n}\n\n.Alert_iconClose__yJVGQ path {\n  fill: #142138;\n}\n\n.Alert_themed__9bAUy .Alert_alert__tyPns {\n  background-color: #fff;\n  color: #1f1f1f;\n}\n.Alert_themed__9bAUy .Alert_iconClose__yJVGQ path {\n  fill: #1f1f1f;\n}\n\n.Alert_yelp__G6AVY .Alert_alert__tyPns {\n  background-color: #fff;\n  color: #1f1f1f;\n}\n.Alert_yelp__G6AVY .Alert_iconClose__yJVGQ path {\n  fill: #1f1f1f;\n}\n\n/* Small devices and above (tablet, 768px and up) */\n@media (min-width: 768px) {\n  .Alert_alert__tyPns {\n    padding: 56px 40px 40px;\n  }\n}";
var styles$E = {"alertWrapper":"Alert_alertWrapper__vYypu","alert":"Alert_alert__tyPns","center":"Alert_center__Yflr6","iconWrapper":"Alert_iconWrapper__TabR7","iconClose":"Alert_iconClose__yJVGQ","themed":"Alert_themed__9bAUy","yelp":"Alert_yelp__G6AVY"};
styleInject(css_248z$E);

var Alert = function (_a) {
    var _b;
    var _c = _a.className, className = _c === void 0 ? '' : _c, children = _a.children, _d = _a.shouldShowCloseIcon, shouldShowCloseIcon = _d === void 0 ? true : _d, onModalClose = _a.onModalClose, _e = _a.platform, platform = _e === void 0 ? 'brand' : _e, centerAlign = _a.centerAlign;
    return (React__default.createElement("div", { className: classNames(styles$E.alertWrapper, className, styles$E[platform]) },
        shouldShowCloseIcon && (React__default.createElement("button", { className: styles$E.iconWrapper, onClick: onModalClose },
            React__default.createElement(SvgIconClose24, { className: styles$E.iconClose, "data-testid": "Close" }))),
        React__default.createElement("div", { className: classNames(styles$E.alert, (_b = {},
                _b[styles$E.center] = centerAlign,
                _b)) }, children)));
};

var _path$r, _path2$h;
function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
function SvgIconClose16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$v({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$r || (_path$r = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.646 2.646a.5.5 0 01.708 0l10 10a.5.5 0 01-.708.708l-10-10a.5.5 0 010-.708z",
    fill: "#1F1F1F"
  })), _path2$h || (_path2$h = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.354 2.646a.5.5 0 010 .708l-10 10a.5.5 0 01-.708-.708l10-10a.5.5 0 01.708 0z",
    fill: "#1F1F1F"
  })));
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var reactIs$2 = {exports: {}};

var reactIs_production_min$1 = {};

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$2=60103,c$1=60106,d$1=60107,e$1=60108,f$1=60114,g$2=60109,h$1=60110,k$2=60112,l$1=60113,m$1=60120,n$1=60115,p$1=60116,q$2=60121,r$1=60122,u=60117,v$2=60129,w$2=60131;
if("function"===typeof Symbol&&Symbol.for){var x$2=Symbol.for;b$2=x$2("react.element");c$1=x$2("react.portal");d$1=x$2("react.fragment");e$1=x$2("react.strict_mode");f$1=x$2("react.profiler");g$2=x$2("react.provider");h$1=x$2("react.context");k$2=x$2("react.forward_ref");l$1=x$2("react.suspense");m$1=x$2("react.suspense_list");n$1=x$2("react.memo");p$1=x$2("react.lazy");q$2=x$2("react.block");r$1=x$2("react.server.block");u=x$2("react.fundamental");v$2=x$2("react.debug_trace_mode");w$2=x$2("react.legacy_hidden");}
function y$2(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b$2:switch(a=a.type,a){case d$1:case f$1:case e$1:case l$1:case m$1:return a;default:switch(a=a&&a.$$typeof,a){case h$1:case k$2:case p$1:case n$1:case g$2:return a;default:return t}}case c$1:return t}}}var z$2=g$2,A$1=b$2,B$1=k$2,C$1=d$1,D$1=p$1,E$1=n$1,F$1=c$1,G$2=f$1,H$1=e$1,I$1=l$1;reactIs_production_min$1.ContextConsumer=h$1;reactIs_production_min$1.ContextProvider=z$2;reactIs_production_min$1.Element=A$1;reactIs_production_min$1.ForwardRef=B$1;reactIs_production_min$1.Fragment=C$1;reactIs_production_min$1.Lazy=D$1;reactIs_production_min$1.Memo=E$1;reactIs_production_min$1.Portal=F$1;reactIs_production_min$1.Profiler=G$2;reactIs_production_min$1.StrictMode=H$1;
reactIs_production_min$1.Suspense=I$1;reactIs_production_min$1.isAsyncMode=function(){return !1};reactIs_production_min$1.isConcurrentMode=function(){return !1};reactIs_production_min$1.isContextConsumer=function(a){return y$2(a)===h$1};reactIs_production_min$1.isContextProvider=function(a){return y$2(a)===g$2};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b$2};reactIs_production_min$1.isForwardRef=function(a){return y$2(a)===k$2};reactIs_production_min$1.isFragment=function(a){return y$2(a)===d$1};reactIs_production_min$1.isLazy=function(a){return y$2(a)===p$1};reactIs_production_min$1.isMemo=function(a){return y$2(a)===n$1};
reactIs_production_min$1.isPortal=function(a){return y$2(a)===c$1};reactIs_production_min$1.isProfiler=function(a){return y$2(a)===f$1};reactIs_production_min$1.isStrictMode=function(a){return y$2(a)===e$1};reactIs_production_min$1.isSuspense=function(a){return y$2(a)===l$1};reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d$1||a===f$1||a===v$2||a===e$1||a===l$1||a===m$1||a===w$2||"object"===typeof a&&null!==a&&(a.$$typeof===p$1||a.$$typeof===n$1||a.$$typeof===g$2||a.$$typeof===h$1||a.$$typeof===k$2||a.$$typeof===u||a.$$typeof===q$2||a[0]===r$1)?!0:!1};
reactIs_production_min$1.typeOf=y$2;

var reactIs_development$1 = {};

/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function() {

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
var REACT_FRAGMENT_TYPE = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  symbolFor('react.scope');
  symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isConcurrentMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development$1.ContextConsumer = ContextConsumer;
reactIs_development$1.ContextProvider = ContextProvider;
reactIs_development$1.Element = Element;
reactIs_development$1.ForwardRef = ForwardRef;
reactIs_development$1.Fragment = Fragment;
reactIs_development$1.Lazy = Lazy;
reactIs_development$1.Memo = Memo;
reactIs_development$1.Portal = Portal;
reactIs_development$1.Profiler = Profiler;
reactIs_development$1.StrictMode = StrictMode;
reactIs_development$1.Suspense = Suspense;
reactIs_development$1.isAsyncMode = isAsyncMode;
reactIs_development$1.isConcurrentMode = isConcurrentMode;
reactIs_development$1.isContextConsumer = isContextConsumer;
reactIs_development$1.isContextProvider = isContextProvider;
reactIs_development$1.isElement = isElement;
reactIs_development$1.isForwardRef = isForwardRef;
reactIs_development$1.isFragment = isFragment;
reactIs_development$1.isLazy = isLazy;
reactIs_development$1.isMemo = isMemo;
reactIs_development$1.isPortal = isPortal;
reactIs_development$1.isProfiler = isProfiler;
reactIs_development$1.isStrictMode = isStrictMode;
reactIs_development$1.isSuspense = isSuspense;
reactIs_development$1.isValidElementType = isValidElementType;
reactIs_development$1.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$2.exports = reactIs_production_min$1;
} else {
  reactIs$2.exports = reactIs_development$1;
}

function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1="function"===typeof Symbol&&Symbol.for,c=b$1?Symbol.for("react.element"):60103,d=b$1?Symbol.for("react.portal"):60106,e=b$1?Symbol.for("react.fragment"):60107,f=b$1?Symbol.for("react.strict_mode"):60108,g$1=b$1?Symbol.for("react.profiler"):60114,h=b$1?Symbol.for("react.provider"):60109,k$1=b$1?Symbol.for("react.context"):60110,l=b$1?Symbol.for("react.async_mode"):60111,m=b$1?Symbol.for("react.concurrent_mode"):60111,n=b$1?Symbol.for("react.forward_ref"):60112,p=b$1?Symbol.for("react.suspense"):60113,q$1=b$1?
Symbol.for("react.suspense_list"):60120,r=b$1?Symbol.for("react.memo"):60115,t=b$1?Symbol.for("react.lazy"):60116,v$1=b$1?Symbol.for("react.block"):60121,w$1=b$1?Symbol.for("react.fundamental"):60117,x$1=b$1?Symbol.for("react.responder"):60118,y$1=b$1?Symbol.for("react.scope"):60119;
function z$1(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g$1:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k$1:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z$1(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k$1;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g$1;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z$1(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z$1(a)===k$1};reactIs_production_min.isContextProvider=function(a){return z$1(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z$1(a)===n};reactIs_production_min.isFragment=function(a){return z$1(a)===e};reactIs_production_min.isLazy=function(a){return z$1(a)===t};
reactIs_production_min.isMemo=function(a){return z$1(a)===r};reactIs_production_min.isPortal=function(a){return z$1(a)===d};reactIs_production_min.isProfiler=function(a){return z$1(a)===g$1};reactIs_production_min.isStrictMode=function(a){return z$1(a)===f};reactIs_production_min.isSuspense=function(a){return z$1(a)===p};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g$1||a===f||a===p||a===q$1||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k$1||a.$$typeof===n||a.$$typeof===w$1||a.$$typeof===x$1||a.$$typeof===y$1||a.$$typeof===v$1)};reactIs_production_min.typeOf=z$1;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = reactIs_production_min;
} else {
  reactIs$1.exports = reactIs_development;
}

var reactIs = reactIs$1.exports;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$2 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor$2(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$2(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

function y(){return (y=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r]);}return e}).apply(this,arguments)}var v=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},g=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!reactIs$2.exports.typeOf(t)},S=Object.freeze([]),w=Object.freeze({});function E(e){return "function"==typeof e}function b(e){return "production"!==process.env.NODE_ENV&&"string"==typeof e&&e||e.displayName||e.name||"Component"}function _(e){return e&&"string"==typeof e.styledComponentId}var N="undefined"!=typeof process&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",C="undefined"!=typeof window&&"HTMLElement"in window,I=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!==process.env.NODE_ENV),O="production"!==process.env.NODE_ENV?{1:"Cannot create styled-component for component: %s.\n\n",2:"Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",3:"Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",4:"The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",5:"The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",6:"Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",7:'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',8:'ThemeProvider: Please make your "theme" prop an object.\n\n',9:"Missing document `<head>`\n\n",10:"Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",11:"_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",12:"It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",13:"%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",14:'ThemeProvider: "theme" prop is required.\n\n',15:"A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",16:"Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",17:"CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"}:{};function R(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t);})),e}function D(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw "production"===process.env.NODE_ENV?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):new Error(R.apply(void 0,[O[e]].concat(n)).trim())}var j=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e;}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&D(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0;}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++);},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n);}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),T=new Map,x=new Map,k=1,V=function(e){if(T.has(e))return T.get(e);for(;x.has(k);)k++;var t=k++;return "production"!==process.env.NODE_ENV&&((0|t)<0||t>1<<30)&&D(16,""+t),T.set(e,t),x.set(t,e),t},z=function(e){return x.get(e)},B=function(e,t){t>=k&&(k=t+1),T.set(e,t),x.set(t,e);},M="style["+N+'][data-styled-version="5.3.6"]',G$1=new RegExp("^"+N+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),L=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r);},F=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(G$1);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(B(u,c),L(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0;}else r.push(i);}}},Y=function(){return "undefined"!=typeof __webpack_nonce__?__webpack_nonce__:null},q=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(N))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(N,"active"),r.setAttribute("data-styled-version","5.3.6");var i=Y();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},H=function(){function e(e){var t=this.element=q(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}D(17);}(t),this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return !1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--;},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),$$2=function(){function e(e){var t=this.element=q(e);this.nodes=t.childNodes,this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return !1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--;},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),W=function(){function e(e){this.rules=[],this.length=0;}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--;},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),U=C,J={isServer:!C,useCSSOMInjection:!I},X=function(){function e(e,t,n){void 0===e&&(e=w),void 0===t&&(t={}),this.options=y({},J,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&C&&U&&(U=!1,function(e){for(var t=document.querySelectorAll(M),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(N)&&(F(e,o),o.parentNode&&o.parentNode.removeChild(o));}}(this));}e.registerId=function(e){return V(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(y({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new W(o):r?new H(o):new $$2(o),new j(e)));var e,t,n,r,o;},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(V(e),this.names.has(e))this.names.get(e).add(t);else {var n=new Set;n.add(t),this.names.set(e,n);}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(V(e),n);},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear();},t.clearRules=function(e){this.getTag().clearGroup(V(e)),this.clearNames(e);},t.clearTag=function(){this.tag=void 0;},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=z(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=N+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",");})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n';}}}return r}(this)},e}(),Z=/(a)(d)/gi,K=function(e){return String.fromCharCode(e+(e>25?39:97))};function Q(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=K(t%52)+n;return (K(t%52)+n).replace(Z,"$1-$2")}var ee=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},te=function(e){return ee(5381,e)};function ne(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(E(n)&&!_(n))return !1}return !0}var re=te("5.3.6"),oe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic="production"===process.env.NODE_ENV&&(void 0===n||n.isStatic)&&ne(e),this.componentId=t,this.baseHash=ee(re,t),this.baseStyle=n,X.registerId(t);}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else {var s=_e(this.rules,e,t,n).join(""),i=Q(ee(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a);}o.push(i),this.staticRulesId=i;}else {for(var c=this.rules.length,u=ee(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h,"production"!==process.env.NODE_ENV&&(u=ee(u,h+d));else if(h){var p=_e(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=ee(u,f+d),l+=f;}}if(l){var m=Q(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y);}o.push(m);}}return o.join(" ")},e}(),se=/^\s*\/\/.*$/gm,ie=[":","[",".","#"];function ae(e){var t,n,r,o,s=void 0===e?w:e,i=s.options,a=void 0===i?w:i,c=s.plugins,u=void 0===c?S:c,l=new stylis_min(a),d=[],p=function(e){function t(t){if(t)try{e(t+"}");}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t);}}}((function(e){d.push(e);})),f=function(e,r,s){return 0===r&&-1!==ie.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(se,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f));},p,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||D(15),ee(e,t.name)}),5381).toString():"",m}var ce=React__default.createContext();ce.Consumer;var le=React__default.createContext(),de=(le.Consumer,new X),he=ae();function pe(){return useContext(ce)||de}function fe(){return useContext(le)||he}var ye=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=he);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"));},this.toString=function(){return D(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t;}return e.prototype.getName=function(e){return void 0===e&&(e=he),this.name+e.hash},e}(),ve=/([A-Z])/,ge=/([A-Z])/g,Se=/^ms-/,we=function(e){return "-"+e.toLowerCase()};function Ee(e){return ve.test(e)?e.replace(ge,we).replace(Se,"-ms-"):e}var be=function(e){return null==e||!1===e||""===e};function _e(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=_e(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(be(e))return "";if(_(e))return "."+e.styledComponentId;if(E(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return "production"!==process.env.NODE_ENV&&reactIs$2.exports.isElement(u)&&console.warn(b(e)+" is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."),_e(u,n,r,o)}var l;return e instanceof ye?r?(e.inject(r,o),e.getName(o)):e:g(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!be(t[i])&&(Array.isArray(t[i])&&t[i].isCss||E(t[i])?s.push(Ee(i)+":",t[i],";"):g(t[i])?s.push.apply(s,e(t[i],i)):s.push(Ee(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitlessKeys?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ne=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ae(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return E(e)||g(e)?Ne(_e(v(S,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ne(_e(v(e,n)))}var Ce=/invalid hook call/i,Ie=new Set,Pe=function(e,t){if("production"!==process.env.NODE_ENV){var n="The component "+e+(t?' with the id of "'+t+'"':"")+" has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.",r=console.error;try{var o=!0;console.error=function(e){if(Ce.test(e))o=!1,Ie.delete(n);else {for(var t=arguments.length,s=new Array(t>1?t-1:0),i=1;i<t;i++)s[i-1]=arguments[i];r.apply(void 0,[e].concat(s));}},useRef(),o&&!Ie.has(n)&&(console.warn(n),Ie.add(n));}catch(e){Ce.test(e.message)&&Ie.delete(n);}finally{console.error=r;}}},Oe=function(e,t,n){return void 0===n&&(n=w),e.theme!==n.theme&&e.theme||t||n.theme},Re=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,De=/(^-|-$)/g;function je(e){return e.replace(Re,"-").replace(De,"")}var Te=function(e){return Q(te(e)>>>0)};function xe(e){return "string"==typeof e&&("production"===process.env.NODE_ENV||e.charAt(0)===e.charAt(0).toLowerCase())}var ke=function(e){return "function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Ve=function(e){return "__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function ze(e,t,n){var r=e[n];ke(t)&&ke(r)?Be(r,t):e[n]=t;}function Be(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(ke(i))for(var a in i)Ve(a)&&ze(e,i[a],a);}return e}var Me=React__default.createContext();Me.Consumer;var Fe={};function Ye(e,t,n){var o=_(e),i=!xe(e),a=t.attrs,c=void 0===a?S:a,d=t.componentId,h=void 0===d?function(e,t){var n="string"!=typeof e?"sc":je(e);Fe[n]=(Fe[n]||0)+1;var r=n+"-"+Te("5.3.6"+n+Fe[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):d,p=t.displayName,v=void 0===p?function(e){return xe(e)?"styled."+e:"Styled("+b(e)+")"}(e):p,g=t.displayName&&t.componentId?je(t.displayName)+"-"+t.componentId:t.componentId||h,N=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,A=t.shouldForwardProp;o&&e.shouldForwardProp&&(A=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var C,I=new oe(n,g,o?e.componentStyle:void 0),P=I.isStatic&&0===c.length,O=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,d=e.shouldForwardProp,h=e.styledComponentId,p=e.target;"production"!==process.env.NODE_ENV&&useDebugValue(h);var m=function(e,t,n){void 0===e&&(e=w);var r=y({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in E(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t];})),[r,o]}(Oe(t,useContext(Me),a)||w,t,o),v=m[0],g=m[1],S=function(e,t,n,r){var o=pe(),s=fe(),i=t?e.generateAndInjectStyles(w,o,s):e.generateAndInjectStyles(n,o,s);return "production"!==process.env.NODE_ENV&&useDebugValue(i),"production"!==process.env.NODE_ENV&&!t&&r&&r(i),i}(i,r,v,"production"!==process.env.NODE_ENV?e.warnTooManyClasses:void 0),b=n,_=g.$as||t.$as||g.as||t.as||p,N=xe(_),A=g!==t?y({},t,{},g):t,C={};for(var I in A)"$"!==I[0]&&"as"!==I&&("forwardedAs"===I?C.as=A[I]:(d?d(I,isPropValid,_):!N||isPropValid(I))&&(C[I]=A[I]));return t.style&&g.style!==t.style&&(C.style=y({},t.style,{},g.style)),C.className=Array.prototype.concat(c,h,S!==h?S:null,t.className,g.className).filter(Boolean).join(" "),C.ref=b,createElement$1(_,C)}(C,e,t,P)};return O.displayName=v,(C=React__default.forwardRef(O)).attrs=N,C.componentStyle=I,C.displayName=v,C.shouldForwardProp=A,C.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):S,C.styledComponentId=g,C.target=o?e.target:e,C.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return {};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(xe(e)?e:je(b(e)));return Ye(e,y({},o,{attrs:N,componentId:s}),n)},Object.defineProperty(C,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?Be({},e.defaultProps,t):t;}}),"production"!==process.env.NODE_ENV&&(Pe(v,g),C.warnTooManyClasses=function(e,t){var n={},r=!1;return function(o){if(!r&&(n[o]=!0,Object.keys(n).length>=200)){var s=t?' with the id of "'+t+'"':"";console.warn("Over 200 classes were generated for component "+e+s+".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"),r=!0,n={};}}}(v,g)),C.toString=function(){return "."+C.styledComponentId},i&&hoistNonReactStatics_cjs(C,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),C}var qe=function(e){return function e(t,r,o){if(void 0===o&&(o=w),!reactIs$2.exports.isValidElementType(r))return D(1,String(r));var s=function(){return t(r,o,Ae.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,y({},o,{},n))},s.attrs=function(n){return e(t,r,y({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Ye,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){qe[e]=qe(e);}));"production"!==process.env.NODE_ENV&&"undefined"!=typeof navigator&&"ReactNative"===navigator.product&&console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"),"production"!==process.env.NODE_ENV&&"test"!==process.env.NODE_ENV&&"undefined"!=typeof window&&(window["__styled-components-init__"]=window["__styled-components-init__"]||0,1===window["__styled-components-init__"]&&console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."),window["__styled-components-init__"]+=1);var styled = qe;

// Colors used for styled components
var colors$1 = {
    // -----------------------
    // BRAND - GLOBAL
    // -----------------------
    neutral: {
        x1: '#fff',
        x2: '#f2f2f2',
        x3: '#dbdbdb',
        x4: '#a3a3a3',
        x5: '#6e6e6e',
        x6: '#1f1f1f',
        x7: '#000'
    },
    success: {
        x1: '#e6f5ee',
        x2: '#21a369',
        x3: '#0e7a4a'
    },
    caution: {
        x1: '#fae9e6',
        x2: '#f5563d',
        x3: '#cc1b00'
    },
    opacity: {
        neutral1: {
            x8: 'rgba(255, 255, 255, 0.08)',
            x16: 'rgba(255, 255, 255, 0.16)',
            x24: 'rgba(255, 255, 255, 0.24)',
            x40: 'rgba(255, 255, 255, 0.4)',
            x64: 'rgba(255, 255, 255, 0.64)'
        },
        neutral7: {
            x8: 'rgba(0, 0, 0, 0.08)',
            x16: 'rgba(0, 0, 0, 0.16)',
            x24: 'rgba(0, 0, 0, 0.24)',
            x40: 'rgba(0, 0, 0, 0.4)',
            x64: 'rgba(0, 0, 0, 0.64)'
        }
    },
    // -----------------------
    // BRAND - PRIMARY
    // -----------------------
    paper: {
        x1: '#f5f4f1',
        x2: '#dad8d2',
        x3: '#b2afa4'
    },
    ink: {
        x1: '#929bad',
        x2: '#343e52',
        x3: '#142138'
    },
    berry: {
        x1: '#fae1e1',
        x2: '#f98686',
        x3: '#f94e4e'
    },
    fig: {
        x1: '#dadff7',
        x2: '#5268cc',
        x3: '#223ba8'
    },
    // -----------------------
    // BRAND - SECONDARY
    // -----------------------
    orange: {
        x1: '#fcd1c8',
        x2: '#f99885',
        x3: '#f9603d'
    },
    lemon: {
        x1: '#f8edcd',
        x2: '#f6c774',
        x3: '#fcef54'
    },
    basil: {
        x1: '#afeedf',
        x2: '#2e9952',
        x3: '#00bd71'
    },
    icee: {
        x1: '#dff4f4',
        x2: '#2738a3',
        x3: '#50cdf9'
    },
    // -----------------------
    // THEMED - BASE COLORS
    // -----------------------
    vanilla: {
        x1: '#f5f4f1',
        x2: '#d9d7d3',
        x3: '#2d2a25',
        x4: '#000'
    },
    sage: {
        x1: '#e6f7ee',
        x2: '#b9e6d4',
        x3: '#13aa6d',
        x4: '#008854'
    },
    eggplant: {
        x1: '#f7f3ff',
        x2: '#dfd4f5',
        x3: '#8258d4',
        x4: '#6d46bb'
    },
    blueberry: {
        x1: '#f0f3ff',
        x2: '#cdd7ff',
        x3: '#405de0',
        x4: '#284ce4'
    },
    blueraspberry: {
        x1: '#e2f5fd',
        x2: '#b6e2fa',
        x3: '#1c9ceb',
        x4: '#1b88d7'
    },
    turquoise: {
        x1: '#e1fbfb',
        x2: '#abe1e3',
        x3: '#02b3b5',
        x4: '#009292'
    },
    grass: {
        x1: '#e7f5e3',
        x2: '#c6e5bc',
        x3: '#3aac00',
        x4: '#308f00'
    },
    kiwi: {
        x1: '#ebf6c0',
        x2: '#ddf197',
        x3: '#9fb800',
        x4: '#8ca200'
    },
    citrus: {
        x1: '#faf6e0',
        x2: '#ecd87f',
        x3: '#dfa600',
        x4: '#c59300'
    },
    persimmon: {
        x1: '#faf1e0',
        x2: '#f5d396',
        x3: '#dd8607',
        x4: '#cd6703'
    },
    tomato: {
        x1: '#fdedeb',
        x2: '#f8cec9',
        x3: '#da1f07',
        x4: '#c11c07'
    },
    raspberry: {
        x1: '#feedf8',
        x2: '#ffc6ec',
        x3: '#e63ea9',
        x4: '#d0078a'
    },
    grape: {
        x1: '#fff0fa',
        x2: '#fac4e9',
        x3: '#b5388c',
        x4: '#a22b7b'
    }
};
// -----------------------
// SEMANTIC NAMING
// -----------------------
var semanticColors = {
    brand: {
        border: {
            primary: colors$1.paper.x2,
            secondary: colors$1.paper.x3,
            tertiary: colors$1.ink.x3,
            active: colors$1.fig.x3,
            caution: colors$1.caution.x3,
            transparent: colors$1.opacity.neutral7.x24,
            inversePrimary: colors$1.ink.x1,
            inverseSecondary: colors$1.ink.x2,
            inverseTertiary: colors$1.neutral.x1,
            inverseCaution: colors$1.caution.x2,
            inverseTransparent: colors$1.opacity.neutral1.x24
        },
        content: {
            primary: colors$1.ink.x3,
            secondary: colors$1.neutral.x5,
            tertiary: colors$1.paper.x3,
            accent: colors$1.fig.x2,
            active: colors$1.fig.x3,
            chownow: colors$1.berry.x3,
            success: colors$1.success.x3,
            caution: colors$1.caution.x3,
            inversePrimary: colors$1.neutral.x1,
            inverseSecondary: colors$1.ink.x1,
            inverseActive: colors$1.fig.x1,
            inverseCaution: colors$1.caution.x2
        },
        surface: {
            primary: colors$1.neutral.x1,
            secondary: colors$1.paper.x1,
            tertiary: colors$1.paper.x2,
            active: colors$1.fig.x3,
            success: colors$1.success.x1,
            caution: colors$1.caution.x1,
            accentPrimary: colors$1.paper.x1,
            accentSecondary: colors$1.paper.x2,
            inversePrimary: colors$1.ink.x3,
            inverseSecondary: colors$1.ink.x2
        }
    },
    themed: {
        border: {
            primary: colors$1.neutral.x3,
            secondary: colors$1.neutral.x4,
            tertiary: colors$1.neutral.x6,
            caution: colors$1.caution.x3,
            active: colors$1.sage.x4,
            transparent: colors$1.opacity.neutral7.x24,
            inverseTertiary: colors$1.neutral.x1,
            inverseTransparent: colors$1.opacity.neutral1.x24
        },
        content: {
            primary: colors$1.neutral.x6,
            secondary: colors$1.neutral.x5,
            tertiary: colors$1.neutral.x4,
            active: colors$1.sage.x4,
            chownow: colors$1.berry.x3,
            success: colors$1.success.x3,
            caution: colors$1.caution.x3,
            inversePrimary: colors$1.neutral.x1
        },
        surface: {
            primary: colors$1.neutral.x1,
            secondary: colors$1.neutral.x2,
            tertiary: colors$1.neutral.x3,
            active: colors$1.sage.x4,
            success: colors$1.success.x1,
            caution: colors$1.caution.x1,
            accentPrimary: colors$1.sage.x1,
            accentSecondary: colors$1.sage.x2,
            inversePrimary: colors$1.sage.x3
        }
    },
    yelp: {
        border: {
            primary: colors$1.neutral.x3,
            secondary: colors$1.neutral.x4,
            tertiary: colors$1.neutral.x6,
            caution: colors$1.caution.x3,
            active: '#b91608',
            transparent: colors$1.opacity.neutral7.x24,
            inverseTertiary: colors$1.neutral.x1,
            inverseTransparent: colors$1.opacity.neutral1.x24
        },
        content: {
            primary: colors$1.neutral.x6,
            secondary: colors$1.neutral.x5,
            tertiary: colors$1.neutral.x4,
            active: '#b91608',
            chownow: colors$1.berry.x3,
            success: colors$1.success.x3,
            caution: colors$1.caution.x3,
            inversePrimary: colors$1.neutral.x1
        },
        surface: {
            primary: colors$1.neutral.x1,
            secondary: colors$1.neutral.x2,
            tertiary: colors$1.neutral.x3,
            active: '#b91608',
            success: colors$1.success.x1,
            caution: colors$1.caution.x1,
            accentPrimary: '#fdedeb',
            accentSecondary: '#f8cdc9',
            inversePrimary: '#cd2e20'
        }
    }
};

// Types used for styled components
var fontFamilyBase = "'Matter', 'Helvetica Neue', Helvetica, Arial, sans-serif";
var fontWeight = {
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700
};
var letterSpacing = {
    base: '0',
    lg: '0.2px',
    headline: {
        x64: '-1.6px',
        x48: '-1px',
        x40: '-0.6px',
        x32: '-0.4px',
        x24: '-0.2px'
    }
};
var headline = {
    md: {
        x24: "".concat(fontWeight.regular, " 24px/28px ").concat(fontFamilyBase),
        x32: "".concat(fontWeight.regular, " 32px/36px ").concat(fontFamilyBase),
        x40: "".concat(fontWeight.regular, " 40px/44px  ").concat(fontFamilyBase),
        x48: "".concat(fontWeight.regular, " 48px/52px ").concat(fontFamilyBase),
        x64: "".concat(fontWeight.regular, " 64px/64px ").concat(fontFamilyBase)
    }
};
var label = {
    reg: {
        x12: "".concat(fontWeight.regular, " 12px/16px ").concat(fontFamilyBase),
        x14: "".concat(fontWeight.regular, " 14px/16px ").concat(fontFamilyBase),
        x16: "".concat(fontWeight.regular, " 16px/24px ").concat(fontFamilyBase),
        x20: "".concat(fontWeight.regular, " 20px/24px ").concat(fontFamilyBase)
    },
    md: {
        x12: "".concat(fontWeight.medium, " 12px/16px ").concat(fontFamilyBase),
        x14: "".concat(fontWeight.medium, " 14px/16px ").concat(fontFamilyBase),
        x16: "".concat(fontWeight.medium, " 16px/24px ").concat(fontFamilyBase),
        x20: "".concat(fontWeight.medium, " 20px/24px ").concat(fontFamilyBase)
    },
    semi: {
        x12: "".concat(fontWeight.semiBold, " 12px/16px ").concat(fontFamilyBase),
        x14: "".concat(fontWeight.semiBold, " 14px/16px ").concat(fontFamilyBase),
        x16: "".concat(fontWeight.semiBold, " 16px/24px ").concat(fontFamilyBase),
        x20: "".concat(fontWeight.semiBold, " 20px/24px ").concat(fontFamilyBase)
    }
};
var paragraph = {
    reg: {
        x14: "".concat(fontWeight.regular, " 14px/20px ").concat(fontFamilyBase),
        x16: "".concat(fontWeight.regular, " 16px/24px ").concat(fontFamilyBase),
        x20: "".concat(fontWeight.regular, " 20px/28px ").concat(fontFamilyBase)
    },
    italic: {
        x14: "italic 14px/20px ".concat(fontFamilyBase),
        x16: "italic 16px/24px ".concat(fontFamilyBase),
        x20: "italic 20px/28px ".concat(fontFamilyBase)
    },
    semi: {
        x14: "".concat(fontWeight.semiBold, " 14px/20px ").concat(fontFamilyBase),
        x16: "".concat(fontWeight.semiBold, " 16px/24px ").concat(fontFamilyBase),
        x20: "".concat(fontWeight.semiBold, " 20px/28px ").concat(fontFamilyBase)
    }
};
// to be used with text-transform: uppercase
var caption = {
    md: {
        x10: "".concat(fontWeight.medium, " 10px/16px ").concat(fontFamilyBase),
        x12: "".concat(fontWeight.medium, " 12px/16px  ").concat(fontFamilyBase)
    }
};

// Variables used for styled components
var space = {
    half: '4px',
    oneAndHalf: '12px',
    x1: '8px',
    x2: '16px',
    x3: '24px',
    x4: '32px',
    x5: '40px',
    x6: '48px',
    x7: '56px',
    x8: '64px',
    x9: '72px',
    x10: '80px',
    x11: '88px',
    x12: '96px'
};
var grid = {
    breakpoint: {
        md: '768px',
        lg: '1200px',
        max: '1440px'
    },
    maxWidth: '1328px'
};

var _path$q;
function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
function SvgIconCarot16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$u({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$q || (_path$q = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.13 6.164a.5.5 0 01.706-.034L8 10.824l5.164-4.694a.5.5 0 11.672.74l-5.5 5a.5.5 0 01-.672 0l-5.5-5a.5.5 0 01-.034-.706z",
    fill: "#1F1F1F"
  })));
}

var _path$p;
function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
function SvgIconCarot24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$t({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$p || (_path$p = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.38 8.164a.5.5 0 01.706-.034L12 15.324l7.914-7.194a.5.5 0 11.672.74l-8.25 7.5a.5.5 0 01-.672 0l-8.25-7.5a.5.5 0 01-.034-.706z",
    fill: "#1F1F1F"
  })));
}

var css_248z$D = "@-webkit-keyframes Button_rotation__-xnxX {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes Button_rotation__-xnxX {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n/*************************************************\n  NOTE: This section is for NON COLOR related styles.\n  All theme related color styles are below.\n*************************************************/\n.Button_button__2JA4L {\n  align-items: center;\n  border: none;\n  border-radius: 28px;\n  cursor: pointer;\n  display: flex;\n  font: 500 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  height: 48px;\n  justify-content: center;\n  padding: 16px 24px;\n  position: relative;\n  text-align: center;\n  transition: background-color 0.3s, opacity 0.3s, border-color 0.3s;\n  white-space: nowrap;\n}\n.Button_button__2JA4L .Button_iconDropdown__sauV3,\n.Button_button__2JA4L .Button_icon__OeKUC {\n  height: 16px;\n  margin-left: 8px;\n  width: 16px;\n}\n.Button_button__2JA4L .Button_icon__OeKUC {\n  margin: 0 8px 0 0;\n}\n.Button_button__2JA4L.Button_buttonIcon__qBAXq {\n  padding: 16px;\n}\n.Button_button__2JA4L.Button_buttonIcon__qBAXq .Button_icon__OeKUC {\n  margin: 0;\n}\n.Button_button__2JA4L.Button_secondaryLabelBtn__7mpYY .Button_buttonContent__3Yt2W {\n  flex: 1 0 auto;\n  text-align: left;\n}\n.Button_button__2JA4L.Button_secondaryLabelBtn__7mpYY .Button_secondaryLabel__H2ECu {\n  margin-left: 8px;\n  text-align: right;\n  align-items: center;\n  display: flex;\n}\n.Button_button__2JA4L.Button_secondaryLabelBtn__7mpYY .Button_secondaryLabel__H2ECu:before {\n  content: \"\";\n  width: 1px;\n  height: 24px;\n  border-right: 1px solid;\n  opacity: 0.24;\n  margin-right: 8px;\n}\n.Button_button__2JA4L:focus {\n  outline: 1px dashed;\n  outline-offset: 2px;\n}\n\n.Button_disabled__O-rJR {\n  border: none;\n  pointer-events: none;\n}\n\n.Button_fullWidth__TIq-7 {\n  width: 100%;\n}\n\n.Button_buttonContent__3Yt2W {\n  align-items: center;\n  display: flex;\n}\n\n.Button_isOpen__2UuQh {\n  transform: rotate(180deg);\n}\n\n.Button_loading__f5mmD .Button_buttonContent__3Yt2W {\n  opacity: 0;\n  visibility: hidden;\n}\n.Button_loading__f5mmD::after {\n  -webkit-animation: Button_rotation__-xnxX 0.75s infinite linear;\n  -o-animation: Button_rotation__-xnxX 0.75s infinite linear;\n  animation: Button_rotation__-xnxX 0.75s infinite linear;\n  border: 1px solid;\n  border-color: #142138 rgba(20, 33, 56, 0.25) rgba(20, 33, 56, 0.25);\n  border-radius: 50%;\n  bottom: 0;\n  content: \"\";\n  display: block;\n  height: 16px;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 16px;\n}\n\n.Button_large__C4VJi {\n  font: 500 16px/20px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  height: 56px;\n  padding: 18px 24px;\n}\n.Button_large__C4VJi .Button_iconDropdown__sauV3,\n.Button_large__C4VJi .Button_icon__OeKUC {\n  height: 24px;\n  width: 24px;\n}\n.Button_large__C4VJi.Button_loading__f5mmD::after {\n  height: 24px;\n  width: 24px;\n}\n\n.Button_small__FgTuP {\n  font: 500 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  height: 40px;\n  padding: 12px 16px;\n}\n.Button_small__FgTuP.Button_buttonIcon__qBAXq {\n  padding: 12px;\n}\n\n.Button_outline__nfBzi {\n  background-color: transparent;\n  border: 1px solid;\n  font: 400 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n.Button_link__6bUkH,\n.Button_linkSecondary__hKZlx {\n  background-color: transparent;\n  border-radius: 0;\n  font: 400 16px/20px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  height: inherit;\n  padding: 0;\n  text-decoration: underline;\n}\n.Button_link__6bUkH.Button_large__C4VJi,\n.Button_linkSecondary__hKZlx.Button_large__C4VJi {\n  font: 400 20px/24px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n.Button_link__6bUkH.Button_small__FgTuP,\n.Button_linkSecondary__hKZlx.Button_small__FgTuP {\n  font: 400 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n.Button_link__6bUkH.Button_xsmall__jyWC-,\n.Button_linkSecondary__hKZlx.Button_xsmall__jyWC- {\n  font: 400 12px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n.Button_caution__TH4qK {\n  background-color: transparent;\n  border: 1px solid;\n  font: 400 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n/*************************************************\n  NOTE: This section is for theme COLOR styles.\n  The format of these styles is:\n  variant\n    hover\n    focus\n    disabled\n    loading\n    inverse\n      hover\n      focus\n      disabled\n    themed\n      hover\n      focus\n      disabled\n*************************************************/\n/****************\n Fill\n****************/\n.Button_fill__KN42i {\n  background-color: #142138;\n  color: #fff;\n}\n.Button_fill__KN42i svg path {\n  fill: #fff;\n}\n.Button_fill__KN42i:hover {\n  background-color: #223ba8;\n}\n.Button_fill__KN42i:focus {\n  outline-color: #142138;\n}\n.Button_fill__KN42i.Button_disabled__O-rJR {\n  background-color: #dad8d2;\n  color: #6e6e6e;\n}\n.Button_fill__KN42i.Button_disabled__O-rJR svg path {\n  fill: #6e6e6e;\n}\n.Button_fill__KN42i.Button_loading__f5mmD::after {\n  border-color: #fff rgba(255, 255, 255, 0.25) rgba(255, 255, 255, 0.25);\n}\n.Button_fill__KN42i.Button_inverse__Yw-W4 {\n  background-color: #fff;\n  color: #142138;\n}\n.Button_fill__KN42i.Button_inverse__Yw-W4 svg path {\n  fill: #142138;\n}\n.Button_fill__KN42i.Button_inverse__Yw-W4:hover {\n  background-color: #223ba8;\n  color: #fff;\n}\n.Button_fill__KN42i.Button_inverse__Yw-W4:hover svg path {\n  fill: #fff;\n}\n.Button_fill__KN42i.Button_inverse__Yw-W4:focus {\n  outline-color: #fff;\n}\n.Button_fill__KN42i.Button_inverse__Yw-W4.Button_disabled__O-rJR {\n  background-color: #343e52;\n  color: #929bad;\n}\n.Button_fill__KN42i.Button_inverse__Yw-W4.Button_disabled__O-rJR svg path {\n  fill: #929bad;\n}\n.Button_fill__KN42i.Button_inverse__Yw-W4.Button_loading__f5mmD::after {\n  border-color: #142138 rgba(20, 33, 56, 0.25) rgba(20, 33, 56, 0.25);\n}\n.Button_fill__KN42i.Button_themed__9RYkI {\n  background-color: #13aa6d;\n  color: #fff;\n}\n.Button_fill__KN42i.Button_themed__9RYkI svg path {\n  fill: #fff;\n}\n.Button_fill__KN42i.Button_themed__9RYkI:hover {\n  background-color: #008854;\n}\n.Button_fill__KN42i.Button_themed__9RYkI.Button_disabled__O-rJR {\n  background-color: #dbdbdb;\n  color: #6e6e6e;\n}\n.Button_fill__KN42i.Button_themed__9RYkI.Button_disabled__O-rJR svg path {\n  fill: #6e6e6e;\n}\n.Button_fill__KN42i.Button_yelp__WGfie {\n  background-color: #cd2e20;\n  color: #fff;\n}\n.Button_fill__KN42i.Button_yelp__WGfie svg path {\n  fill: #fff;\n}\n.Button_fill__KN42i.Button_yelp__WGfie:hover {\n  background-color: #b91608;\n}\n.Button_fill__KN42i.Button_yelp__WGfie.Button_disabled__O-rJR {\n  background-color: #dbdbdb;\n  color: #6e6e6e;\n}\n.Button_fill__KN42i.Button_yelp__WGfie.Button_disabled__O-rJR svg path {\n  fill: #6e6e6e;\n}\n\n/****************\n Outline\n****************/\n.Button_outline__nfBzi {\n  border-color: #dad8d2;\n  color: #142138;\n}\n.Button_outline__nfBzi svg path {\n  fill: #142138;\n}\n.Button_outline__nfBzi:hover {\n  border-color: #142138;\n}\n.Button_outline__nfBzi:focus {\n  outline-color: #142138;\n}\n.Button_outline__nfBzi.Button_disabled__O-rJR {\n  background-color: #dad8d2;\n  color: #6e6e6e;\n}\n.Button_outline__nfBzi.Button_disabled__O-rJR svg path {\n  fill: #6e6e6e;\n}\n.Button_outline__nfBzi.Button_loading__f5mmD::after {\n  border-color: #142138 rgba(20, 33, 56, 0.25) rgba(20, 33, 56, 0.25);\n}\n.Button_outline__nfBzi.Button_inverse__Yw-W4 {\n  border-color: #929bad;\n  color: #fff;\n}\n.Button_outline__nfBzi.Button_inverse__Yw-W4 svg path {\n  fill: #fff;\n}\n.Button_outline__nfBzi.Button_inverse__Yw-W4:hover {\n  border-color: #fff;\n}\n.Button_outline__nfBzi.Button_inverse__Yw-W4:focus {\n  outline-color: #fff;\n}\n.Button_outline__nfBzi.Button_inverse__Yw-W4.Button_disabled__O-rJR {\n  border: none;\n  background-color: #343e52;\n  color: #929bad;\n}\n.Button_outline__nfBzi.Button_inverse__Yw-W4.Button_disabled__O-rJR svg path {\n  fill: #929bad;\n}\n.Button_outline__nfBzi.Button_inverse__Yw-W4.Button_loading__f5mmD::after {\n  border-color: #fff rgba(255, 255, 255, 0.25) rgba(255, 255, 255, 0.25);\n}\n.Button_outline__nfBzi.Button_themed__9RYkI {\n  border-color: #dbdbdb;\n  color: #1f1f1f;\n}\n.Button_outline__nfBzi.Button_themed__9RYkI svg path {\n  fill: #1f1f1f;\n}\n.Button_outline__nfBzi.Button_themed__9RYkI:hover {\n  border-color: #1f1f1f;\n}\n.Button_outline__nfBzi.Button_themed__9RYkI.Button_disabled__O-rJR {\n  background-color: #dbdbdb;\n  color: #6e6e6e;\n}\n.Button_outline__nfBzi.Button_themed__9RYkI.Button_disabled__O-rJR svg path {\n  fill: #6e6e6e;\n}\n\n/****************\n Link\n****************/\n.Button_link__6bUkH {\n  color: #142138;\n}\n.Button_link__6bUkH:hover {\n  color: #223ba8;\n}\n.Button_link__6bUkH:focus {\n  outline-color: #142138;\n}\n.Button_link__6bUkH.Button_disabled__O-rJR {\n  color: #b2afa4;\n}\n.Button_link__6bUkH.Button_inverse__Yw-W4 {\n  color: #fff;\n}\n.Button_link__6bUkH.Button_inverse__Yw-W4:hover {\n  color: #dadff7;\n}\n.Button_link__6bUkH.Button_inverse__Yw-W4:focus {\n  outline-color: #fff;\n}\n.Button_link__6bUkH.Button_inverse__Yw-W4.Button_disabled__O-rJR {\n  color: #929bad;\n}\n.Button_link__6bUkH.Button_themed__9RYkI {\n  color: #1f1f1f;\n}\n.Button_link__6bUkH.Button_themed__9RYkI:hover {\n  color: #008854;\n}\n.Button_link__6bUkH.Button_themed__9RYkI.Button_disabled__O-rJR {\n  color: #a3a3a3;\n}\n.Button_link__6bUkH.Button_yelp__WGfie {\n  color: #1f1f1f;\n}\n.Button_link__6bUkH.Button_yelp__WGfie:hover {\n  color: #b91608;\n}\n.Button_link__6bUkH.Button_yelp__WGfie.Button_disabled__O-rJR {\n  color: #a3a3a3;\n}\n\n/****************\n Link Secondary\n****************/\n.Button_linkSecondary__hKZlx {\n  color: #6e6e6e;\n}\n.Button_linkSecondary__hKZlx:hover {\n  color: #223ba8;\n}\n.Button_linkSecondary__hKZlx:focus {\n  outline-color: #142138;\n}\n.Button_linkSecondary__hKZlx.Button_disabled__O-rJR {\n  color: #b2afa4;\n}\n.Button_linkSecondary__hKZlx.Button_inverse__Yw-W4 {\n  color: #929bad;\n}\n.Button_linkSecondary__hKZlx.Button_inverse__Yw-W4:hover {\n  color: #dadff7;\n}\n.Button_linkSecondary__hKZlx.Button_inverse__Yw-W4:focus {\n  outline-color: #fff;\n}\n.Button_linkSecondary__hKZlx.Button_inverse__Yw-W4.Button_disabled__O-rJR {\n  color: #929bad;\n}\n.Button_linkSecondary__hKZlx.Button_themed__9RYkI {\n  color: #6e6e6e;\n}\n.Button_linkSecondary__hKZlx.Button_themed__9RYkI:hover {\n  color: #008854;\n}\n.Button_linkSecondary__hKZlx.Button_themed__9RYkI.Button_disabled__O-rJR {\n  color: #a3a3a3;\n}\n.Button_linkSecondary__hKZlx.Button_yelp__WGfie {\n  color: #6e6e6e;\n}\n.Button_linkSecondary__hKZlx.Button_yelp__WGfie:hover {\n  color: #b91608;\n}\n.Button_linkSecondary__hKZlx.Button_yelp__WGfie.Button_disabled__O-rJR {\n  color: #a3a3a3;\n}\n\n/****************\n Caution\n****************/\n.Button_caution__TH4qK {\n  border-color: #cc1b00;\n  color: #cc1b00;\n}\n.Button_caution__TH4qK svg path {\n  fill: #cc1b00;\n}\n.Button_caution__TH4qK:hover {\n  background-color: #fae9e6;\n}\n.Button_caution__TH4qK:focus {\n  outline-color: #142138;\n}\n.Button_caution__TH4qK.Button_disabled__O-rJR {\n  background-color: #dad8d2;\n  color: #6e6e6e;\n  border-color: #dad8d2;\n}\n.Button_caution__TH4qK.Button_disabled__O-rJR svg path {\n  fill: #6e6e6e;\n}\n.Button_caution__TH4qK.Button_loading__f5mmD::after {\n  border-color: #cc1b00 rgba(204, 27, 0, 0.25) rgba(204, 27, 0, 0.25);\n}\n.Button_caution__TH4qK.Button_inverse__Yw-W4 {\n  border-color: #f5563d;\n  color: #f5563d;\n}\n.Button_caution__TH4qK.Button_inverse__Yw-W4 svg path {\n  fill: #f5563d;\n}\n.Button_caution__TH4qK.Button_inverse__Yw-W4:hover {\n  border-color: #f5563d;\n}\n.Button_caution__TH4qK.Button_inverse__Yw-W4:focus {\n  outline-color: #f5563d;\n}\n.Button_caution__TH4qK.Button_inverse__Yw-W4.Button_disabled__O-rJR {\n  border: none;\n  background-color: #343e52;\n  border-color: #343e52;\n  color: #929bad;\n}\n.Button_caution__TH4qK.Button_inverse__Yw-W4.Button_disabled__O-rJR svg path {\n  fill: #929bad;\n}\n.Button_caution__TH4qK.Button_inverse__Yw-W4.Button_loading__f5mmD::after {\n  border-color: #f5563d rgba(245, 86, 61, 0.25) rgba(245, 86, 61, 0.25);\n}\n.Button_caution__TH4qK.Button_themed__9RYkI {\n  border-color: #cc1b00;\n  color: #cc1b00;\n}\n.Button_caution__TH4qK.Button_themed__9RYkI svg path {\n  fill: #cc1b00;\n}\n.Button_caution__TH4qK.Button_themed__9RYkI:hover {\n  border-color: #cc1b00;\n}\n.Button_caution__TH4qK.Button_themed__9RYkI.Button_disabled__O-rJR {\n  background-color: #dbdbdb;\n  border-color: #dbdbdb;\n  color: #6e6e6e;\n}\n.Button_caution__TH4qK.Button_themed__9RYkI.Button_disabled__O-rJR svg path {\n  fill: #6e6e6e;\n}\n.Button_caution__TH4qK.Button_themed__9RYkI.Button_focus__rShXa {\n  outline-color: #1f1f1f;\n}";
var styles$D = {"button":"Button_button__2JA4L","iconDropdown":"Button_iconDropdown__sauV3","icon":"Button_icon__OeKUC","buttonIcon":"Button_buttonIcon__qBAXq","secondaryLabelBtn":"Button_secondaryLabelBtn__7mpYY","buttonContent":"Button_buttonContent__3Yt2W","secondaryLabel":"Button_secondaryLabel__H2ECu","disabled":"Button_disabled__O-rJR","fullWidth":"Button_fullWidth__TIq-7","isOpen":"Button_isOpen__2UuQh","loading":"Button_loading__f5mmD","rotation":"Button_rotation__-xnxX","large":"Button_large__C4VJi","small":"Button_small__FgTuP","outline":"Button_outline__nfBzi","link":"Button_link__6bUkH","linkSecondary":"Button_linkSecondary__hKZlx","xsmall":"Button_xsmall__jyWC-","caution":"Button_caution__TH4qK","fill":"Button_fill__KN42i","inverse":"Button_inverse__Yw-W4","themed":"Button_themed__9RYkI","yelp":"Button_yelp__WGfie","focus":"Button_focus__rShXa"};
styleInject(css_248z$D);

var Button = forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.dataTestId, dataTestId = _d === void 0 ? 'button' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, Icon = _a.icon, _f = _a.isDropdown, isDropdown = _f === void 0 ? false : _f, _g = _a.isOpen, isOpen = _g === void 0 ? false : _g, _h = _a.isLoading, isLoading = _h === void 0 ? false : _h, _j = _a.isFullWidth, isFullWidth = _j === void 0 ? false : _j, _k = _a.isInverse, isInverse = _k === void 0 ? false : _k, label = _a.label, _l = _a.platform, platform = _l === void 0 ? 'brand' : _l, secondaryLabel = _a.secondaryLabel, _m = _a.size, size = _m === void 0 ? 'medium' : _m, _o = _a.type, type = _o === void 0 ? 'button' : _o, _p = _a.variant, variant = _p === void 0 ? 'fill' : _p, _q = _a.onClick, onClick = _q === void 0 ? function () { } : _q;
    var isButtonIcon = !!Icon && !label;
    var hasSecondaryLabel = !!secondaryLabel;
    var IconCarot = function () {
        var _a, _b;
        return size === 'large' ? (React__default.createElement(SvgIconCarot24, { className: classNames(styles$D.iconDropdown, (_a = {}, _a[styles$D.isOpen] = isOpen, _a)) })) : (React__default.createElement(SvgIconCarot16, { className: classNames(styles$D.iconDropdown, (_b = {}, _b[styles$D.isOpen] = isOpen, _b)) }));
    };
    return (React__default.createElement("button", { ref: ref, "aria-label": label, "data-testid": dataTestId, className: classNames(styles$D.button, className, styles$D[platform], styles$D[size], styles$D[variant], (_b = {},
            _b[styles$D.disabled] = disabled,
            _b[styles$D.inverse] = isInverse,
            _b[styles$D.loading] = isLoading,
            _b[styles$D.fullWidth] = isFullWidth,
            _b[styles$D.buttonIcon] = isButtonIcon,
            _b[styles$D.secondaryLabelBtn] = hasSecondaryLabel,
            _b)), disabled: disabled, onClick: onClick, type: type },
        React__default.createElement("span", { className: styles$D.buttonContent },
            Icon && React__default.createElement(Icon, { className: styles$D.icon }),
            label,
            isDropdown && React__default.createElement(IconCarot, null)),
        hasSecondaryLabel && React__default.createElement("span", { className: styles$D.secondaryLabel }, secondaryLabel)));
});

var variantBackgroundColors = {
    caution: "".concat(semanticColors.brand.surface.caution),
    neutral: "".concat(semanticColors.brand.surface.tertiary),
    success: "".concat(semanticColors.brand.surface.success)
};
var BannerContent = styled.span(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  margin: auto;\n\n  @media (max-width: ", ") {\n    display: block;\n  }\n"], ["\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  margin: auto;\n\n  @media (max-width: ", ") {\n    display: block;\n  }\n"])), grid.breakpoint.md);
var BannerMessage = styled.span(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  ", "\n\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: ", ";\n"], ["\n  ", "\n\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: ", ";\n"])), function (_a) {
    var shouldTruncate = _a.shouldTruncate;
    return "\n    ".concat(shouldTruncate ? "-webkit-line-clamp: 1" : '', ";\n  ");
}, semanticColors.brand.content.primary);
var BannerWrapper = styled.div(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  background-color: ", ";\n  box-sizing: border-box;\n  display: flex;\n  font: ", ";\n  padding: ", " ", ";\n  width: 100%;\n  min-width: 0;\n\n  @media (max-width: ", ") {\n    padding: ", ";\n  }\n"], ["\n  background-color: ", ";\n  box-sizing: border-box;\n  display: flex;\n  font: ", ";\n  padding: ", " ", ";\n  width: 100%;\n  min-width: 0;\n\n  @media (max-width: ", ") {\n    padding: ", ";\n  }\n"])), function (_a) {
    var variant = _a.variant;
    return variantBackgroundColors[variant];
}, paragraph.reg.x14, space.x2, space.x3, grid.breakpoint.md, space.x2);
var CloseButton = styled(Button)(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  margin: auto;\n  padding: 0 !important;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  @media (max-width: ", ") {\n    display: inline-block;\n  }\n"], ["\n  margin: auto;\n  padding: 0 !important;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  @media (max-width: ", ") {\n    display: inline-block;\n  }\n"])), grid.breakpoint.md);
var ViewMoreButton = styled(Button)(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  margin-right: ", ";\n\n  @media (max-width: ", ") {\n    margin-top: ", ";\n  }\n"], ["\n  margin-right: ", ";\n\n  @media (max-width: ", ") {\n    margin-top: ", ";\n  }\n"])), space.x1, grid.breakpoint.md, space.half);
var templateObject_1$3, templateObject_2$3, templateObject_3$2, templateObject_4$1, templateObject_5$1;

var css_248z$C = ".StatusDot_dotContainer__5YmbV {\n  display: inline-block;\n  height: 16px;\n  margin: auto;\n  margin-right: 8px;\n  width: 16px;\n}\n.StatusDot_dotContainer__5YmbV.StatusDot_small__8oc1Z {\n  padding: 4px;\n}\n\n.StatusDot_dot__7taPN {\n  align-items: center;\n  border-radius: 8px;\n  display: flex;\n  height: 8px;\n  justify-content: center;\n  min-width: 8px;\n  width: 8px;\n}\n\n.StatusDot_icon__1r-CU {\n  height: 8px;\n  width: 8px;\n}\n.StatusDot_icon__1r-CU path {\n  fill: #fff;\n}\n\n.StatusDot_neutral__E64fy {\n  background-color: #6e6e6e;\n}\n\n.StatusDot_success__0cLTz {\n  background-color: #0e7a4a;\n}\n\n.StatusDot_caution__wqT7T {\n  background-color: #cc1b00;\n}\n\n.StatusDot_active__3baRn {\n  background-color: #223ba8;\n}\n\n.StatusDot_themed__0QO6i.StatusDot_neutral__E64fy {\n  background-color: #6e6e6e;\n}\n.StatusDot_themed__0QO6i.StatusDot_success__0cLTz {\n  background-color: #0e7a4a;\n}\n.StatusDot_themed__0QO6i.StatusDot_caution__wqT7T {\n  background-color: #cc1b00;\n}\n.StatusDot_themed__0QO6i.StatusDot_active__3baRn {\n  background-color: #008854;\n}\n\n.StatusDot_small__8oc1Z {\n  height: 8px;\n  width: 8px;\n}\n\n.StatusDot_medium__6nzlU {\n  height: 16px;\n  width: 16px;\n}";
var styles$C = {"dotContainer":"StatusDot_dotContainer__5YmbV","small":"StatusDot_small__8oc1Z","dot":"StatusDot_dot__7taPN","icon":"StatusDot_icon__1r-CU","neutral":"StatusDot_neutral__E64fy","success":"StatusDot_success__0cLTz","caution":"StatusDot_caution__wqT7T","active":"StatusDot_active__3baRn","themed":"StatusDot_themed__0QO6i","medium":"StatusDot_medium__6nzlU"};
styleInject(css_248z$C);

var StatusDot = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.dataTestId, dataTestId = _c === void 0 ? 'status-dot' : _c, Icon = _a.icon, _d = _a.size, size = _d === void 0 ? 'small' : _d, _e = _a.variant, variant = _e === void 0 ? 'neutral' : _e, _f = _a.platform, platform = _f === void 0 ? 'brand' : _f;
    return (React__default.createElement("span", { className: classNames(styles$C.dotContainer, styles$C[size]) },
        React__default.createElement("span", { "data-testid": dataTestId, className: classNames(styles$C.dot, className, styles$C[variant], styles$C[size], styles$C[platform]) }, Icon && size === 'medium' && React__default.createElement(Icon, { className: styles$C.icon }))));
};

var Banner = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.dataTestId, dataTestId = _b === void 0 ? 'banner' : _b, onClose = _a.onClose, onViewMoreClick = _a.onViewMoreClick, shouldTruncate = _a.shouldTruncate, _c = _a.variant, variant = _c === void 0 ? 'neutral' : _c;
    return (React__default.createElement(BannerWrapper, { className: className, "data-testid": dataTestId, variant: variant },
        React__default.createElement(StatusDot, { variant: variant, size: "small" }),
        React__default.createElement(BannerContent, null,
            React__default.createElement(BannerMessage, { "data-testid": "".concat(dataTestId, "-message"), shouldTruncate: shouldTruncate }, children),
            onViewMoreClick && (React__default.createElement(ViewMoreButton, { dataTestId: "".concat(dataTestId, "-view-more"), label: "View More", variant: "link", size: "small", onClick: onViewMoreClick }))),
        onClose && (React__default.createElement(CloseButton, { dataTestId: "".concat(dataTestId, "-close"), size: "xsmall", variant: "link", icon: SvgIconClose16, onClick: onClose }))));
};

var css_248z$B = ".ButtonSet_buttonSet__-7BWC {\n  border-radius: 8px;\n  border: solid #dad8d2 1px;\n  display: inline-flex;\n}\n.ButtonSet_buttonSet__-7BWC.ButtonSet_themed__k1RK6 {\n  border-color: #dad8d2;\n}\n\n.ButtonSet_button__09q2f {\n  border-bottom: none;\n  border-left: none;\n  border-radius: 0;\n  border-right-style: solid;\n  border-right-width: 1px;\n  border-top: none;\n  display: inline-block;\n  padding-left: 16px;\n  padding-right: 16px;\n}\n.ButtonSet_button__09q2f:last-child {\n  border-right: none;\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n.ButtonSet_button__09q2f:focus {\n  outline-offset: -14px;\n}\n\n.ButtonSet_buttonColors__-c7F7 {\n  border-color: #dad8d2;\n}\n.ButtonSet_buttonColors__-c7F7:disabled {\n  background-color: #f5f4f1;\n}\n.ButtonSet_buttonColors__-c7F7:hover, .ButtonSet_buttonColors__-c7F7:active {\n  border-right: solid #dad8d2 1px;\n  color: #223ba8;\n}\n.ButtonSet_buttonColors__-c7F7:hover svg path, .ButtonSet_buttonColors__-c7F7:active svg path {\n  fill: #223ba8;\n}\n.ButtonSet_buttonColors__-c7F7.ButtonSet_themed__k1RK6 {\n  border-color: #dbdbdb;\n}\n.ButtonSet_buttonColors__-c7F7.ButtonSet_themed__k1RK6:disabled {\n  background-color: #f2f2f2;\n}\n.ButtonSet_buttonColors__-c7F7.ButtonSet_themed__k1RK6:hover, .ButtonSet_buttonColors__-c7F7.ButtonSet_themed__k1RK6:active {\n  border-right: solid #dbdbdb 1px;\n  color: #008854;\n}\n.ButtonSet_buttonColors__-c7F7.ButtonSet_themed__k1RK6:hover svg path, .ButtonSet_buttonColors__-c7F7.ButtonSet_themed__k1RK6:active svg path {\n  fill: #008854;\n}";
var styles$B = {"buttonSet":"ButtonSet_buttonSet__-7BWC","themed":"ButtonSet_themed__k1RK6","button":"ButtonSet_button__09q2f","buttonColors":"ButtonSet_buttonColors__-c7F7"};
styleInject(css_248z$B);

var ButtonSet = function (_a) {
    var _b;
    var children = _a.children, _c = _a.isInverse, isInverse = _c === void 0 ? false : _c, _d = _a.platform, platform = _d === void 0 ? 'brand' : _d, _e = _a.size, size = _e === void 0 ? 'medium' : _e;
    return (React__default.createElement("div", { className: classNames(styles$B.buttonSet, styles$B[platform], (_b = {},
            _b[styles$B.inverse] = isInverse,
            _b)) }, React__default.Children.map(children, function (child) {
        var _a;
        return React__default.cloneElement(child, {
            className: classNames(styles$B.button, (_a = {},
                _a[styles$B.buttonColors] = !isInverse,
                _a[styles$B[platform]] = !isInverse,
                _a)),
            isInverse: isInverse,
            platform: platform,
            size: size,
            variant: 'outline'
        });
    })));
};

var _path$o;
function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
function SvgIconChevronSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$s({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$o || (_path$o = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.87 10.836a.5.5 0 01-.706.034L8 6.176 2.836 10.87a.5.5 0 01-.672-.74l5.5-5a.5.5 0 01.672 0l5.5 5a.5.5 0 01.034.706z",
    fill: "#142138"
  })));
}

var css_248z$A = ".CardInfo_container__dFcM0 {\n  background-color: #fff;\n  border: 1px solid #dad8d2;\n  border-radius: 16px;\n  color: #142138;\n  font: 400 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-family: \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  height: fit-content;\n  line-height: 1.15;\n  width: 100%;\n}\n\n.CardInfo_title__1SO-f {\n  font: 600 16px/20px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  letter-spacing: 0.2px;\n  padding: 24px;\n  position: relative;\n  text-transform: capitalize;\n}\n\n.CardInfo_downArrow__oVhZP {\n  cursor: pointer;\n  height: 16px;\n  margin-top: 2px;\n  padding: 16px;\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  transition: transform 0.3s;\n  width: 16px;\n}\n.CardInfo_downArrow__oVhZP.CardInfo_active__8-uJw {\n  transform: rotate(180deg);\n}\n\n.CardInfo_divider__YGCSW {\n  background-color: #dad8d2;\n  height: 1px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.CardInfo_childrenWrap__Ulcot {\n  padding: 24px;\n  position: relative;\n}\n\n.CardInfo_expandWrap__erPJD {\n  transition: height 0.3s, opacity 0.2s;\n}";
var styles$A = {"container":"CardInfo_container__dFcM0","title":"CardInfo_title__1SO-f","downArrow":"CardInfo_downArrow__oVhZP","active":"CardInfo_active__8-uJw","divider":"CardInfo_divider__YGCSW","childrenWrap":"CardInfo_childrenWrap__Ulcot","expandWrap":"CardInfo_expandWrap__erPJD"};
styleInject(css_248z$A);

var CardInfo = function (_a) {
    var _b;
    var children = _a.children, title = _a.title, className = _a.className;
    var childrenRef = useRef(null);
    var _c = useState(0), initialHeight = _c[0], setInitialHeight = _c[1];
    var _d = useState(0), height = _d[0], setHeight = _d[1];
    var isCollapsed = height === 0;
    function handleResize() {
        var _a;
        var elemHeight = ((_a = childrenRef === null || childrenRef === void 0 ? void 0 : childrenRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
        setInitialHeight(elemHeight);
        setHeight(elemHeight);
    }
    useEffect(function () {
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    useEffect(function () {
        handleResize();
    }, [children]);
    function handleOnClick() {
        setHeight(height ? 0 : initialHeight);
    }
    return (React__default.createElement("div", { className: classNames(styles$A.container, className) },
        React__default.createElement("div", { className: styles$A.title },
            title,
            React__default.createElement(SvgIconChevronSmall, { className: classNames(styles$A.downArrow, (_b = {},
                    _b[styles$A.active] = isCollapsed,
                    _b)), onClick: handleOnClick, "data-testid": "expand" })),
        React__default.createElement("div", { className: styles$A.expandWrap, style: {
                height: height,
                opacity: isCollapsed ? 0 : 1
            } },
            React__default.createElement("div", { className: styles$A.childrenWrap, ref: childrenRef },
                React__default.createElement("div", { className: styles$A.divider }),
                children))));
};

var css_248z$z = "@-webkit-keyframes Checkbox_rotation__j50o2 {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes Checkbox_rotation__j50o2 {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n.Checkbox_checkboxWrapper__64tjQ {\n  width: 24px;\n  height: 24px;\n  position: relative;\n}\n.Checkbox_checkboxWrapper__64tjQ .Checkbox_checkboxVisible__UqjUe {\n  border: 1px solid #dad8d2;\n  width: 20px;\n  height: 20px;\n  margin: 2px;\n  background-color: #fff;\n  border-radius: 4px;\n  position: absolute;\n}\n.Checkbox_checkboxWrapper__64tjQ .Checkbox_iconCheckmark__v5oqC {\n  display: none;\n  margin-left: 2px;\n  margin-top: 2px;\n}\n.Checkbox_checkboxWrapper__64tjQ input {\n  z-index: 1;\n  left: 50%;\n  opacity: 0;\n  top: 50%;\n  transform: translatex(-50%) translatey(-50%);\n  display: block;\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  position: absolute;\n}\n.Checkbox_checkboxWrapper__64tjQ input:checked + .Checkbox_checkboxVisible__UqjUe {\n  background-color: #142138;\n  border-color: #142138;\n  background-position: center;\n}\n.Checkbox_checkboxWrapper__64tjQ input:checked + .Checkbox_checkboxVisible__UqjUe .Checkbox_iconCheckmark__v5oqC {\n  display: block;\n}\n.Checkbox_checkboxWrapper__64tjQ input:hover + .Checkbox_checkboxVisible__UqjUe {\n  border-color: #223ba8;\n}\n.Checkbox_checkboxWrapper__64tjQ input:hover:checked + .Checkbox_checkboxVisible__UqjUe {\n  border-color: #223ba8;\n  background-color: #223ba8;\n}\n.Checkbox_checkboxWrapper__64tjQ input:focus + .Checkbox_checkboxVisible__UqjUe {\n  outline: 1px dashed;\n  outline-offset: 2px;\n  outline-color: #142138;\n}\n.Checkbox_checkboxWrapper__64tjQ input:disabled {\n  cursor: default;\n}\n.Checkbox_checkboxWrapper__64tjQ input:disabled + .Checkbox_checkboxVisible__UqjUe, .Checkbox_checkboxWrapper__64tjQ input:disabled:hover + .Checkbox_checkboxVisible__UqjUe {\n  background-color: #f5f4f1;\n  border-color: #dad8d2;\n}\n.Checkbox_checkboxWrapper__64tjQ input:disabled:checked + .Checkbox_checkboxVisible__UqjUe, .Checkbox_checkboxWrapper__64tjQ input:disabled:checked:hover + .Checkbox_checkboxVisible__UqjUe, .Checkbox_checkboxWrapper__64tjQ input:disabled:hover:checked + .Checkbox_checkboxVisible__UqjUe, .Checkbox_checkboxWrapper__64tjQ input:disabled:hover:checked:hover + .Checkbox_checkboxVisible__UqjUe {\n  background-color: #dad8d2;\n  border-color: #dad8d2;\n}\n.Checkbox_checkboxWrapper__64tjQ input.Checkbox_themed__ZjR6S + .Checkbox_checkboxVisible__UqjUe {\n  border-color: #dbdbdb;\n}\n.Checkbox_checkboxWrapper__64tjQ input.Checkbox_themed__ZjR6S:checked + .Checkbox_checkboxVisible__UqjUe {\n  background-color: #13aa6d;\n  border-color: #13aa6d;\n}\n.Checkbox_checkboxWrapper__64tjQ input.Checkbox_themed__ZjR6S:hover + .Checkbox_checkboxVisible__UqjUe {\n  border-color: #008854;\n}\n.Checkbox_checkboxWrapper__64tjQ input.Checkbox_themed__ZjR6S:hover:checked + .Checkbox_checkboxVisible__UqjUe {\n  border-color: #008854;\n  background-color: #008854;\n}\n.Checkbox_checkboxWrapper__64tjQ input.Checkbox_themed__ZjR6S:focus + .Checkbox_checkboxVisible__UqjUe {\n  outline-color: #1f1f1f;\n}\n.Checkbox_checkboxWrapper__64tjQ input.Checkbox_themed__ZjR6S:disabled {\n  cursor: default;\n}\n.Checkbox_checkboxWrapper__64tjQ input.Checkbox_themed__ZjR6S:disabled + .Checkbox_checkboxVisible__UqjUe, .Checkbox_checkboxWrapper__64tjQ input.Checkbox_themed__ZjR6S:disabled:hover + .Checkbox_checkboxVisible__UqjUe {\n  background-color: #f2f2f2;\n  border-color: #dbdbdb;\n}\n.Checkbox_checkboxWrapper__64tjQ input.Checkbox_themed__ZjR6S:disabled:checked + .Checkbox_checkboxVisible__UqjUe, .Checkbox_checkboxWrapper__64tjQ input.Checkbox_themed__ZjR6S:disabled:hover:checked + .Checkbox_checkboxVisible__UqjUe, .Checkbox_checkboxWrapper__64tjQ input.Checkbox_themed__ZjR6S:disabled:hover:checked + .Checkbox_checkboxVisible__UqjUe, .Checkbox_checkboxWrapper__64tjQ input.Checkbox_themed__ZjR6S:disabled:hover:hover:checked + .Checkbox_checkboxVisible__UqjUe {\n  background-color: #dbdbdb;\n  border-color: #dbdbdb;\n}";
var styles$z = {"checkboxWrapper":"Checkbox_checkboxWrapper__64tjQ","checkboxVisible":"Checkbox_checkboxVisible__UqjUe","iconCheckmark":"Checkbox_iconCheckmark__v5oqC","themed":"Checkbox_themed__ZjR6S","rotation":"Checkbox_rotation__j50o2"};
styleInject(css_248z$z);

var Checkbox = function (_a) {
    var _b;
    var _c = _a.checked, checked = _c === void 0 ? false : _c, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.dataTestId, dataTestId = _e === void 0 ? '' : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, id = _a.id, name = _a.name, _g = _a.onChange, onChange = _g === void 0 ? function () { } : _g, _h = _a.platform, platform = _h === void 0 ? 'brand' : _h, _j = _a.value, value = _j === void 0 ? '' : _j;
    var _k = useState(checked), isChecked = _k[0], setIsChecked = _k[1];
    useEffect(function () {
        setIsChecked(checked);
    }, [checked]);
    var handleOnChange = function (event) {
        setIsChecked(!isChecked);
        onChange(event);
    };
    return (React__default.createElement("div", { className: styles$z.checkboxWrapper },
        React__default.createElement("input", { checked: isChecked, className: classNames(styles$z.checkbox, className, styles$z[platform], (_b = {},
                _b[styles$z.disabled] = disabled,
                _b)), "data-testid": dataTestId, disabled: disabled, id: id, name: name, onChange: handleOnChange, type: "checkbox", value: value }),
        React__default.createElement("div", { className: styles$z.checkboxVisible },
            React__default.createElement("svg", { className: styles$z.iconCheckmark, width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.3536 3.64645C14.5488 3.84171 14.5488 4.15829 14.3536 4.35355L6.35355 12.3536C6.15829 12.5488 5.84171 12.5488 5.64645 12.3536L1.64645 8.35355C1.45118 8.15829 1.45118 7.84171 1.64645 7.64645C1.84171 7.45118 2.15829 7.45118 2.35355 7.64645L6 11.2929L13.6464 3.64645C13.8417 3.45118 14.1583 3.45118 14.3536 3.64645Z", fill: "white" })))));
};

var css_248z$y = ".DashboardGrid_dashboardGrid__Zov4v {\n  column-gap: 16px;\n  display: grid;\n  grid-template-columns: repeat(4, [col-start] 1fr);\n  justify-content: center;\n  margin: 0 auto;\n}\n@media screen and (min-width: 768px) {\n  .DashboardGrid_dashboardGrid__Zov4v {\n    column-gap: 24px;\n    grid-template-columns: repeat(12, [col-start] 36px);\n  }\n}\n@media screen and (min-width: 1200px) {\n  .DashboardGrid_dashboardGrid__Zov4v {\n    grid-template-columns: repeat(12, [col-start] 56px);\n  }\n}";
var styles$y = {"dashboardGrid":"DashboardGrid_dashboardGrid__Zov4v"};
styleInject(css_248z$y);

var DashboardGrid = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b;
    return (React__default.createElement("div", { className: classNames(styles$y.dashboardGrid, className) }, children));
};

var css_248z$x = ".Grid_grid__tDvDD {\n  display: grid;\n  grid-template-columns: repeat(4, [col-start] 1fr);\n  gap: 16px;\n  margin: 0 16px;\n}\n@media screen and (min-width: 768px) {\n  .Grid_grid__tDvDD {\n    grid-template-columns: repeat(12, [col-start] 1fr);\n    gap: 32px;\n    margin: 0 32px;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .Grid_grid__tDvDD {\n    gap: 56px;\n    margin: 0 56px;\n  }\n}\n@media screen and (min-width: 1440px) {\n  .Grid_grid__tDvDD {\n    margin: 0 auto;\n    max-width: 1328px;\n  }\n}\n\n.Grid_gridItem__3fi-D.Grid_sm-1__G3aeS {\n  grid-column-end: span 1;\n}\n.Grid_gridItem__3fi-D.Grid_sm-offset-1__m7sQk {\n  grid-column-start: col-start 1;\n}\n.Grid_gridItem__3fi-D.Grid_sm-2__Kkm6D {\n  grid-column-end: span 2;\n}\n.Grid_gridItem__3fi-D.Grid_sm-offset-2__TFaT7 {\n  grid-column-start: col-start 2;\n}\n.Grid_gridItem__3fi-D.Grid_sm-3__VGk7p {\n  grid-column-end: span 3;\n}\n.Grid_gridItem__3fi-D.Grid_sm-offset-3__yfNCB {\n  grid-column-start: col-start 3;\n}\n.Grid_gridItem__3fi-D.Grid_sm-4__QQBXS {\n  grid-column-end: span 4;\n}\n.Grid_gridItem__3fi-D.Grid_sm-offset-4__DmdUD {\n  grid-column-start: col-start 4;\n}\n@media screen and (min-width: 768px) {\n  .Grid_gridItem__3fi-D.Grid_md-1__Ltenn {\n    grid-column-end: span 1;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-offset-1__gZ-mU {\n    grid-column-start: col-start 1;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-2__2z-9C {\n    grid-column-end: span 2;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-offset-2__cECz- {\n    grid-column-start: col-start 2;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-3__9DiB4 {\n    grid-column-end: span 3;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-offset-3__szwK5 {\n    grid-column-start: col-start 3;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-4__znUhZ {\n    grid-column-end: span 4;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-offset-4__pA6-r {\n    grid-column-start: col-start 4;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-5__qjhp8 {\n    grid-column-end: span 5;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-offset-5__m1yIx {\n    grid-column-start: col-start 5;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-6__40Z0I {\n    grid-column-end: span 6;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-offset-6__7R5SF {\n    grid-column-start: col-start 6;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-7__JdRHE {\n    grid-column-end: span 7;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-offset-7__WOV-J {\n    grid-column-start: col-start 7;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-8__d-S-v {\n    grid-column-end: span 8;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-offset-8__FQnQP {\n    grid-column-start: col-start 8;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-9__nRLeb {\n    grid-column-end: span 9;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-offset-9__-FIbh {\n    grid-column-start: col-start 9;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-10__O1Yzl {\n    grid-column-end: span 10;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-offset-10__Iz7CQ {\n    grid-column-start: col-start 10;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-11__vEHnk {\n    grid-column-end: span 11;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-offset-11__4uahS {\n    grid-column-start: col-start 11;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-12__lpYz3 {\n    grid-column-end: span 12;\n  }\n  .Grid_gridItem__3fi-D.Grid_md-offset-12__ubs-r {\n    grid-column-start: col-start 12;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .Grid_gridItem__3fi-D.Grid_lg-1__-uzF9 {\n    grid-column-end: span 1;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-offset-1__blK25 {\n    grid-column-start: col-start 1;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-2__Iyt3t {\n    grid-column-end: span 2;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-offset-2__5amO4 {\n    grid-column-start: col-start 2;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-3__Ylqy6 {\n    grid-column-end: span 3;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-offset-3__tg5HQ {\n    grid-column-start: col-start 3;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-4__rg-a4 {\n    grid-column-end: span 4;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-offset-4__ZQnjY {\n    grid-column-start: col-start 4;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-5__ZQ1bu {\n    grid-column-end: span 5;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-offset-5__iQDBp {\n    grid-column-start: col-start 5;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-6__tFQsP {\n    grid-column-end: span 6;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-offset-6__CRaNe {\n    grid-column-start: col-start 6;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-7__cN7rr {\n    grid-column-end: span 7;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-offset-7__Lmfv6 {\n    grid-column-start: col-start 7;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-8__9xafX {\n    grid-column-end: span 8;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-offset-8__isLQd {\n    grid-column-start: col-start 8;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-9__ePHl- {\n    grid-column-end: span 9;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-offset-9__q5oCz {\n    grid-column-start: col-start 9;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-10__3XEPf {\n    grid-column-end: span 10;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-offset-10__k1pAv {\n    grid-column-start: col-start 10;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-11__Y7Vim {\n    grid-column-end: span 11;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-offset-11__0qtTB {\n    grid-column-start: col-start 11;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-12__nk5S9 {\n    grid-column-end: span 12;\n  }\n  .Grid_gridItem__3fi-D.Grid_lg-offset-12__aV6eg {\n    grid-column-start: col-start 12;\n  }\n}";
var styles$x = {"grid":"Grid_grid__tDvDD","gridItem":"Grid_gridItem__3fi-D","sm-1":"Grid_sm-1__G3aeS","sm-offset-1":"Grid_sm-offset-1__m7sQk","sm-2":"Grid_sm-2__Kkm6D","sm-offset-2":"Grid_sm-offset-2__TFaT7","sm-3":"Grid_sm-3__VGk7p","sm-offset-3":"Grid_sm-offset-3__yfNCB","sm-4":"Grid_sm-4__QQBXS","sm-offset-4":"Grid_sm-offset-4__DmdUD","md-1":"Grid_md-1__Ltenn","md-offset-1":"Grid_md-offset-1__gZ-mU","md-2":"Grid_md-2__2z-9C","md-offset-2":"Grid_md-offset-2__cECz-","md-3":"Grid_md-3__9DiB4","md-offset-3":"Grid_md-offset-3__szwK5","md-4":"Grid_md-4__znUhZ","md-offset-4":"Grid_md-offset-4__pA6-r","md-5":"Grid_md-5__qjhp8","md-offset-5":"Grid_md-offset-5__m1yIx","md-6":"Grid_md-6__40Z0I","md-offset-6":"Grid_md-offset-6__7R5SF","md-7":"Grid_md-7__JdRHE","md-offset-7":"Grid_md-offset-7__WOV-J","md-8":"Grid_md-8__d-S-v","md-offset-8":"Grid_md-offset-8__FQnQP","md-9":"Grid_md-9__nRLeb","md-offset-9":"Grid_md-offset-9__-FIbh","md-10":"Grid_md-10__O1Yzl","md-offset-10":"Grid_md-offset-10__Iz7CQ","md-11":"Grid_md-11__vEHnk","md-offset-11":"Grid_md-offset-11__4uahS","md-12":"Grid_md-12__lpYz3","md-offset-12":"Grid_md-offset-12__ubs-r","lg-1":"Grid_lg-1__-uzF9","lg-offset-1":"Grid_lg-offset-1__blK25","lg-2":"Grid_lg-2__Iyt3t","lg-offset-2":"Grid_lg-offset-2__5amO4","lg-3":"Grid_lg-3__Ylqy6","lg-offset-3":"Grid_lg-offset-3__tg5HQ","lg-4":"Grid_lg-4__rg-a4","lg-offset-4":"Grid_lg-offset-4__ZQnjY","lg-5":"Grid_lg-5__ZQ1bu","lg-offset-5":"Grid_lg-offset-5__iQDBp","lg-6":"Grid_lg-6__tFQsP","lg-offset-6":"Grid_lg-offset-6__CRaNe","lg-7":"Grid_lg-7__cN7rr","lg-offset-7":"Grid_lg-offset-7__Lmfv6","lg-8":"Grid_lg-8__9xafX","lg-offset-8":"Grid_lg-offset-8__isLQd","lg-9":"Grid_lg-9__ePHl-","lg-offset-9":"Grid_lg-offset-9__q5oCz","lg-10":"Grid_lg-10__3XEPf","lg-offset-10":"Grid_lg-offset-10__k1pAv","lg-11":"Grid_lg-11__Y7Vim","lg-offset-11":"Grid_lg-offset-11__0qtTB","lg-12":"Grid_lg-12__nk5S9","lg-offset-12":"Grid_lg-offset-12__aV6eg"};
styleInject(css_248z$x);

// Generated with util/create-component.js
function Grid(_a) {
    var _b;
    var children = _a.children, _c = _a.className, className = _c === void 0 ? '' : _c, container = _a.container, _d = _a.sm, sm = _d === void 0 ? 4 : _d, md = _a.md, lg = _a.lg, smOffset = _a.smOffset, mdOffset = _a.mdOffset, lgOffset = _a.lgOffset;
    var gridItem = !container;
    return (React__default.createElement("div", { className: classNames(className, (_b = {},
            _b[styles$x.grid] = container,
            _b[styles$x.gridItem] = gridItem,
            _b[styles$x["sm-".concat(sm)]] = sm,
            _b[styles$x["md-".concat(md)]] = md,
            _b[styles$x["lg-".concat(lg)]] = lg,
            _b[styles$x["sm-offset-".concat(smOffset)]] = smOffset,
            _b[styles$x["md-offset-".concat(mdOffset)]] = mdOffset,
            _b[styles$x["lg-offset-".concat(lgOffset)]] = lgOffset,
            _b)) }, children));
}

var CoverWrap = styled.header(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  background: ", ";\n  width: 100%;\n"], ["\n  background: ", ";\n  width: 100%;\n"])), semanticColors.brand.surface.secondary);
var CoverContent = styled.div(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  margin: 0 auto;\n  padding: ", " ", ";\n  position: relative;\n  z-index: 1;\n\n  @media (min-width: ", ") {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  @media (min-width: ", ") {\n    display: flex;\n    justify-content: space-between;\n  }\n"], ["\n  margin: 0 auto;\n  padding: ", " ", ";\n  position: relative;\n  z-index: 1;\n\n  @media (min-width: ", ") {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  @media (min-width: ", ") {\n    display: flex;\n    justify-content: space-between;\n  }\n"])), space.x5, space.x2, grid.breakpoint.md, grid.breakpoint.lg);
var BackUrl = styled.div(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  margin-bottom: ", ";\n\n  a {\n    color: inherit;\n    font-size: 12px;\n  }\n"], ["\n  margin-bottom: ", ";\n\n  a {\n    color: inherit;\n    font-size: 12px;\n  }\n"])), space.x2);
var Title = styled.h1(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  font: ", ";\n  letter-spacing: ", ";\n  margin: 0 0 ", " 0;\n\n  @media (min-width: ", ") {\n    font: ", ";\n    letter-spacing: ", ";\n  }\n"], ["\n  color: ", ";\n  font: ", ";\n  letter-spacing: ", ";\n  margin: 0 0 ", " 0;\n\n  @media (min-width: ", ") {\n    font: ", ";\n    letter-spacing: ", ";\n  }\n"])), semanticColors.brand.content.primary, headline.md.x24, letterSpacing.headline.x24, space.x2, grid.breakpoint.lg, headline.md.x32, letterSpacing.headline.x32);
var Body = styled.p(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n  font: ", ";\n  margin: 0 0 ", " 0;\n  max-width: 100%;\n\n  @media (min-width: ", ") {\n    margin: 0;\n    max-width: 580px;\n  }\n"], ["\n  color: ", ";\n  font: ", ";\n  margin: 0 0 ", " 0;\n  max-width: 100%;\n\n  @media (min-width: ", ") {\n    margin: 0;\n    max-width: 580px;\n  }\n"])), semanticColors.brand.content.primary, paragraph.reg.x14, space.x3, grid.breakpoint.lg);
var CtaButtons = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n\n  @media (min-width: ", ") {\n    display: flex;\n    flex-direction: row-reverse;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n\n  @media (min-width: ", ") {\n    display: flex;\n    flex-direction: row-reverse;\n  }\n"])), grid.breakpoint.lg);
var NestedButton = function (_a) {
    var children = _a.children, className = _a.className;
    return React__default.cloneElement(children, {
        className: className
    });
};
var SecondaryButton = styled(NestedButton)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin-left: ", ";\n\n  @media (min-width: ", ") {\n    margin-right: ", ";\n    margin-left: 0;\n  }\n"], ["\n  margin-left: ", ";\n\n  @media (min-width: ", ") {\n    margin-right: ", ";\n    margin-left: 0;\n  }\n"])), space.x1, grid.breakpoint.lg, space.x1);
var templateObject_1$2, templateObject_2$2, templateObject_3$1, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

var Cover = function (_a) {
    var _b = _a.backLinkUrl, backLinkUrl = _b === void 0 ? undefined : _b, _c = _a.body, body = _c === void 0 ? undefined : _c, _d = _a.ctaElement, ctaElement = _d === void 0 ? undefined : _d, _e = _a.secondaryCtaElement, secondaryCtaElement = _e === void 0 ? undefined : _e, title = _a.title;
    return (React__default.createElement(CoverWrap, null,
        React__default.createElement(DashboardGrid, null,
            React__default.createElement(Grid, { sm: 4, md: 12 },
                React__default.createElement(CoverContent, null,
                    React__default.createElement("div", null,
                        backLinkUrl && (React__default.createElement(BackUrl, null,
                            React__default.createElement(Link, { to: backLinkUrl },
                                React__default.createElement(Button, { label: "Back", variant: "link", size: "xsmall" })))),
                        React__default.createElement(Title, null, title),
                        body && React__default.createElement(Body, null, body)),
                    (ctaElement || secondaryCtaElement) && (React__default.createElement(CtaButtons, null,
                        ctaElement,
                        secondaryCtaElement ? (React__default.createElement(SecondaryButton, null, secondaryCtaElement)) : null)))))));
};

var css_248z$w = ".DropdownButton_dropdownbutton__sR7Mw {\n  color: #142138;\n  position: relative;\n  width: max-content;\n}\n\n.DropdownButton_menu__An5Ud {\n  z-index: 1;\n  display: inline-block;\n  background-color: #fff;\n  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);\n  border-radius: 8px;\n  width: max-content;\n  position: absolute;\n  top: 32px;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n.DropdownButton_menu__An5Ud.DropdownButton_right__169wF {\n  right: 0;\n}\n\n.DropdownButton_small__rmLKd.DropdownButton_menu__An5Ud {\n  top: 48px;\n}\n\n.DropdownButton_medium__A-u30.DropdownButton_menu__An5Ud {\n  top: 56px;\n}\n\n.DropdownButton_large__9GsWO.DropdownButton_menu__An5Ud {\n  top: 64px;\n}";
var styles$w = {"dropdownbutton":"DropdownButton_dropdownbutton__sR7Mw","menu":"DropdownButton_menu__An5Ud","right":"DropdownButton_right__169wF","small":"DropdownButton_small__rmLKd","medium":"DropdownButton_medium__A-u30","large":"DropdownButton_large__9GsWO"};
styleInject(css_248z$w);

var DropdownButton = function (_a) {
    var _b;
    var _c = _a.alignMenu, alignMenu = _c === void 0 ? 'left' : _c, _d = _a.size, size = _d === void 0 ? 'large' : _d, children = _a.children, buttonProps = __rest(_a, ["alignMenu", "size", "children"]);
    var _e = useState(false), isOpen = _e[0], setIsOpen = _e[1];
    var dropdownRef = useRef(null);
    var buttonRef = useRef(null);
    var shouldFocusButton = useRef(false);
    var handleToggleDropdown = function () {
        setIsOpen(!isOpen);
        shouldFocusButton.current = !isOpen; // Set shouldFocusButton to true only when closing the dropdown
    };
    var handleClickOutside = function (event) {
        var target = event.target;
        if (dropdownRef.current &&
            'contains' in dropdownRef.current &&
            !dropdownRef.current.contains(target) &&
            target !== buttonRef.current) {
            setIsOpen(false);
        }
    };
    useEffect(function () {
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(function () {
        // Shift focus back to button when dropdown is closed, but not on initial render
        if (!isOpen && buttonRef.current && shouldFocusButton.current) {
            buttonRef.current.focus();
            shouldFocusButton.current = false; // Reset shouldFocusButton
        }
    }, [isOpen]);
    return (React__default.createElement("div", { ref: dropdownRef, className: styles$w.dropdownbutton },
        React__default.createElement(Button, __assign({ isDropdown: true, size: size }, buttonProps, { onClick: handleToggleDropdown, isOpen: isOpen, ref: buttonRef })),
        isOpen && (React__default.createElement("ul", { className: classNames(styles$w.menu, styles$w[size], (_b = {},
                _b[styles$w.right] = alignMenu === 'right',
                _b)), onClick: function () { return setIsOpen(false); } }, children))));
};

var css_248z$v = ".DropdownButtonItem_dropdownButtonItem__d32WE {\n  cursor: pointer;\n  padding: 16px;\n}\n\n.DropdownButtonItem_button__g8bqK {\n  text-decoration: none;\n}\n.DropdownButtonItem_button__g8bqK:hover {\n  color: #6e6e6e;\n  background: none;\n}";
var styles$v = {"dropdownButtonItem":"DropdownButtonItem_dropdownButtonItem__d32WE","button":"DropdownButtonItem_button__g8bqK"};
styleInject(css_248z$v);

var DropdownButtonItem = function (_a) {
    var children = _a.children, onClick = _a.onClick;
    return (React__default.createElement("li", { role: "listitem", className: styles$v.dropdownButtonItem },
        React__default.createElement(Button, { className: styles$v.button, label: children, onClick: onClick, variant: "link" })));
};

var css_248z$u = "@-webkit-keyframes Radio_rotation__evVc- {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes Radio_rotation__evVc- {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n.Radio_radioWrapper__xuf-v {\n  width: 24px;\n  height: 24px;\n  position: relative;\n}\n.Radio_radioWrapper__xuf-v .Radio_radioVisible__GA1Il {\n  border: 1px solid #dad8d2;\n  width: 20px;\n  height: 20px;\n  margin: 2px;\n  background-color: #fff;\n  border-radius: 100%;\n  position: absolute;\n}\n.Radio_radioWrapper__xuf-v input {\n  z-index: 1;\n  left: 50%;\n  opacity: 0;\n  top: 50%;\n  transform: translatex(-50%) translatey(-50%);\n  display: block;\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  position: absolute;\n}\n.Radio_radioWrapper__xuf-v input:checked + .Radio_radioVisible__GA1Il {\n  border-color: #142138;\n}\n.Radio_radioWrapper__xuf-v input:checked + .Radio_radioVisible__GA1Il:after {\n  content: \"\";\n  background-color: #142138;\n  width: 14px;\n  height: 14px;\n  position: absolute;\n  border-radius: 100%;\n  top: 3px;\n  left: 3px;\n}\n.Radio_radioWrapper__xuf-v input:hover + .Radio_radioVisible__GA1Il {\n  border-color: #223ba8;\n}\n.Radio_radioWrapper__xuf-v input:hover:checked + .Radio_radioVisible__GA1Il:after {\n  background-color: #223ba8;\n}\n.Radio_radioWrapper__xuf-v input:focus + .Radio_radioVisible__GA1Il {\n  outline: 1px dashed;\n  outline-offset: 1px;\n  outline-color: #142138;\n}\n.Radio_radioWrapper__xuf-v input:disabled + .Radio_radioVisible__GA1Il, .Radio_radioWrapper__xuf-v input:disabled:hover + .Radio_radioVisible__GA1Il {\n  border-color: #dad8d2;\n  background-color: #f5f4f1;\n}\n.Radio_radioWrapper__xuf-v input:disabled:checked + .Radio_radioVisible__GA1Il, .Radio_radioWrapper__xuf-v input:disabled:checked:hover + .Radio_radioVisible__GA1Il, .Radio_radioWrapper__xuf-v input:disabled:hover:checked + .Radio_radioVisible__GA1Il, .Radio_radioWrapper__xuf-v input:disabled:hover:checked:hover + .Radio_radioVisible__GA1Il {\n  background-color: #fff;\n}\n.Radio_radioWrapper__xuf-v input:disabled:checked + .Radio_radioVisible__GA1Il:after, .Radio_radioWrapper__xuf-v input:disabled:checked:hover + .Radio_radioVisible__GA1Il:after, .Radio_radioWrapper__xuf-v input:disabled:hover:checked + .Radio_radioVisible__GA1Il:after, .Radio_radioWrapper__xuf-v input:disabled:hover:checked:hover + .Radio_radioVisible__GA1Il:after {\n  background-color: #dad8d2;\n}\n\n.Radio_themed__HHEwb .Radio_radioVisible__GA1Il {\n  border: 1px solid #dbdbdb;\n}\n.Radio_themed__HHEwb input:checked + .Radio_radioVisible__GA1Il {\n  border-color: #13aa6d;\n}\n.Radio_themed__HHEwb input:checked + .Radio_radioVisible__GA1Il:after {\n  background-color: #13aa6d;\n}\n.Radio_themed__HHEwb input:hover + .Radio_radioVisible__GA1Il {\n  border-color: #008854;\n}\n.Radio_themed__HHEwb input:hover:checked + .Radio_radioVisible__GA1Il:after {\n  background-color: #008854;\n}\n.Radio_themed__HHEwb input:focus + .Radio_radioVisible__GA1Il {\n  outline-color: #dbdbdb;\n}\n.Radio_themed__HHEwb input:disabled + .Radio_radioVisible__GA1Il, .Radio_themed__HHEwb input:disabled:hover + .Radio_radioVisible__GA1Il {\n  background-color: #f2f2f2;\n  border-color: #dbdbdb;\n}\n.Radio_themed__HHEwb input:disabled:checked + .Radio_radioVisible__GA1Il, .Radio_themed__HHEwb input:disabled:hover:checked + .Radio_radioVisible__GA1Il, .Radio_themed__HHEwb input:disabled:hover:checked + .Radio_radioVisible__GA1Il, .Radio_themed__HHEwb input:disabled:hover:hover:checked + .Radio_radioVisible__GA1Il {\n  background-color: #fff;\n}\n.Radio_themed__HHEwb input:disabled:checked + .Radio_radioVisible__GA1Il:after, .Radio_themed__HHEwb input:disabled:hover:checked + .Radio_radioVisible__GA1Il:after, .Radio_themed__HHEwb input:disabled:hover:checked + .Radio_radioVisible__GA1Il:after, .Radio_themed__HHEwb input:disabled:hover:hover:checked + .Radio_radioVisible__GA1Il:after {\n  background-color: #dbdbdb;\n}";
var styles$u = {"radioWrapper":"Radio_radioWrapper__xuf-v","radioVisible":"Radio_radioVisible__GA1Il","themed":"Radio_themed__HHEwb","rotation":"Radio_rotation__evVc-"};
styleInject(css_248z$u);

var Radio = function (_a) {
    var _b = _a.checked, checked = _b === void 0 ? false : _b, _c = _a.className, className = _c === void 0 ? '' : _c, dataTestId = _a.dataTestId, _d = _a.disabled, disabled = _d === void 0 ? false : _d, id = _a.id, name = _a.name, _e = _a.onChange, onChange = _e === void 0 ? function () { } : _e, _f = _a.platform, platform = _f === void 0 ? 'brand' : _f, value = _a.value;
    var _g = useState(checked), isChecked = _g[0], setIsChecked = _g[1];
    useEffect(function () {
        setIsChecked(checked);
    }, [checked]);
    var handleOnChange = function (event) {
        onChange(event);
    };
    return (React__default.createElement("div", { className: classNames(className, styles$u.radioWrapper, styles$u[platform]) },
        React__default.createElement("input", { checked: isChecked, readOnly: true, "data-testid": dataTestId, disabled: disabled, id: id, name: name, onChange: handleOnChange, type: "radio", value: value }),
        React__default.createElement("div", { className: styles$u.radioVisible })));
};

var FilterContext = createContext({
    onSelectFilter: function () { },
    selectedFilters: {}
});

var css_248z$t = ".Filter_filter__hVoYQ {\n  cursor: pointer;\n  margin-bottom: 24px;\n}\n\n.Filter_label__oiWhG {\n  align-items: center;\n  display: flex;\n}\n\n.Filter_input__G7y-d {\n  margin-right: 8px;\n  margin-top: -2px;\n}";
var styles$t = {"filter":"Filter_filter__hVoYQ","label":"Filter_label__oiWhG","input":"Filter_input__G7y-d"};
styleInject(css_248z$t);

var Filter = function (_a) {
    var children = _a.children, _b = _a.filterCategory, filterCategory = _b === void 0 ? '' : _b, inputType = _a.inputType, _c = _a.selectedFilter, selectedFilter = _c === void 0 ? false : _c, value = _a.value, _d = _a.defaultFilter, defaultFilter = _d === void 0 ? false : _d;
    var _e = useState(defaultFilter || selectedFilter), isSelected = _e[0], setIsSelected = _e[1]; // Use defaultFilter in the initial state
    var _f = useContext(FilterContext), onSelectFilter = _f.onSelectFilter, selectedFilters = _f.selectedFilters;
    var InputComponent = inputType === 'radio' ? Radio : Checkbox;
    var name = inputType === 'radio' ? filterCategory : children;
    // if something sets the props.selected = true, update isSelected
    useEffect(function () {
        setIsSelected(defaultFilter || selectedFilter);
        onSelectFilter(filterCategory, children, value, defaultFilter || selectedFilter);
    }, [defaultFilter, selectedFilter]);
    var onChangeHandler = function (_a) {
        var target = _a.target;
        setIsSelected(!isSelected);
        onSelectFilter(filterCategory, children, target.value, target.checked);
    };
    function getSelectedFilter() {
        var _a;
        if (selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters[name])
            return (_a = selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters[name][0]) === null || _a === void 0 ? void 0 : _a.value;
    }
    return (React__default.createElement("li", { key: children, className: styles$t.filter },
        React__default.createElement("label", { className: styles$t.label },
            React__default.createElement("span", { className: styles$t.input },
                React__default.createElement(InputComponent, { checked: value === getSelectedFilter(), name: name, value: value, onChange: onChangeHandler })),
            children)));
};

var css_248z$s = ".FilterButton_filterButton__LCwK4 {\n  position: relative;\n}\n\n.FilterButton_button__E25s6 {\n  background-color: #fff;\n  border-radius: 8px;\n  display: inline-block;\n  height: 40px;\n  padding: 8px 16px;\n}\n.FilterButton_button__E25s6:active {\n  border-color: #142138;\n}\n\n.FilterButton_filterMenu__lRSgQ {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);\n  max-width: 600px;\n  min-width: 200px;\n  padding: 16px;\n  position: absolute;\n  top: 3em;\n  visibility: hidden;\n  width: max-content;\n}\n.FilterButton_filterMenu__lRSgQ.FilterButton_right__CmMGt {\n  right: 0;\n}\n.FilterButton_filterMenu__lRSgQ.FilterButton_themed__Tad6- {\n  background-color: #fff;\n}\n\n.FilterButton_doneButton__vK4HY {\n  min-width: 176px;\n}\n\n.FilterButton_showMenu__9a6-N {\n  margin-top: 8px;\n  visibility: visible;\n  z-index: 1;\n}";
var styles$s = {"filterButton":"FilterButton_filterButton__LCwK4","button":"FilterButton_button__E25s6","filterMenu":"FilterButton_filterMenu__lRSgQ","right":"FilterButton_right__CmMGt","themed":"FilterButton_themed__Tad6-","doneButton":"FilterButton_doneButton__vK4HY","showMenu":"FilterButton_showMenu__9a6-N"};
styleInject(css_248z$s);

var FilterButton = function (_a) {
    var _b;
    var _c = _a.alignMenu, alignMenu = _c === void 0 ? 'left' : _c, children = _a.children, _d = _a.className, className = _d === void 0 ? '' : _d, dataTestId = _a.dataTestId, label = _a.label, _e = _a.onSetFilters, onSetFilters = _e === void 0 ? function (filters) { } : _e;
    var filterMenuRef = useRef(null);
    var filterButtonRef = useRef(null);
    var _f = useState(false), isOpen = _f[0], setIsOpen = _f[1];
    var _g = useState({}), selectedFilters = _g[0], setSelectedFilters = _g[1];
    var _h = useState(label), buttonLabel = _h[0], setButtonLabel = _h[1];
    var _j = useState('checkbox'), inputType = _j[0], setInputType = _j[1];
    var mutableSelectedFilters = __assign({}, selectedFilters);
    var getbuttonLabel = function () {
        if (selectedFilters[label].length === 0)
            return label;
        return inputType === 'checkbox'
            ? "".concat(label, ": ").concat(selectedFilters[label].length)
            : selectedFilters[label][0].label;
    };
    /** Called when the user clicks the "Done" button on filter menu to save changed filters */
    var onSaveFilters = function () {
        // set button label
        setButtonLabel(getbuttonLabel());
        // pass values to parent component
        onSetFilters(selectedFilters);
        // close Menu
        setIsOpen(false);
    };
    // Close menu on outside click
    useEffect(function () {
        function handleClickOutside(event) {
            if (filterMenuRef.current &&
                filterButtonRef.current &&
                !filterMenuRef.current.contains(event.target) &&
                !filterButtonRef.current.contains(event.target)) {
                if (isOpen) {
                    onSaveFilters(); // Apply filters when clicking outside of dropdown
                }
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onSaveFilters]);
    /** Called when the user clicks on one filter to select or unselect it */
    var onSetSingleFilter = function (filterCategory, label, value, checked) {
        // initialize filters array if it doesn't already exist
        if (!mutableSelectedFilters[filterCategory]) {
            mutableSelectedFilters[filterCategory] = [];
        }
        if (inputType === 'checkbox') {
            // Checkbox
            if (checked) {
                // Add filter
                mutableSelectedFilters[filterCategory].push({ label: label, value: value });
                setSelectedFilters(mutableSelectedFilters);
            }
            else {
                // remove filter
                mutableSelectedFilters[filterCategory] = mutableSelectedFilters[filterCategory].filter(function (filter) { return filter.label !== label; });
                setSelectedFilters(mutableSelectedFilters);
            }
        }
        else {
            // Radio
            if (checked) {
                // Add filter
                mutableSelectedFilters[filterCategory] = [{ label: label, value: value }];
                setSelectedFilters(mutableSelectedFilters);
            }
        }
    };
    return (React__default.createElement("div", { className: styles$s.filterButton },
        React__default.createElement("span", { ref: filterButtonRef },
            React__default.createElement(Button, { className: classNames(styles$s.button, className), dataTestId: dataTestId, label: buttonLabel, onClick: function () { return setIsOpen(!isOpen); }, variant: "outline" })),
        React__default.createElement("div", { ref: filterMenuRef, className: classNames(styles$s.filterMenu, (_b = {},
                _b[styles$s.showMenu] = isOpen,
                _b[styles$s.right] = alignMenu === 'right',
                _b)) },
            React__default.createElement(FilterContext.Provider, { value: {
                    onSelectFilter: onSetSingleFilter,
                    selectedFilters: selectedFilters
                } }, React__default.Children.map(children, function (child) {
                return React__default.cloneElement(child, { filterCategory: label, setInputType: setInputType, showSelectAll: true });
            })),
            React__default.createElement(Button, { className: styles$s.doneButton, isFullWidth: true, label: "Done", onClick: onSaveFilters, size: "small" }))));
};

var css_248z$r = ".FilterGroup_filterGroup__Zla5z {\n  position: relative;\n}\n\n/*\n  These styles are from Button.scss but the Button component didn't allow for an icon on the right side so\n  I just used a standard button with the outline styling. Theming isn't necessary for filter buttons at the moment\n*/\n.FilterGroup_button__581mG {\n  align-items: center;\n  background-color: #fff;\n  border-radius: 8px;\n  border: solid 1px #dad8d2;\n  cursor: pointer;\n  display: inline-flex;\n  font: 400 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  height: 40px;\n  padding: 8px 16px;\n  transition: background-color 0.3s, opacity 0.3s, border-color 0.3s;\n  white-space: nowrap;\n  /* Button Outline style */\n  color: #142138;\n}\n.FilterGroup_button__581mG svg path {\n  fill: #142138;\n}\n.FilterGroup_button__581mG:hover, .FilterGroup_button__581mG:active {\n  border-color: #142138;\n}\n.FilterGroup_button__581mG:focus {\n  outline: 1px dashed;\n  outline-offset: 2px;\n  outline-color: #142138;\n}\n.FilterGroup_button__581mG.FilterGroup_disabled__0APXb {\n  background-color: #dad8d2;\n  color: #6e6e6e;\n}\n.FilterGroup_button__581mG.FilterGroup_disabled__0APXb svg path {\n  fill: #6e6e6e;\n}\n\n.FilterGroup_icon__wW4Mo {\n  height: 16px;\n  margin-left: 8px;\n  width: 16px;\n}\n\n.FilterGroup_filterMenu__0viMA {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);\n  max-width: 600px;\n  min-width: 400px;\n  padding: 16px;\n  position: absolute;\n  top: 3em;\n  visibility: hidden;\n  width: max-content;\n}\n.FilterGroup_filterMenu__0viMA.FilterGroup_right__tCUOt {\n  right: 0;\n}\n.FilterGroup_filterMenu__0viMA.FilterGroup_themed__-H2Np {\n  background-color: #fff;\n}\n\n.FilterGroup_filterLists__tLvEZ {\n  display: flex;\n}\n\n.FilterGroup_vertical__jvUSi {\n  flex-direction: column;\n  max-height: 50vh;\n  overflow: auto;\n}\n.FilterGroup_vertical__jvUSi .FilterGroup_filterList__t3uPY {\n  border-bottom: 1px solid #dad8d2;\n  margin-bottom: 24px;\n  margin-right: 0;\n}\n.FilterGroup_vertical__jvUSi .FilterGroup_filterList__t3uPY:last-child {\n  border-bottom: none;\n}\n\n.FilterGroup_filterList__t3uPY {\n  margin-right: 48px;\n}\n\n.FilterGroup_doneButton__07Nve {\n  min-width: 176px;\n}\n\n.FilterGroup_showMenu__g8egQ {\n  visibility: visible;\n}";
var styles$r = {"filterGroup":"FilterGroup_filterGroup__Zla5z","button":"FilterGroup_button__581mG","disabled":"FilterGroup_disabled__0APXb","icon":"FilterGroup_icon__wW4Mo","filterMenu":"FilterGroup_filterMenu__0viMA","right":"FilterGroup_right__tCUOt","themed":"FilterGroup_themed__-H2Np","filterLists":"FilterGroup_filterLists__tLvEZ","vertical":"FilterGroup_vertical__jvUSi","filterList":"FilterGroup_filterList__t3uPY","doneButton":"FilterGroup_doneButton__07Nve","showMenu":"FilterGroup_showMenu__g8egQ"};
styleInject(css_248z$r);

var _path$n, _path2$g, _path3$3, _path4$2;
function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
function SvgIconFilter16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$r({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$n || (_path$n = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.35C5 1.157 4.776 1 4.5 1s-.5.157-.5.35v7.722a1.75 1.75 0 011 0V1.35zM5 12.428a1.749 1.749 0 01-1 0v2.222c0 .193.224.35.5.35s.5-.157.5-.35v-2.223z",
    fill: "#1F1F1F"
  })), _path2$g || (_path2$g = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 11.5a.75.75 0 100-1.5.75.75 0 000 1.5zm0 1a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z",
    fill: "#1F1F1F"
  })), _path3$3 || (_path3$3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.35c0-.193-.224-.35-.5-.35s-.5.157-.5.35v2.222a1.75 1.75 0 011 0V1.35zM12 6.928a1.75 1.75 0 01-1 0v7.722c0 .193.224.35.5.35s.5-.157.5-.35V6.928z",
    fill: "#1F1F1F"
  })), _path4$2 || (_path4$2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 6a.75.75 0 100-1.5.75.75 0 000 1.5zm0 1a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z",
    fill: "#1F1F1F"
  })));
}

var FilterGroup = function (_a) {
    var _b, _c;
    var _d = _a.alignMenu, alignMenu = _d === void 0 ? 'left' : _d, children = _a.children, _e = _a.className, className = _e === void 0 ? '' : _e, dataTestId = _a.dataTestId, _f = _a.label, label = _f === void 0 ? 'More' : _f, _g = _a.layout, layout = _g === void 0 ? 'horizontal' : _g, _h = _a.onSetFilters, onSetFilters = _h === void 0 ? function (filters) { } : _h;
    var filterMenuRef = useRef(null);
    var filterButtonRef = useRef(null);
    var _j = useState(false), isOpen = _j[0], setIsOpen = _j[1];
    var _k = useState({}), selectedFilters = _k[0], setSelectedFilters = _k[1];
    var _l = useState(label), buttonLabel = _l[0], setButtonLabel = _l[1];
    var _m = useState('checkbox'), inputType = _m[0]; _m[1];
    var getbuttonLabel = function () {
        var numSelected = Object.keys(selectedFilters).reduce(function (prev, current) { return prev + selectedFilters[current].length; }, 0);
        return numSelected > 0 ? numSelected.toString() : label; // cast number to string
    };
    // Close menu on outside click
    useEffect(function () {
        function handleClickOutside(event) {
            if (filterMenuRef.current &&
                filterButtonRef.current &&
                !filterMenuRef.current.contains(event.target) &&
                !filterButtonRef.current.contains(event.target)) {
                if (isOpen)
                    setIsOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);
    /** Called when the user clicks on one filter to select or unselect it */
    var onSetSingleFilter = function (filterCategory, label, value, checked) {
        var mutableSelectedFilters = __assign({}, selectedFilters);
        // initialize filters array if it doesn't already exist
        if (!mutableSelectedFilters[filterCategory]) {
            mutableSelectedFilters[filterCategory] = [];
        }
        if (inputType === 'checkbox') {
            // Checkbox
            if (checked) {
                // Add filter
                mutableSelectedFilters[filterCategory].push({ label: label, value: value });
                setSelectedFilters(mutableSelectedFilters);
            }
            else {
                // remove filter
                mutableSelectedFilters[filterCategory] = mutableSelectedFilters[filterCategory].filter(function (filter) { return filter.label !== label; });
                setSelectedFilters(mutableSelectedFilters);
            }
        }
        else {
            // Radio
            if (checked) {
                // Add filter
                mutableSelectedFilters[filterCategory] = [{ label: label, value: value }];
                setSelectedFilters(mutableSelectedFilters);
            }
        }
    };
    /** Called when the user clicks the "Done" button on filter menu to save changed filters */
    var onSaveFilters = function () {
        // set button label
        setButtonLabel(getbuttonLabel());
        // pass values to parent component
        onSetFilters(selectedFilters);
        // close Menu
        setIsOpen(false);
    };
    return (React__default.createElement("div", { className: styles$r.filterGroup },
        React__default.createElement("button", { className: classNames(styles$r.button, className), "data-test-id": dataTestId, onClick: function () { return setIsOpen(!isOpen); }, ref: filterButtonRef },
            buttonLabel,
            " ",
            React__default.createElement(SvgIconFilter16, { className: styles$r.icon })),
        React__default.createElement("div", { ref: filterMenuRef, className: classNames(styles$r.filterMenu, (_b = {},
                _b[styles$r.showMenu] = isOpen,
                _b[styles$r.right] = alignMenu === 'right',
                _b)) },
            React__default.createElement(FilterContext.Provider, { value: {
                    onSelectFilter: onSetSingleFilter,
                    selectedFilters: selectedFilters
                } },
                React__default.createElement("div", { className: classNames(styles$r.filterLists, (_c = {}, _c[styles$r.vertical] = layout === 'vertical', _c)) }, React__default.Children.map(children, function (child) { return (React__default.createElement("div", { className: styles$r.filterList }, child)); }))),
            React__default.createElement(Button, { className: styles$r.doneButton, label: "Done", onClick: onSaveFilters, size: "small", isFullWidth: true }))));
};

var css_248z$q = ".FilterList_filters__Ko0gT {\n  font: 400 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.FilterList_selectAll__mpcHw {\n  border-bottom: solid #dad8d2 1px;\n  margin-bottom: 24px;\n}\n\n.FilterList_label__9RWTT {\n  align-items: center;\n  color: #142138;\n  display: flex;\n  font: 400 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  letter-spacing: 0.2px;\n  margin: 0 0 24px 0;\n  padding: 0;\n}\n\n.FilterList_filter__4LwWI {\n  cursor: pointer;\n  margin-bottom: 24px;\n}\n\n.FilterList_input__E8NEW {\n  margin-right: 8px;\n  margin-top: -2px;\n}";
var styles$q = {"filters":"FilterList_filters__Ko0gT","selectAll":"FilterList_selectAll__mpcHw","label":"FilterList_label__9RWTT","filter":"FilterList_filter__4LwWI","input":"FilterList_input__E8NEW"};
styleInject(css_248z$q);

var SELECT_ALL = 'Select All';
var FilterList = function (_a) {
    var _b = _a.allowMultipleFilters, allowMultipleFilters = _b === void 0 ? false : _b, children = _a.children, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.filterCategory, filterCategory = _d === void 0 ? undefined : _d, _e = _a.label, label = _e === void 0 ? undefined : _e, _f = _a.setInputType, setInputType = _f === void 0 ? function () { } : _f, _g = _a.showSelectAll, showSelectAll = _g === void 0 ? false : _g;
    var _h = useState(false), selectedFilter = _h[0], setSelectedFilter = _h[1];
    var inputType = allowMultipleFilters ? 'checkbox' : 'radio';
    var filterCat = filterCategory || label;
    useEffect(function () {
        setInputType(inputType);
    }, [inputType]);
    var onSelectAll = function () {
        setSelectedFilter(!selectedFilter);
    };
    return (React__default.createElement(React__default.Fragment, null,
        label && React__default.createElement("h3", { className: styles$q.label }, label),
        React__default.createElement("ul", { className: classNames(className, styles$q.filters) },
            showSelectAll && allowMultipleFilters && (React__default.createElement("div", { className: styles$q.selectAll },
                React__default.createElement("li", { className: styles$q.filter },
                    React__default.createElement("label", { className: styles$q.label },
                        React__default.createElement("span", { className: styles$q.input },
                            React__default.createElement(Checkbox, { name: SELECT_ALL, value: SELECT_ALL, onChange: onSelectAll })),
                        SELECT_ALL)))),
            React__default.Children.map(children, function (child) {
                return React__default.cloneElement(child, { inputType: inputType, filterCategory: filterCat, selectedFilter: selectedFilter });
            }))));
};

var paths = {};

Object.defineProperty(paths, "__esModule", {
  value: true
});
paths.RESTAURANT_LOGIN = paths.FOR_RESTAURANTS_MOBILE_URL = paths.FOR_RESTAURANTS_DESKTOP_URL = paths.GET_THE_APP_URL = paths.DOWNLOAD_APP_URL = paths.HELP_URL = paths.REGISTRATION_REDIRECT_URL = paths.CANCELED_SUPPORT_URL = CCPA_URL_1 = paths.CCPA_URL = paths.COOKIES_URL = PRIVACY_URL_1 = paths.PRIVACY_URL = TERMS_URL_1 = paths.TERMS_URL = CHOWNOW_URL_1 = paths.CHOWNOW_URL = BASE_SUPPORT_URL_1 = paths.BASE_SUPPORT_URL = BASE_CHOWNOW_URL_1 = paths.BASE_CHOWNOW_URL = void 0;
const BASE_CHOWNOW_URL = 'https://get.chownow.com';
var BASE_CHOWNOW_URL_1 = paths.BASE_CHOWNOW_URL = BASE_CHOWNOW_URL;
const BASE_SUPPORT_URL = 'https://support.chownow.com';
var BASE_SUPPORT_URL_1 = paths.BASE_SUPPORT_URL = BASE_SUPPORT_URL;
const UTM_PARAMS = '?utm_source=product&utm_medium=orderdirect&utm_campaign=poweredbyfooter';
const CHOWNOW_URL = "".concat(BASE_CHOWNOW_URL, "/").concat(UTM_PARAMS);
var CHOWNOW_URL_1 = paths.CHOWNOW_URL = CHOWNOW_URL;
const TERMS_URL = "".concat(BASE_CHOWNOW_URL, "/terms-of-service");
var TERMS_URL_1 = paths.TERMS_URL = TERMS_URL;
const PRIVACY_URL = "".concat(BASE_CHOWNOW_URL, "/privacy-policy");
var PRIVACY_URL_1 = paths.PRIVACY_URL = PRIVACY_URL;
const COOKIES_URL = "".concat(BASE_CHOWNOW_URL, "/cookie-notice"); // eslint-disable-next-line max-len

paths.COOKIES_URL = COOKIES_URL;
const CCPA_URL = "https://chownow-requests.my.onetrust.com/webform/67994022-0d2e-4da4-af0f-30b990afab7a/b16058fc-4ca6-4d7a-a18d-d18b292f7d11"; // eslint-disable-next-line max-len

var CCPA_URL_1 = paths.CCPA_URL = CCPA_URL;
const CANCELED_SUPPORT_URL = "".concat(BASE_SUPPORT_URL, "/customer/s/topic/0TO4A000000g8gzWAA/declined-canceled-orders"); // eslint-disable-next-line max-len

paths.CANCELED_SUPPORT_URL = CANCELED_SUPPORT_URL;
const REGISTRATION_REDIRECT_URL = "".concat(BASE_CHOWNOW_URL, "/registration-error?utm_source=qtc&utm_medium=organic&utm_campaign=redirect");
paths.REGISTRATION_REDIRECT_URL = REGISTRATION_REDIRECT_URL;
const HELP_URL = "".concat(BASE_SUPPORT_URL, "/customer/s/");
paths.HELP_URL = HELP_URL;
const DOWNLOAD_APP_URL = 'https://chownow.app.link/download-chownow-app-side-menu';
paths.DOWNLOAD_APP_URL = DOWNLOAD_APP_URL;
const GET_THE_APP_URL = 'https://chownow.app.link/chownow-app-download';
paths.GET_THE_APP_URL = GET_THE_APP_URL;
const FOR_RESTAURANTS_DESKTOP_URL = 'https://get.chownow.com/?utm_medium=desktop_auth_dropdown&utm_source=marketplace_web';
paths.FOR_RESTAURANTS_DESKTOP_URL = FOR_RESTAURANTS_DESKTOP_URL;
const FOR_RESTAURANTS_MOBILE_URL = 'https://get.chownow.com/?utm_medium=mobile_side_menu&utm_source=marketplace_web';
paths.FOR_RESTAURANTS_MOBILE_URL = FOR_RESTAURANTS_MOBILE_URL;
const RESTAURANT_LOGIN = 'https://admin.chownow.com/admin/login?next=https%3A%2F%2Fdashboard.chownow.com';
paths.RESTAURANT_LOGIN = RESTAURANT_LOGIN;

var _path$m, _g$1, _defs$1;
function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
function SvgIconLogoPowered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$q({
    width: 176,
    height: 24,
    viewBox: "0 0 176 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
    d: "M113.196 15.883c2.348 0 4.024-1.257 4.533-3.277l-1.751-.374c-.329 1.317-1.316 2.11-2.782 2.11-1.93 0-3.367-1.332-3.367-3.815 0-2.484 1.452-3.83 3.367-3.83 1.451 0 2.513.852 2.812 2.259l1.736-.374c-.374-2.08-2.125-3.411-4.548-3.411-2.678 0-5.147 1.78-5.147 5.356 0 3.575 2.439 5.356 5.147 5.356zM118.893 15.763h1.631v-3.261c0-1.84.763-2.933 2.02-2.933 1.017 0 1.646.613 1.646 1.616v4.578h1.63v-4.952c0-1.646-1.122-2.708-2.827-2.708-1.062 0-1.945.479-2.469 1.421V5.171h-1.631v10.592zM130.863 15.883c2.259 0 3.889-1.631 3.889-3.89 0-2.26-1.63-3.89-3.889-3.89-2.275 0-3.89 1.63-3.89 3.89 0 2.259 1.615 3.89 3.89 3.89zm-2.245-3.89c0-1.451.898-2.469 2.245-2.469 1.331 0 2.244 1.018 2.244 2.469 0 1.451-.913 2.468-2.244 2.468-1.347 0-2.245-1.017-2.245-2.468zM137.391 15.763h1.497l1.631-5.251 1.63 5.251h1.511l2.319-7.54h-1.66l-1.422 5.266-1.615-5.266h-1.512l-1.63 5.266-1.422-5.266h-1.661l2.334 7.54zM147.018 15.763h1.661v-7.69l4.817 7.69h1.841V5.29h-1.676v7.705l-4.802-7.705h-1.841v10.473zM160.462 15.883c2.259 0 3.89-1.631 3.89-3.89 0-2.26-1.631-3.89-3.89-3.89-2.274 0-3.89 1.63-3.89 3.89 0 2.259 1.616 3.89 3.89 3.89zm-2.244-3.89c0-1.451.898-2.469 2.244-2.469 1.332 0 2.244 1.018 2.244 2.469 0 1.451-.912 2.468-2.244 2.468-1.346 0-2.244-1.017-2.244-2.468zM166.99 15.763h1.496l1.631-5.251 1.631 5.251h1.511l2.318-7.54h-1.66l-1.421 5.266-1.616-5.266h-1.511l-1.631 5.266-1.421-5.266h-1.661l2.334 7.54zM.799 5.29h3.98c1.017 0 1.83.28 2.438.838.609.549.913 1.282.913 2.2 0 .917-.304 1.655-.913 2.214-.608.548-1.421.822-2.438.822H2.16v4.399H.8V5.29zm3.935 4.848c.618 0 1.102-.16 1.45-.48.36-.318.54-.762.54-1.33 0-.57-.18-1.013-.54-1.332-.348-.33-.832-.494-1.45-.494H2.16v3.636h2.574zM12.499 15.883c-.738 0-1.401-.165-1.99-.494a3.648 3.648 0 01-1.361-1.391c-.32-.589-.479-1.257-.479-2.005s.16-1.417.479-2.005a3.542 3.542 0 011.361-1.376c.589-.34 1.252-.51 1.99-.51s1.396.17 1.975.51c.588.329 1.047.788 1.376 1.376.33.588.494 1.257.494 2.005s-.165 1.416-.494 2.005a3.616 3.616 0 01-1.376 1.391c-.579.33-1.237.494-1.975.494zm-2.528-3.89c0 .808.234 1.471.703 1.99.469.508 1.077.763 1.825.763s1.356-.255 1.825-.763c.469-.519.703-1.182.703-1.99s-.234-1.466-.703-1.975c-.469-.519-1.077-.778-1.825-.778s-1.357.26-1.825.778c-.47.509-.703 1.167-.703 1.975zM17.015 8.223h1.302l1.63 5.76 1.766-5.76h1.227l1.765 5.76 1.616-5.76h1.332l-2.32 7.54h-1.241l-1.765-5.73-1.766 5.73H19.32l-2.304-7.54zM28.309 11.993c0-.718.145-1.372.434-1.96.299-.599.723-1.067 1.272-1.406.558-.35 1.206-.524 1.944-.524.719 0 1.352.16 1.9.479.55.309.968.738 1.257 1.286.3.539.45 1.132.45 1.78 0 .21-.01.405-.03.584H29.58c.04.758.279 1.372.718 1.84.449.46 1.012.689 1.69.689.559 0 1.033-.125 1.422-.374a1.91 1.91 0 00.808-1.048l1.181.374a2.934 2.934 0 01-1.241 1.601c-.599.38-1.322.569-2.17.569-.738 0-1.386-.17-1.945-.509a3.644 3.644 0 01-1.286-1.406 4.354 4.354 0 01-.45-1.975zm5.91-.823c-.06-.598-.29-1.082-.689-1.451-.399-.37-.922-.554-1.57-.554-.589 0-1.088.18-1.497.539-.409.349-.678.838-.808 1.466h4.564zM41.598 9.464c-.28-.12-.603-.18-.972-.18-.639 0-1.162.31-1.571.928-.4.609-.599 1.502-.599 2.678v2.873h-1.271v-7.54h1.271v1.526c.22-.48.549-.873.988-1.182.438-.31.892-.464 1.361-.464.33 0 .618.045.868.135l-.075 1.226zM41.944 11.993c0-.718.145-1.372.434-1.96.3-.599.723-1.067 1.272-1.406.558-.35 1.206-.524 1.944-.524.719 0 1.352.16 1.9.479.55.309.968.738 1.257 1.286.3.539.45 1.132.45 1.78 0 .21-.01.405-.03.584h-5.955c.04.758.279 1.372.718 1.84.449.46 1.012.689 1.69.689.559 0 1.033-.125 1.422-.374a1.91 1.91 0 00.808-1.048l1.182.374a2.934 2.934 0 01-1.242 1.601c-.599.38-1.322.569-2.17.569-.738 0-1.386-.17-1.945-.509a3.643 3.643 0 01-1.286-1.406 4.353 4.353 0 01-.449-1.975zm5.91-.823c-.06-.598-.29-1.082-.689-1.451-.398-.37-.922-.554-1.57-.554-.589 0-1.088.18-1.497.539-.408.349-.678.838-.807 1.466h4.563zM53.916 15.883c-.758 0-1.41-.165-1.96-.494a3.326 3.326 0 01-1.256-1.391c-.28-.589-.42-1.257-.42-2.005s.14-1.417.42-2.005a3.26 3.26 0 011.242-1.376c.548-.34 1.202-.51 1.96-.51.498 0 .972.11 1.42.33.46.22.809.509 1.048.868V5.17h1.272v10.593H56.37v-1.092c-.17.349-.484.638-.942.868-.46.229-.963.344-1.511.344zm-2.333-3.89c0 .828.224 1.496.673 2.005.449.498 1.042.748 1.78.748s1.332-.25 1.78-.748c.45-.51.674-1.177.674-2.005 0-.828-.225-1.491-.674-1.99-.448-.509-1.042-.763-1.78-.763s-1.331.254-1.78.763c-.45.499-.673 1.162-.673 1.99zM66.777 15.883a3.331 3.331 0 01-1.51-.344c-.46-.23-.774-.519-.943-.868v1.092h-1.272V5.171h1.272V9.3c.24-.36.583-.649 1.032-.868a3.29 3.29 0 011.436-.33c.758 0 1.407.17 1.945.51.549.329.963.788 1.242 1.376.29.588.434 1.257.434 2.005s-.145 1.416-.434 2.005a3.228 3.228 0 01-1.242 1.391c-.548.33-1.202.494-1.96.494zm-2.573-3.89c0 .828.225 1.496.673 2.005.45.498 1.043.748 1.78.748.739 0 1.332-.25 1.781-.748.449-.51.673-1.177.673-2.005 0-.828-.224-1.491-.673-1.99-.449-.509-1.042-.763-1.78-.763s-1.332.254-1.78.763c-.45.499-.674 1.162-.674 1.99zM77.873 8.223l-3.95 10.263h-1.302l1.093-2.828-2.948-7.435h1.377l2.214 5.775 2.214-5.775h1.302z",
    fill: "#161616"
  })), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-logo-powered_svg__clip1_1747_2737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.154 10.958C104.154 5.072 99.312.3 93.344.3 87.372.3 82.53 5.072 82.53 10.958c0 .15.005.296.01.441-.01.472.041 1.526.54 2.915a10.547 10.547 0 002.098 3.628c1.477 1.812 3.763 3.764 7.312 5.555.534.27 1.17.27 1.705 0 3.55-1.797 5.841-3.743 7.312-5.555a10.54 10.54 0 002.098-3.628c.499-1.384.55-2.443.54-2.915.005-.15.01-.296.01-.441z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.895 6.166a.876.876 0 011.253.025l2.28 2.438-.987 1.059L88.926 7.4a.846.846 0 01-.03-1.234zM99.206 14.957a.152.152 0 00.209 0c.04-.046.05-.106.025-.15 0 0-.616-1.637-1.461-2.47-.52-.511-1.14-.767-1.731-.777-.591-.01-.9 0-1.477-.422-.258-.189-.56-.597-.56-.597l3.447-3.136a.846.846 0 00.025-1.234.876.876 0 00-1.252.025s-4.376 4.699-4.659 4.977c-.283.279-.932.402-1.553.412-.621.01-1.283.28-1.833.823-1.028 1.013-1.589 2.89-.759 3.708.825.818 2.73.266 3.758-.748.55-.542.825-1.335.835-1.947.01-.612 0-.9.392-1.445.207-.288.672-.597.672-.597s.437.327.637.597c.433.585.422.868.433 1.445.01.577.27 1.194.789 1.706.845.833 2.51 1.445 2.51 1.445a.163.163 0 00.158-.035.147.147 0 000-.206l-2.409-2.097a.363.363 0 010-.522.376.376 0 01.53 0l2.388 2.118c.102.1.275.1.377 0a.264.264 0 000-.372l-2.149-2.353a.363.363 0 010-.522.376.376 0 01.53 0l2.128 2.374z",
    fill: "#fff"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-logo-powered_svg__clip0_1747_2737"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h176v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-logo-powered_svg__clip1_1747_2737"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(82.53 .3)",
    d: "M0 0h21.625v23.4H0z"
  })))));
}

var css_248z$p = ".Footer_footer__dFxAg {\n  background-color: #fff;\n  border-top: 1px solid #dad8d2;\n}\n\n.Footer_brand__R1HjE {\n  padding: 24px;\n}\n.Footer_brand__R1HjE .Footer_socialMedia__iYwom {\n  padding-top: 24px;\n}\n\n.Footer_themed__JiFFS {\n  padding: 24px 16px;\n}\n.Footer_themed__JiFFS .Footer_logoWrapper__G8rY- {\n  display: none;\n}\n.Footer_themed__JiFFS .Footer_socialMedia__iYwom {\n  border-top: 1px solid #dad8d2;\n  margin-top: 24px;\n  padding-top: 24px;\n}\n\n.Footer_linkWrapper__llOj3 {\n  display: flex;\n  flex-direction: column;\n}\n\n.Footer_footerLinks__Rxjc0 {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.Footer_linkText__gme9A {\n  font: 400 12px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  white-space: nowrap;\n  width: fit-content;\n}\n\n/* Small devices and above (tablet, 768px and up) */\n@media screen and (min-width: 768px) {\n  .Footer_footer__dFxAg {\n    padding: 32px;\n  }\n\n  .Footer_themed__JiFFS .Footer_logoWrapper__G8rY- {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    margin-bottom: 32px;\n  }\n  .Footer_themed__JiFFS .Footer_logoWrapper__G8rY- a {\n    display: flex;\n  }\n  .Footer_themed__JiFFS .Footer_logoWrapper__G8rY- svg {\n    height: 24px;\n    width: auto;\n  }\n  .Footer_themed__JiFFS .Footer_socialMedia__iYwom {\n    display: none;\n  }\n\n  .Footer_linkText__gme9A {\n    margin: 0;\n  }\n\n  .Footer_footerLinks__Rxjc0 {\n    align-items: flex-start;\n    align-content: flex-start;\n    align-self: stretch;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 16px;\n  }\n}\n/* Medium devices and above (desktop, 1200px and up) */\n@media screen and (min-width: 1200px) {\n  .Footer_footer__dFxAg {\n    padding: 32px 48px;\n  }\n\n  .Footer_brand__R1HjE .Footer_socialMedia__iYwom {\n    padding: 0;\n  }\n\n  .Footer_themed__JiFFS .Footer_logoWrapper__G8rY- {\n    margin: 0;\n  }\n  .Footer_themed__JiFFS .Footer_footerLinks__Rxjc0 {\n    justify-content: flex-end;\n  }\n\n  .Footer_linkWrapper__llOj3 {\n    flex-direction: row;\n  }\n\n  .Footer_footerLinks__Rxjc0 {\n    align-items: center;\n    align-content: center;\n    flex: 1;\n  }\n}";
var styles$p = {"footer":"Footer_footer__dFxAg","brand":"Footer_brand__R1HjE","socialMedia":"Footer_socialMedia__iYwom","themed":"Footer_themed__JiFFS","logoWrapper":"Footer_logoWrapper__G8rY-","linkWrapper":"Footer_linkWrapper__llOj3","footerLinks":"Footer_footerLinks__Rxjc0","linkText":"Footer_linkText__gme9A"};
styleInject(css_248z$p);

var _path$l;
function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }
function SvgIconSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$p({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
    d: "M10.161 3.453c-.827 0-1.066.365-1.066 1.17V5.96h2.206l-.221 2.158H9.096v6.55H6.45v-6.55H4.667V5.96H6.45V4.66c0-2.177.881-3.327 3.341-3.327.515 0 1.03.03 1.542.092v2.03l-1.172-.002z",
    fill: "#142138"
  })));
}

var _path$k, _path2$f;
function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }
function SvgIconSocialInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
    d: "M3.416 1.367c-.461.18-.851.419-1.24.808-.39.388-.63.78-.809 1.239-.173.443-.29.953-.324 1.699C1.009 5.858 1 6.097 1 7.999c0 1.9.009 2.14.043 2.885.034.746.153 1.256.324 1.7.18.46.418.85.808 1.24.39.39.78.63 1.24.809.445.174.954.29 1.7.324.745.034.984.043 2.885.043 1.9 0 2.14-.008 2.885-.043.746-.034 1.255-.153 1.7-.324.46-.18.85-.418 1.24-.808.39-.39.629-.78.808-1.241.174-.444.29-.954.324-1.7C14.991 10.14 15 9.9 15 8c0-1.902-.008-2.14-.043-2.886-.034-.746-.153-1.256-.324-1.7a3.451 3.451 0 00-.805-1.238c-.39-.39-.78-.629-1.241-.808-.444-.173-.953-.29-1.699-.324C10.143 1.009 9.904 1 8.003 1c-1.901 0-2.14.009-2.886.043-.748.031-1.257.15-1.701.324zm7.412.934c.683.031 1.053.145 1.3.242.328.128.561.279.806.523.245.245.396.478.524.806.097.247.21.617.242 1.3.034.738.04.96.04 2.83s-.01 2.091-.04 2.829c-.032.683-.145 1.053-.242 1.3a2.18 2.18 0 01-.524.806 2.181 2.181 0 01-.805.523c-.248.097-.618.21-1.3.242-.738.034-.96.04-2.829.04-1.87 0-2.091-.009-2.828-.04-.683-.031-1.053-.145-1.3-.242a2.182 2.182 0 01-.806-.523 2.182 2.182 0 01-.524-.806c-.096-.248-.21-.617-.242-1.3-.034-.738-.04-.96-.04-2.83s.01-2.091.04-2.829c.032-.683.146-1.053.242-1.3.128-.328.28-.561.524-.806a2.18 2.18 0 01.805-.523c.248-.097.618-.211 1.3-.242.738-.034.96-.04 2.829-.04 1.87 0 2.091.006 2.829.04z",
    fill: "#142138"
  })), _path2$f || (_path2$f = /*#__PURE__*/React.createElement("path", {
    d: "M4.406 8.001a3.594 3.594 0 107.189 0 3.594 3.594 0 00-7.189 0zm5.927 0a2.333 2.333 0 11-4.666.002A2.333 2.333 0 0110.333 8zM11.739 5.104a.84.84 0 100-1.679.84.84 0 000 1.68z",
    fill: "#142138"
  })));
}

var _path$j;
function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
function SvgIconSocialTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.333 3.93a6.58 6.58 0 01-1.728.423c.622-.333 1.1-.86 1.323-1.489a6.442 6.442 0 01-1.912.653c-.547-.524-1.33-.85-2.196-.85-1.66 0-3.008 1.205-3.008 2.692 0 .212.026.417.078.613C5.39 5.86 3.173 4.79 1.687 3.16c-.259.399-.406.861-.406 1.355 0 .933.53 1.757 1.338 2.24a3.29 3.29 0 01-1.364-.335v.033c0 1.305 1.038 2.393 2.415 2.64a3.262 3.262 0 01-.793.095c-.194 0-.383-.016-.566-.048.383 1.07 1.493 1.849 2.81 1.87a6.502 6.502 0 01-3.737 1.152c-.242 0-.482-.012-.717-.037a9.263 9.263 0 004.611 1.21c5.537 0 8.562-4.103 8.562-7.662 0-.117-.002-.234-.008-.349.588-.38 1.1-.854 1.501-1.393z",
    fill: "#142138"
  })));
}

var css_248z$o = ".SocialList_socialList__ssaBJ {\n  display: flex;\n  flex-direction: row;\n  margin: 0;\n  padding: 0;\n  width: fit-content;\n}\n\n.SocialList_large__CJ3qn .SocialList_socialLink__RgAPz {\n  margin-right: 32px;\n}\n.SocialList_large__CJ3qn .SocialList_socialIcon__XpYWY {\n  height: 24px;\n  width: 24px;\n}\n\n.SocialList_socialLink__RgAPz {\n  list-style-type: none;\n  margin-right: 16px;\n}\n.SocialList_socialLink__RgAPz:last-of-type {\n  margin-right: 0;\n}\n.SocialList_socialLink__RgAPz a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.SocialList_socialIcon__XpYWY {\n  height: 16px;\n  width: 16px;\n}\n.SocialList_socialIcon__XpYWY:hover path {\n  transition: fill 0.2s ease;\n  fill: #223ba8;\n}";
var styles$o = {"socialList":"SocialList_socialList__ssaBJ","large":"SocialList_large__CJ3qn","socialLink":"SocialList_socialLink__RgAPz","socialIcon":"SocialList_socialIcon__XpYWY"};
styleInject(css_248z$o);

var css_248z$n = ".Outlink_outlink__KI20b {\n  color: #142138;\n  font-family: \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  letter-spacing: 0 !important;\n  text-decoration: none;\n}\n.Outlink_outlink__KI20b:hover, .Outlink_outlink__KI20b:active {\n  color: #223ba8;\n  text-decoration: none;\n  transition: fill 0.2s ease;\n}\n.Outlink_outlink__KI20b:focus, .Outlink_outlink__KI20b:focus-visible {\n  outline: thin dashed #142138;\n  text-decoration: none;\n}\n\n.Outlink_themed__vBsIT {\n  color: #1f1f1f;\n}\n.Outlink_themed__vBsIT:hover, .Outlink_themed__vBsIT:active {\n  color: #008854;\n}\n.Outlink_themed__vBsIT:focus, .Outlink_themed__vBsIT:focus-visible {\n  outline: thin dashed #1f1f1f;\n}";
var styles$n = {"outlink":"Outlink_outlink__KI20b","themed":"Outlink_themed__vBsIT"};
styleInject(css_248z$n);

// Generated with util/create-component.js
function Outlink(_a) {
    var ariaLabel = _a.ariaLabel, children = _a.children, className = _a.className, handleClick = _a.handleClick, _b = _a.platform, platform = _b === void 0 ? 'brand' : _b, to = _a.to;
    return (React__default.createElement("a", { href: to, "data-testid": "Outlink", "aria-label": ariaLabel, className: classNames(className, styles$n.outlink, styles$n[platform]), target: "_blank", rel: "noreferrer", onClick: handleClick }, children));
}

// Generated with util/create-component.js
function SocialList(_a) {
    var _b;
    var _c = _a.isLarge, isLarge = _c === void 0 ? false : _c;
    return (React__default.createElement("ul", { "data-testid": "SocialList", className: classNames(styles$o.socialList, (_b = {},
            _b[styles$o.large] = isLarge,
            _b)) },
        React__default.createElement("li", { className: styles$o.socialLink },
            React__default.createElement(Outlink, { to: "https://instagram.com/ChowNow/", ariaLabel: "Instagram" },
                React__default.createElement(SvgIconSocialInstagram, { className: styles$o.socialIcon }))),
        React__default.createElement("li", { className: styles$o.socialLink },
            React__default.createElement(Outlink, { to: "https://twitter.com/ChowNow/", ariaLabel: "Twitter" },
                React__default.createElement(SvgIconSocialTwitter, { className: styles$o.socialIcon }))),
        React__default.createElement("li", { className: styles$o.socialLink },
            React__default.createElement(Outlink, { to: "https://facebook.com/ChowNow/", ariaLabel: "Facebook" },
                React__default.createElement(SvgIconSocialFacebook, { className: styles$o.socialIcon })))));
}

// Generated with util/create-component.js
function Footer(_a) {
    var _b = _a.platform, platform = _b === void 0 ? 'brand' : _b;
    var isMarketplace = platform === 'brand';
    var poweredOutlink = (React__default.createElement(Outlink, { to: CHOWNOW_URL_1, ariaLabel: "Powered by ChowNow" },
        React__default.createElement(SvgIconLogoPowered, null)));
    return (React__default.createElement("footer", { "data-testid": "Footer", className: classNames(styles$p.footer, styles$p[platform]) },
        React__default.createElement("div", { className: styles$p.linkWrapper },
            !isMarketplace && React__default.createElement("div", { className: styles$p.logoWrapper }, poweredOutlink),
            React__default.createElement("div", { className: styles$p.footerLinks },
                React__default.createElement(Outlink, { to: "".concat(BASE_CHOWNOW_URL_1, "/about"), ariaLabel: "About Us", className: styles$p.linkText, platform: platform }, "About Us"),
                isMarketplace && (React__default.createElement(Outlink, { to: "".concat(BASE_SUPPORT_URL_1, "/customer/s/"), ariaLabel: "Help", className: styles$p.linkText, platform: platform }, "Help")),
                React__default.createElement(Outlink, { to: TERMS_URL_1, ariaLabel: "Terms of Use", className: styles$p.linkText, platform: platform }, "Terms of Use"),
                React__default.createElement(Outlink, { to: PRIVACY_URL_1, ariaLabel: "Privacy Policy", className: styles$p.linkText, platform: platform }, "Privacy Policy"),
                React__default.createElement(Outlink, { to: CCPA_URL_1, ariaLabel: "Do Not Sell or Share My Personal Information", className: styles$p.linkText, platform: platform }, "Do Not Sell or Share My Personal Information"),
                React__default.createElement(Outlink, { to: CCPA_URL_1, ariaLabel: "Limit The Use Of My Sensitive Personal Information", className: styles$p.linkText, platform: platform }, "Limit The Use Of My Sensitive Personal Information")),
            React__default.createElement("div", { className: styles$p.socialMedia }, isMarketplace ? React__default.createElement(SocialList, null) : poweredOutlink))));
}

var css_248z$m = ".Input_input__b0K8L {\n  border-radius: 8px;\n  border: 1px solid #dad8d2;\n  color: #142138;\n  font: 400 16px/24px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  padding: 11px 16px;\n  width: 100%;\n}\n.Input_input__b0K8L:hover, .Input_input__b0K8L:focus {\n  border-color: #142138;\n}\n.Input_input__b0K8L:focus-visible, .Input_input__b0K8L:focus:not(:focus-visible) {\n  outline: none;\n}\n.Input_input__b0K8L.Input_error__SvBaQ {\n  border-color: #cc1b00;\n}\n.Input_input__b0K8L[disabled] {\n  color: #6e6e6e;\n  -webkit-text-fill-color: #6e6e6e;\n  background-color: #dad8d2;\n}\n.Input_input__b0K8L[disabled]:hover, .Input_input__b0K8L[disabled]:focus {\n  border-color: #dad8d2;\n}\n.Input_input__b0K8L.Input_withLink__muQfo {\n  padding-right: 48px;\n}\n.Input_input__b0K8L.Input_multi__yvHmQ {\n  min-height: 80px;\n  resize: vertical;\n}\n\n.Input_inputContainer__brk3i {\n  position: relative;\n  display: flex;\n}\n\n.Input_icon__UFEJu {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  left: 16px;\n  position: absolute;\n  top: 0;\n}\n.Input_icon__UFEJu svg {\n  height: 16px;\n  width: 16px;\n}\n.Input_icon__UFEJu path {\n  fill: #142138;\n}\n.Input_icon__UFEJu.Input_placeholderIcon__ZQlct path {\n  fill: #6e6e6e;\n}\n\n.Input_label__P9idL {\n  display: flex;\n  font: 400 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n.Input_label__P9idL.Input_disabled__vzBxC {\n  color: #6e6e6e;\n}\n\n.Input_link__-rrnR {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  position: absolute;\n  right: 16px;\n  top: 0;\n}\n\n.Input_clearIconWrapper__v7o-o {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  position: absolute;\n  left: calc(100% - 32px);\n  top: 0;\n}\n\n.Input_clearIcon__PRKEX {\n  cursor: pointer;\n}\n.Input_clearIcon__PRKEX:focus {\n  outline: 1px dashed #142138;\n}\n.Input_clearIcon__PRKEX:hover path, .Input_clearIcon__PRKEX:active path {\n  fill: #223ba8;\n}\n.Input_clearIcon__PRKEX path {\n  fill: #142138;\n}\n\n.Input_indent__-hXE1 {\n  text-indent: 24px;\n}\n\n.Input_helpSection__pwEVB {\n  display: flex;\n  color: #6e6e6e;\n  margin: 8px 0 0;\n  width: 100%;\n}\n\n.Input_helpText__-W27V {\n  flex-grow: 1;\n  font: 400 12px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  margin-right: 8px;\n  text-align: left;\n}\n.Input_helpText__-W27V.Input_error__SvBaQ {\n  color: #cc1b00;\n}\n\n.Input_characterLimit__05o1y {\n  display: flex;\n  flex-grow: 0;\n  font: 500 10px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  letter-spacing: 0.8px;\n  text-align: right;\n}\n\n.Input_themed__Wlewp .Input_input__b0K8L {\n  border: 1px solid #dbdbdb;\n  color: #1f1f1f;\n}\n.Input_themed__Wlewp .Input_input__b0K8L:hover, .Input_themed__Wlewp .Input_input__b0K8L:focus {\n  border-color: #1f1f1f;\n}\n.Input_themed__Wlewp .Input_input__b0K8L[disabled] {\n  color: #6e6e6e;\n  background-color: #dbdbdb;\n}\n.Input_themed__Wlewp .Input_input__b0K8L[disabled]:hover, .Input_themed__Wlewp .Input_input__b0K8L[disabled]:focus {\n  border-color: #dbdbdb;\n}\n.Input_themed__Wlewp .Input_input__b0K8L.Input_error__SvBaQ {\n  border-color: #cc1b00;\n}\n.Input_themed__Wlewp .Input_clearIcon__PRKEX:hover path, .Input_themed__Wlewp .Input_clearIcon__PRKEX:active path {\n  fill: #008854;\n}\n.Input_themed__Wlewp .Input_clearIcon__PRKEX path {\n  fill: #1f1f1f;\n}\n.Input_themed__Wlewp .Input_icon__UFEJu path {\n  fill: #1f1f1f;\n}\n.Input_themed__Wlewp .Input_icon__UFEJu.Input_placeholderIcon__ZQlct path {\n  fill: #6e6e6e;\n}\n.Input_themed__Wlewp .Input_label__P9idL.Input_disabled__vzBxC {\n  color: #6e6e6e;\n}\n.Input_themed__Wlewp .Input_helpSection__pwEVB {\n  color: #6e6e6e;\n}\n.Input_themed__Wlewp .Input_helpText__-W27V.Input_error__SvBaQ {\n  color: #cc1b00;\n}\n\n.Input_srOnly__Gfh9K {\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.Input_visibleLabel__rwjfK {\n  margin-top: 8px;\n}";
var styles$m = {"input":"Input_input__b0K8L","error":"Input_error__SvBaQ","withLink":"Input_withLink__muQfo","multi":"Input_multi__yvHmQ","inputContainer":"Input_inputContainer__brk3i","icon":"Input_icon__UFEJu","placeholderIcon":"Input_placeholderIcon__ZQlct","label":"Input_label__P9idL","disabled":"Input_disabled__vzBxC","link":"Input_link__-rrnR","clearIconWrapper":"Input_clearIconWrapper__v7o-o","clearIcon":"Input_clearIcon__PRKEX","indent":"Input_indent__-hXE1","helpSection":"Input_helpSection__pwEVB","helpText":"Input_helpText__-W27V","characterLimit":"Input_characterLimit__05o1y","themed":"Input_themed__Wlewp","srOnly":"Input_srOnly__Gfh9K","visibleLabel":"Input_visibleLabel__rwjfK"};
styleInject(css_248z$m);

/* eslint-disable prefer-template */
function normalizePhone(phone) {
    var digits = phone && phone.replace(/[^\d]/g, '');
    if (!digits)
        return '';
    if (digits.length <= 3) {
        // Not a long enough sequence for a dash.
        return digits;
    }
    if (digits.length <= 6) {
        // Insert a dash between the third and fourth digits.
        return digits.slice(0, 3) + '-' + digits.slice(3);
    }
    // Insert a dash between the third and fourth digits, and another between the sixth and seventh.
    return digits.slice(0, 3) + '-' + digits.slice(3, 6) + '-' + digits.slice(6, 10);
}
var Input = function (_a) {
    var _b, _c, _d, _e, _f;
    var characterLimit = _a.characterLimit, _g = _a.className, className = _g === void 0 ? '' : _g, dataTestId = _a.dataTestId, _h = _a.disabled, disabled = _h === void 0 ? false : _h, errorText = _a.errorText, helpText = _a.helpText, icon = _a.icon, id = _a.id, inputMode = _a.inputMode, _j = _a.isMultiLine, isMultiLine = _j === void 0 ? false : _j, label = _a.label, link = _a.link, name = _a.name, _k = _a.onChange, onChange = _k === void 0 ? function () { } : _k, _l = _a.onKeyDown, onKeyDown = _l === void 0 ? function () { } : _l, placeholder = _a.placeholder, _m = _a.platform, platform = _m === void 0 ? 'brand' : _m, _o = _a.shouldHideLabel, shouldHideLabel = _o === void 0 ? false : _o, _p = _a.type, type = _p === void 0 ? 'text' : _p, _q = _a.value, value = _q === void 0 ? '' : _q;
    var inputValueRef = useRef(value); // capture initial value
    var inputValue = inputValueRef.current;
    var showClearLink = !!inputValue && !disabled && !link && !isMultiLine;
    var elementType = isMultiLine ? 'textarea' : 'input';
    var isNumbertype = type === 'number';
    var inputType = isNumbertype ? 'text' : type; // don't allow <Input type=number />. use formatValue() to enforce numeric input
    var isTelephone = type === 'tel';
    // don't allow 0 or negative numbers for maxLength
    var maxLength = characterLimit && characterLimit > 0 ? characterLimit : undefined;
    var resetInputRef = function () {
        inputValueRef.current = '';
    };
    var updateRef = function (val) {
        inputValueRef.current = val;
    };
    // This is a temporary work around to allow for numeric input. TODO smooth this over in Cocina
    var formatValue = function (val) {
        if (!isTelephone) {
            return isNumbertype ? val.replace(/[^0-9.]/g, '') : val;
        }
        return normalizePhone(val);
    };
    return (React__default.createElement("div", { className: classNames(className, styles$m[platform]), "data-testid": dataTestId },
        React__default.createElement("label", { htmlFor: id, className: classNames(styles$m.label, (_b = {},
                _b[styles$m.disabled] = disabled,
                _b[styles$m.srOnly] = shouldHideLabel,
                _b)) }, label),
        React__default.createElement("div", { className: classNames(styles$m.inputContainer, (_c = {},
                _c[styles$m.visibleLabel] = !shouldHideLabel,
                _c)) },
            icon && (React__default.createElement("div", { className: classNames(styles$m.icon, (_d = {},
                    _d[styles$m.placeholderIcon] = !inputValue.length,
                    _d)) }, icon)),
            React__default.createElement(elementType, {
                className: classNames(styles$m.input, (_e = {},
                    _e[styles$m.indent] = !!icon,
                    _e[styles$m.error] = errorText,
                    _e[styles$m.withLink] = link || showClearLink,
                    _e[styles$m.multi] = isMultiLine,
                    _e)),
                'aria-describedby': 'input-help-text',
                id: id,
                inputMode: inputMode,
                maxLength: maxLength,
                name: name,
                onChange: function (e) {
                    updateRef(formatValue(e.target.value));
                    onChange(formatValue(e.target.value));
                },
                onKeyDown: onKeyDown,
                placeholder: placeholder,
                type: inputType,
                value: inputValue,
                disabled: disabled,
                'aria-label': id
            }, isMultiLine ? inputValue : null // children argument for textarea input
            ),
            link && (React__default.createElement("div", { className: styles$m.link },
                React__default.createElement(Button, { label: link.label, onClick: link.onClick, platform: platform, size: "xsmall", variant: "link" }))),
            showClearLink && (React__default.createElement("div", { className: styles$m.clearIconWrapper },
                React__default.createElement(SvgIconClose16, { className: styles$m.clearIcon, onClick: function () {
                        resetInputRef();
                        onChange('');
                    }, role: "button" })))),
        (!!errorText || !!helpText || !!characterLimit) && (React__default.createElement("p", { className: styles$m.helpSection },
            React__default.createElement("span", { className: classNames(styles$m.helpText, (_f = {},
                    _f[styles$m.error] = errorText,
                    _f)), id: "input-help-text" }, errorText || helpText),
            !!characterLimit && (React__default.createElement("span", { className: styles$m.characterLimit },
                inputValue.length,
                "/",
                characterLimit))))));
};

var _path$i, _path2$e;
function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
function SvgIconMapMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.434 11.077c.825-.844 1.334-1.534 1.645-2.21.305-.662.446-1.37.446-2.29C13.525 3.476 11.068 1 8 1 4.932 1 2.475 3.476 2.475 6.578c0 .95.11 1.612.39 2.237.287.643.79 1.329 1.704 2.264l3.432 3.509 3.433-3.511zM8 16l-4.12-4.213C1.983 9.847 1.5 8.65 1.5 6.577 1.5 2.908 4.41 0 8 0s6.5 2.907 6.5 6.578c0 2.07-.645 3.435-2.378 5.207L8.001 16z",
    fill: "#1F1F1F"
  })), _path2$e || (_path2$e = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0 1a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    fill: "#1F1F1F"
  })));
}

// Generated with util/create-component.js
function InputAddress(_a) {
    var errorText = _a.errorText, helpText = _a.helpText, label = _a.label, onChange = _a.onChange, placeholder = _a.placeholder, platform = _a.platform, value = _a.value;
    return (React__default.createElement(Input, { errorText: errorText, helpText: helpText, icon: React__default.createElement(SvgIconMapMarker, null), id: "address", label: label || 'Address', name: "address", onChange: onChange, placeholder: placeholder, platform: platform, value: value }));
}

// Generated with util/create-component.js
function InputPassword(_a) {
    var errorText = _a.errorText, helpText = _a.helpText, label = _a.label, link = _a.link, onChange = _a.onChange, platform = _a.platform, value = _a.value;
    return (React__default.createElement(Input, { errorText: errorText, helpText: helpText, id: "password", label: label || 'Password', link: link, name: "password", onChange: onChange, platform: platform, type: "password", value: value }));
}

var _path$h, _path2$d;
function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
function SvgIconCreditCard24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5c0-.5.5-1 1-1h22c.5 0 1 .5 1 1v14c0 .5-.5 1-1 1H1c-.5 0-1-.5-1-1V5zm1 0v14h22V5H1z",
    fill: "#1F1F1F"
  })), _path2$d || (_path2$d = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 9H1V8h22v1z",
    fill: "#1F1F1F"
  })));
}

var _path$g, _path2$c, _path3$2;
function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
function SvgIconDiscover24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5c0-.5.5-1 1-1h22c.5 0 1 .5 1 1v14c0 .5-.5 1-1 1H1c-.5 0-1-.5-1-1V5zm1 0v14h22V5H1z",
    fill: "#000"
  })), _path2$c || (_path2$c = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.066 12.138h-.175v-.87h.175c.384 0 .56.16.56.418 0 .29-.176.452-.56.452zm1.19-.484c0-.548-.386-.838-1.086-.838h-.874v2.87h.594v-1.161h.07l.805 1.16h.735l-.945-1.192c.42-.065.735-.42.7-.839zm-4.025 2.032h1.68v-.484h-1.085v-.774h1.05v-.484h-1.05V11.3h1.085v-.484h-1.68v2.87zm-1.75-.935l-.804-1.935h-.63l1.295 2.934h.314l1.295-2.934h-.63l-.84 1.934zm-7.103-.484c0 .806.7 1.483 1.575 1.483.28 0 .525-.065.77-.161v-.645a.942.942 0 01-.7.322c-.56 0-1.015-.387-1.015-.902v-.065c-.035-.516.42-.967.98-1 .28 0 .56.13.735.323v-.645c-.21-.129-.49-.161-.735-.161-.91-.065-1.61.612-1.61 1.45zm-1.084-.354c-.35-.13-.455-.194-.455-.355.035-.193.21-.355.42-.322.175 0 .35.096.49.225l.314-.386a1.447 1.447 0 00-.874-.323c-.49-.032-.91.322-.945.774v.032c0 .387.175.613.735.774.14.032.28.097.42.161.105.065.175.161.175.29 0 .226-.21.42-.42.42h-.035a.694.694 0 01-.63-.387l-.385.354c.21.355.63.549 1.05.549.56.032 1.014-.355 1.05-.871v-.097c-.036-.387-.21-.58-.91-.838zm-2.03 1.773h.595v-2.87h-.595v2.87zm-1.19-.71c-.21.161-.524.258-.804.226h-.175V11.3h.175c.28-.033.595.064.804.225.21.194.315.452.315.71a.98.98 0 01-.315.741zm-.7-2.16H2.5v2.87h.875c.385.032.77-.097 1.084-.323.35-.29.56-.677.56-1.096.035-.774-.63-1.419-1.47-1.451h-.174z",
    fill: "#000"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.508 10.75c-.875 0-1.61.645-1.61 1.483 0 .806.7 1.483 1.61 1.516.91.032 1.61-.645 1.644-1.484-.035-.838-.735-1.515-1.644-1.515z",
    fill: "#FF6000"
  })));
}

var _path$f, _path2$b;
function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
function SvgIconAmericanExpress24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5c0-.5.5-1 1-1h22c.5 0 1 .5 1 1v14c0 .5-.5 1-1 1H1c-.5 0-1-.5-1-1V5zm1 0v14h22V5H1z",
    fill: "#000"
  })), _path2$b || (_path2$b = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.194 14.493h-.988v-.483h.862s.314.035.314-.166c0-.19-.47-.175-.47-.175s-.766.064-.766-.626c0-.685.692-.646.692-.646h1.063v.49h-.855s-.297-.057-.297.15c0 .173.404.148.404.148s.847-.06.847.573c0 .678-.546.738-.74.738-.041 0-.067-.003-.067-.003zm-4.928.004V12.4h1.73v.487h-1.172v.323h1.143v.477h-1.143v.356h1.173v.454h-1.732zm2.97-.004h-.988v-.483h.866s.311.035.311-.166c0-.19-.47-.175-.47-.175s-.766.064-.766-.626c0-.685.692-.646.692-.646h1.066v.49h-.858s-.297-.057-.297.15c0 .173.403.148.403.148s.848-.06.848.573c0 .678-.546.738-.74.738-.042 0-.067-.003-.067-.003zm-7.485.003h-.484l-.589-.622-.592.622H7.022v-2.104h2.02l.636.668.64-.664h.426v-.004h1.347s.703-.075.703.618c0 .619-.234.81-.951.81h-.544v.676h-.548zm-.695-1.033l.688.732v-1.46l-.688.728zm-2.475.578H8.75l.547-.579-.547-.576H7.58v.323h1.14v.477H7.58v.355zm3.718-.767h.573c.167 0 .304-.088.304-.198 0-.11-.137-.2-.304-.2H11.3v.399zm3.152 1.226v-.409s-.022-.32-.37-.32h-.54v.729h-.555v-2.1h1.347s.703-.082.703.614c0 .363-.31.49-.31.49s.266.122.266.477v.519h-.54zm-.91-1.222h.573c.167 0 .304-.088.304-.199 0-.11-.137-.199-.303-.199h-.574v.398zm-.418-1.653h.558V9.518h-.558v2.107zm-4.3-.008v-2.1h1.732v.49H9.382v.324h1.144v.476H9.382v.356h1.173v.454H8.824zm-.869 0v-1.45l-.695 1.45h-.455l-.7-1.443v1.443H5.01l-.192-.44H3.803l-.196.44H3l.921-2.1h.78l.845 1.93v-1.93h.876l.61 1.304.608-1.305h.876v2.1h-.562zM4.04 10.64h.54l-.27-.625-.27.625zm14.818.977l-.88-1.404v1.404H16.89l-.196-.44H15.68l-.193.44h-.869s-.747-.103-.747-.991c0-1.166.847-1.12.876-1.127l.685.018v.472l-.562.007s-.367 0-.411.459a1.449 1.449 0 00-.008.146c.003.71.642.49.663.483l.688-1.567h.777l.832 1.904V9.518h.784l.87 1.382V9.518h.559v2.1h-.766zm-2.941-.977h.54l-.267-.625-.273.625zm-3.608.978v-.408s-.022-.32-.37-.32h-.54v.728h-.555v-2.1h1.347s.702-.082.702.615c0 .362-.31.49-.31.49s.27.121.27.476v.52h-.544zm-.91-1.224h.573c.167 0 .304-.09.304-.2 0-.11-.137-.198-.304-.198H11.4v.398z",
    fill: "#006FCF"
  })));
}

var _path$e, _path2$a, _path3$1, _path4$1;
function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
function SvgIconMastercard24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5c0-.5.5-1 1-1h22c.5 0 1 .5 1 1v14c0 .5-.5 1-1 1H1c-.5 0-1-.5-1-1V5zm1 0v14h22V5H1z",
    fill: "#000"
  })), _path2$a || (_path2$a = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7.5h-4.5v9h4.5v-9z",
    fill: "#FF5F00"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 12c0-.852.19-1.693.559-2.459A5.605 5.605 0 0112 7.578a5.508 5.508 0 00-5.869-.637 5.584 5.584 0 00-2.284 2.075 5.672 5.672 0 000 5.968 5.584 5.584 0 002.284 2.075A5.509 5.509 0 0012 16.422a5.603 5.603 0 01-1.566-1.963A5.667 5.667 0 019.875 12z",
    fill: "#EB001B"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12c0 1.055-.294 2.09-.847 2.984a5.585 5.585 0 01-2.284 2.075A5.509 5.509 0 0112 16.422a5.614 5.614 0 001.565-1.964 5.677 5.677 0 000-4.916A5.614 5.614 0 0012 7.578a5.509 5.509 0 015.869-.637 5.585 5.585 0 012.284 2.075C20.706 9.91 21 10.945 21 12z",
    fill: "#F79E1B"
  })));
}

var _path$d, _path2$9, _path3, _path4;
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
function SvgIconVisa24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5c0-.5.5-1 1-1h22c.5 0 1 .5 1 1v14c0 .5-.5 1-1 1H1c-.5 0-1-.5-1-1V5zm1 0v14h22V5H1z",
    fill: "#000"
  })), _path2$9 || (_path2$9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 14.9h-1.517l-.194-.86h-2.1l-.345.86h-1.722l2.464-5.365s.15-.431.763-.431h1.328L21.75 14.9zm-2.467-4.22l-.868 2.17h1.357l-.49-2.17z",
    fill: "#0066B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.001 10.498l.236-1.245S15.509 9 14.751 9c-.82 0-2.768.327-2.768 1.919 0 1.498 2.286 1.516 2.286 2.302 0 .787-2.05.646-2.727.15l-.245 1.301s.737.328 1.865.328c1.127 0 2.83-.534 2.83-1.984 0-1.508-2.307-1.648-2.307-2.303 0-.656 1.61-.571 2.316-.215zM10.278 14.9H8.627L9.66 9.104h1.653L10.278 14.9zM5.474 12.232l.187.858 1.575-3.986h1.779L6.385 14.9H4.665L3.229 9.864A6.532 6.532 0 001.5 9.202l.03-.098h1.303l2.641 3.128z",
    fill: "#0066B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 12l-.525-2.5s-.063-.5-.74-.5H1.53l-.029.094s1.181.227 2.314 1.078C4.897 10.986 5.25 12 5.25 12z",
    fill: "#F9A533"
  })));
}

var css_248z$l = ".InputPayment_inputPayment__llkT8 input {\n  text-indent: 32px;\n}\n\n.InputPayment_icon__-2ZdF {\n  height: 24px !important;\n  position: relative;\n  width: 24px !important;\n}";
var styles$l = {"inputPayment":"InputPayment_inputPayment__llkT8","icon":"InputPayment_icon__-2ZdF"};
styleInject(css_248z$l);

// Generated with util/create-component.js
var getCardType = function (card) {
    if (card === null || card === void 0 ? void 0 : card.startsWith('4'))
        return 1; // visa
    if (card && /^5[1-4]/.test(card))
        return 2; // mastercard
    if ((card === null || card === void 0 ? void 0 : card.startsWith('34')) || (card === null || card === void 0 ? void 0 : card.startsWith('37')))
        return 3; // Amex
    if (card === null || card === void 0 ? void 0 : card.startsWith('6011'))
        return 4; // Discover
    return 0;
};
var getCardTypeIcon = function (card) {
    var cardType = getCardType(card);
    switch (cardType) {
        case 1:
            return React__default.createElement(SvgIconVisa24, { className: styles$l.icon });
        case 2:
            return React__default.createElement(SvgIconMastercard24, { className: styles$l.icon });
        case 3:
            return React__default.createElement(SvgIconAmericanExpress24, { className: styles$l.icon });
        case 4:
            return React__default.createElement(SvgIconDiscover24, { className: styles$l.icon });
        default:
            return React__default.createElement(SvgIconCreditCard24, { className: styles$l.icon });
    }
};
function InputPayment(_a) {
    var errorText = _a.errorText, helpText = _a.helpText, label = _a.label, _b = _a.onChange, onChange = _b === void 0 ? function () { } : _b, placeholder = _a.placeholder, platform = _a.platform, value = _a.value;
    var _c = useState(value), newValue = _c[0], setNewValue = _c[1];
    var isMounted = useRef(false);
    // side effects for when value changes
    useEffect(function () {
        if (isMounted.current) {
            onChange(newValue || '');
        }
        else {
            isMounted.current = true;
        }
    }, [newValue]);
    return (React__default.createElement(Input, { className: styles$l.inputPayment, errorText: errorText, helpText: helpText, icon: getCardTypeIcon(newValue), id: "payment", label: label || 'Card Number', name: "payment", onChange: setNewValue, placeholder: placeholder, platform: platform, type: "number", value: newValue }));
}

// Generated with util/create-component.js
function InputPromo(_a) {
    var errorText = _a.errorText, helpText = _a.helpText, onChange = _a.onChange, onClick = _a.onClick, platform = _a.platform, value = _a.value;
    var link = {
        label: 'Apply',
        onClick: onClick
    };
    return (React__default.createElement(Input, { errorText: errorText, helpText: helpText, id: "promo", label: "Promo", link: link, name: "promo", onChange: onChange, platform: platform, value: value }));
}

var _path$c, _path2$8;
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
function SvgIconSearch16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 9.793l4.354 4.354a.5.5 0 01-.708.707L9.793 10.5l.707-.707z",
    fill: "#1F1F1F"
  })), _path2$8 || (_path2$8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 2a4.5 4.5 0 100 9 4.5 4.5 0 000-9zM1 6.5a5.5 5.5 0 1111 0 5.5 5.5 0 01-11 0z",
    fill: "#1F1F1F"
  })));
}

var css_248z$k = ".InputSearch_inputSearch__5Y2pM input {\n  background-color: #f5f4f1;\n  border-color: #f5f4f1;\n  border-radius: 28px;\n  text-indent: 26px;\n}\n.InputSearch_inputSearch__5Y2pM input.InputSearch_simple__WtOT- {\n  background-color: transparent;\n  border: none;\n}\n.InputSearch_inputSearch__5Y2pM input.InputSearch_simple__WtOT-[disabled] {\n  color: #b2afa4;\n}\n.InputSearch_inputSearch__5Y2pM input.InputSearch_themed__3jHXB {\n  background-color: #f2f2f2;\n  border-color: #f2f2f2;\n}\n.InputSearch_inputSearch__5Y2pM input.InputSearch_themed__3jHXB.InputSearch_simple__WtOT-[disabled] {\n  background-color: transparent;\n  border: none;\n  color: #a3a3a3;\n}\n\n.InputSearch_iconDisabled__hw-uW path {\n  fill: #a3a3a3;\n}\n\n.InputSearch_themed__3jHXB.InputSearch_iconDisabled__hw-uW path {\n  fill: #a3a3a3;\n}";
var styles$k = {"inputSearch":"InputSearch_inputSearch__5Y2pM","simple":"InputSearch_simple__WtOT-","themed":"InputSearch_themed__3jHXB","iconDisabled":"InputSearch_iconDisabled__hw-uW"};
styleInject(css_248z$k);

var InputSearch = function (_a) {
    var _b, _c, _d;
    var disabled = _a.disabled, helpText = _a.helpText, _e = _a.label, label = _e === void 0 ? 'Search' : _e, onChange = _a.onChange, onKeyDown = _a.onKeyDown, placeholder = _a.placeholder, platform = _a.platform, _f = _a.isSimple, isSimple = _f === void 0 ? false : _f, value = _a.value;
    var isThemed = platform === 'themed';
    return (React__default.createElement(Input, { className: classNames(styles$k.inputSearch, (_b = {}, _b[styles$k.simple] = isSimple, _b), (_c = {}, _c[styles$k.themed] = isThemed, _c)), helpText: helpText, icon: React__default.createElement(SvgIconSearch16, { className: classNames((_d = {},
                _d[styles$k.iconDisabled] = disabled,
                _d[styles$k.themed] = isThemed,
                _d)) }), id: "search", label: label, name: "search", onChange: onChange, onKeyDown: onKeyDown, placeholder: placeholder, platform: platform, disabled: disabled, shouldHideLabel: true, value: value }));
};

var css_248z$j = "@-webkit-keyframes LoadingSpinner_rotation__qphOd {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes LoadingSpinner_rotation__qphOd {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n.LoadingSpinner_spinner__STthc {\n  -webkit-animation: LoadingSpinner_rotation__qphOd 0.75s infinite linear;\n  -o-animation: LoadingSpinner_rotation__qphOd 0.75s infinite linear;\n  animation: LoadingSpinner_rotation__qphOd 0.75s infinite linear;\n  border: 1px solid;\n  border-color: #142138 rgba(20, 33, 56, 0.24) rgba(20, 33, 56, 0.24);\n  border-radius: 50%;\n  display: block;\n  position: relative;\n}\n\n.LoadingSpinner_themed__tfFyD {\n  border-color: #008854 rgba(0, 0, 0, 0.24) rgba(0, 0, 0, 0.24);\n}\n\n.LoadingSpinner_centered__zqojo {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  margin: auto;\n  z-index: 10;\n}\n\n.LoadingSpinner_small__mjHVK {\n  height: 16px;\n  width: 16px;\n}\n\n.LoadingSpinner_medium__O-y89 {\n  height: 24px;\n  width: 24px;\n}\n\n.LoadingSpinner_large__eRk6c {\n  height: 32px;\n  width: 32px;\n}\n\n.LoadingSpinner_x-large__ZazYc {\n  height: 40px;\n  width: 40px;\n  border-width: 4px;\n}\n\n.LoadingSpinner_overLayActive__92IpP {\n  background: rgba(255, 255, 255, 0.7);\n  height: 100%;\n  left: 0;\n  overflow: hidden;\n  padding: 10px;\n  z-index: 50;\n  box-sizing: border-box;\n  top: 0;\n  width: 100%;\n  position: absolute;\n}";
var styles$j = {"spinner":"LoadingSpinner_spinner__STthc","rotation":"LoadingSpinner_rotation__qphOd","themed":"LoadingSpinner_themed__tfFyD","centered":"LoadingSpinner_centered__zqojo","small":"LoadingSpinner_small__mjHVK","medium":"LoadingSpinner_medium__O-y89","large":"LoadingSpinner_large__eRk6c","x-large":"LoadingSpinner_x-large__ZazYc","overLayActive":"LoadingSpinner_overLayActive__92IpP"};
styleInject(css_248z$j);

function LoadingSpinner(_a) {
    var _b, _c;
    var _d = _a.isCentered, isCentered = _d === void 0 ? false : _d, isWhite = _a.isWhite, _e = _a.overlay, overlay = _e === void 0 ? false : _e, _f = _a.platform, platform = _f === void 0 ? 'brand' : _f, _g = _a.size, size = _g === void 0 ? 'medium' : _g;
    return (React__default.createElement("div", { className: classNames(styles$j.spinnerOverlay, (_b = {},
            _b[styles$j.overLayActive] = overlay,
            _b)) },
        React__default.createElement("div", { "data-testid": "LoadingSpinner", className: classNames(styles$j.spinner, styles$j[platform], styles$j[size], (_c = {},
                _c[styles$j.centered] = isCentered,
                _c[styles$j.white] = isWhite,
                _c)) })));
}

var css_248z$i = ".MapGrid_container__LUIR2 {\n  display: flex;\n  flex-direction: column;\n}\n\n.MapGrid_fixed__NpT44 {\n  padding: 0 16px;\n  flex-basis: 368px;\n}\n\n/* Medium devices and above (tablet, 768px and up) */\n@media (min-width: 768px) {\n  .MapGrid_container__LUIR2 {\n    flex-direction: row;\n  }\n\n  .MapGrid_fixed__NpT44 {\n    padding: 0 24px;\n    flex-basis: 352px;\n  }\n\n  .MapGrid_map__JLcYb {\n    flex-grow: 1;\n  }\n}";
var styles$i = {"container":"MapGrid_container__LUIR2","fixed":"MapGrid_fixed__NpT44","map":"MapGrid_map__JLcYb"};
styleInject(css_248z$i);

// Generated with util/create-component.js
// Map "Grid" component.
// There is a maximum of 2 columns in this layout. On mobile, there is one.
function MapGrid(_a) {
    var _b;
    var children = _a.children, _c = _a.className, className = _c === void 0 ? '' : _c, isContainer = _a.isContainer, isMap = _a.isMap;
    var classes = {
        wrapper: classNames(className, (_b = {},
            _b[styles$i.container] = isContainer,
            _b[styles$i.map] = isMap,
            _b[styles$i.fixed] = !isMap && !isContainer,
            _b))
    };
    return React__default.createElement("div", { className: classes.wrapper }, children);
}

var format = {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$d =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$e = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$d = fails$e;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$d(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$c = fails$e;

var functionBindNative = !fails$c(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$2 = functionBindNative;

var call$a = Function.prototype.call;

var functionCall = NATIVE_BIND$2 ? call$a.bind(call$a) : function () {
  return call$a.apply(call$a, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$2 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var bind = FunctionPrototype$2.bind;
var call$9 = FunctionPrototype$2.call;
var uncurryThis$g = NATIVE_BIND$1 && bind.bind(call$9, call$9);

var functionUncurryThis = NATIVE_BIND$1 ? function (fn) {
  return fn && uncurryThis$g(fn);
} : function (fn) {
  return fn && function () {
    return call$9.apply(fn, arguments);
  };
};

var uncurryThis$f = functionUncurryThis;

var toString$7 = uncurryThis$f({}.toString);
var stringSlice$5 = uncurryThis$f(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$5(toString$7(it), 8, -1);
};

var uncurryThis$e = functionUncurryThis;
var fails$b = fails$e;
var classof$3 = classofRaw$1;

var $Object$3 = Object;
var split = uncurryThis$e(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$b(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$3('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$3(it) == 'String' ? split(it, '') : $Object$3(it);
} : $Object$3;

var $TypeError$6 = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$6 = function (it) {
  if (it == undefined) throw $TypeError$6("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = indexedObject;
var requireObjectCoercible$5 = requireObjectCoercible$6;

var toIndexedObject$4 = function (it) {
  return IndexedObject(requireObjectCoercible$5(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$d = function (argument) {
  return typeof argument == 'function';
};

var isCallable$c = isCallable$d;

var isObject$5 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$c(it);
};

var global$c = global$d;
var isCallable$b = isCallable$d;

var aFunction = function (argument) {
  return isCallable$b(argument) ? argument : undefined;
};

var getBuiltIn$4 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$c[namespace]) : global$c[namespace] && global$c[namespace][method];
};

var uncurryThis$d = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$d({}.isPrototypeOf);

var getBuiltIn$3 = getBuiltIn$4;

var engineUserAgent = getBuiltIn$3('navigator', 'userAgent') || '';

var global$b = global$d;
var userAgent = engineUserAgent;

var process$1 = global$b.process;
var Deno = global$b.Deno;
var versions = process$1 && process$1.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es-x/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$a = fails$e;

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$a(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es-x/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$2 = getBuiltIn$4;
var isCallable$a = isCallable$d;
var isPrototypeOf = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$2 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$2('Symbol');
  return isCallable$a($Symbol) && isPrototypeOf($Symbol.prototype, $Object$2(it));
};

var $String$3 = String;

var tryToString$1 = function (argument) {
  try {
    return $String$3(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$9 = isCallable$d;
var tryToString = tryToString$1;

var $TypeError$5 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$1 = function (argument) {
  if (isCallable$9(argument)) return argument;
  throw $TypeError$5(tryToString(argument) + ' is not a function');
};

var aCallable = aCallable$1;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$3 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};

var call$8 = functionCall;
var isCallable$8 = isCallable$d;
var isObject$4 = isObject$5;

var $TypeError$4 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$8(fn = input.toString) && !isObject$4(val = call$8(fn, input))) return val;
  if (isCallable$8(fn = input.valueOf) && !isObject$4(val = call$8(fn, input))) return val;
  if (pref !== 'string' && isCallable$8(fn = input.toString) && !isObject$4(val = call$8(fn, input))) return val;
  throw $TypeError$4("Can't convert object to primitive value");
};

var shared$4 = {exports: {}};

var global$a = global$d;

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$1 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$1(global$a, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$a[key] = value;
  } return value;
};

var global$9 = global$d;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$9[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.24.1',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.24.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$4 = requireObjectCoercible$6;

var $Object$1 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$2 = function (argument) {
  return $Object$1(requireObjectCoercible$4(argument));
};

var uncurryThis$c = functionUncurryThis;
var toObject$1 = toObject$2;

var hasOwnProperty = uncurryThis$c({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$1(it), key);
};

var uncurryThis$b = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$6 = uncurryThis$b(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$6(++id + postfix, 36);
};

var global$8 = global$d;
var shared$3 = shared$4.exports;
var hasOwn$6 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$3('wks');
var Symbol$1 = global$8.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$5 = function (name) {
  if (!hasOwn$6(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn$6(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var call$7 = functionCall;
var isObject$3 = isObject$5;
var isSymbol$1 = isSymbol$2;
var getMethod$2 = getMethod$3;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$4 = wellKnownSymbol$5;

var $TypeError$3 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$4('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$3(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$2(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$7(exoticToPrim, input, pref);
    if (!isObject$3(result) || isSymbol$1(result)) return result;
    throw $TypeError$3("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$7 = global$d;
var isObject$2 = isObject$5;

var document$1 = global$7.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$2(document$1) && isObject$2(document$1.createElement);

var documentCreateElement$1 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$7 = descriptors;
var fails$9 = fails$e;
var createElement = documentCreateElement$1;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$7 && !fails$9(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$6 = descriptors;
var call$6 = functionCall;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var createPropertyDescriptor$1 = createPropertyDescriptor$2;
var toIndexedObject$3 = toIndexedObject$4;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$5 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$6 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$3(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$5(O, P)) return createPropertyDescriptor$1(!call$6(propertyIsEnumerableModule.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$5 = descriptors;
var fails$8 = fails$e;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$5 && fails$8(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var isObject$1 = isObject$5;

var $String$2 = String;
var $TypeError$2 = TypeError;

// `Assert: Type(argument) is Object`
var anObject$8 = function (argument) {
  if (isObject$1(argument)) return argument;
  throw $TypeError$2($String$2(argument) + ' is not an object');
};

var DESCRIPTORS$4 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$7 = anObject$8;
var toPropertyKey = toPropertyKey$2;

var $TypeError$1 = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$4 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$7(O);
  P = toPropertyKey(P);
  anObject$7(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$7(O);
  P = toPropertyKey(P);
  anObject$7(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$1('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$3 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$2;

var createNonEnumerableProperty$3 = DESCRIPTORS$3 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$2 = descriptors;
var hasOwn$4 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$4(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$2 || (DESCRIPTORS$2 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$a = functionUncurryThis;
var isCallable$7 = isCallable$d;
var store$1 = sharedStore;

var functionToString = uncurryThis$a(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$7(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$2 = store$1.inspectSource;

var global$6 = global$d;
var isCallable$6 = isCallable$d;
var inspectSource$1 = inspectSource$2;

var WeakMap$2 = global$6.WeakMap;

var nativeWeakMap = isCallable$6(WeakMap$2) && /native code/.test(inspectSource$1(WeakMap$2));

var shared$2 = shared$4.exports;
var uid = uid$2;

var keys = shared$2('keys');

var sharedKey$2 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$5 = global$d;
var uncurryThis$9 = functionUncurryThis;
var isObject = isObject$5;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$3;
var hasOwn$3 = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$1 = sharedKey$2;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$1 = global$5.TypeError;
var WeakMap$1 = global$5.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$1('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap$1());
  var wmget = uncurryThis$9(store.get);
  var wmhas = uncurryThis$9(store.has);
  var wmset = uncurryThis$9(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey$1('state');
  hiddenKeys$3[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$3(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$2(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$3(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$3(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var fails$7 = fails$e;
var isCallable$5 = isCallable$d;
var hasOwn$2 = hasOwnProperty_1;
var DESCRIPTORS$1 = descriptors;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var inspectSource = inspectSource$2;
var InternalStateModule = internalState;

var enforceInternalState = InternalStateModule.enforce;
var getInternalState$1 = InternalStateModule.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS$1 && !fails$7(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$2(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS$1) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$2(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$2(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$1) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$2(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$5(this) && getInternalState$1(this).source || inspectSource(this);
}, 'toString');

var isCallable$4 = isCallable$d;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn = makeBuiltIn$2.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$2 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$4(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$2.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$2 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$2 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$6 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$5 = toIntegerOrInfinity$6;

var max$1 = Math.max;
var min$2 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$5(index);
  return integer < 0 ? max$1(integer + length, 0) : min$2(integer, length);
};

var toIntegerOrInfinity$4 = toIntegerOrInfinity$6;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$3 = function (argument) {
  return argument > 0 ? min$1(toIntegerOrInfinity$4(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$2 = toLength$3;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$1 = function (obj) {
  return toLength$2(obj.length);
};

var toIndexedObject$2 = toIndexedObject$4;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike = lengthOfArrayLike$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$1 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$2($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$1(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$1(false)
};

var uncurryThis$8 = functionUncurryThis;
var hasOwn$1 = hasOwnProperty_1;
var toIndexedObject$1 = toIndexedObject$4;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$1 = uncurryThis$8([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$1(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$1(hiddenKeys$2, key) && hasOwn$1(O, key) && push$1(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$1(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$1(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$1 = getBuiltIn$4;
var uncurryThis$7 = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var anObject$6 = anObject$8;

var concat$1 = uncurryThis$7([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$6(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$6 = fails$e;
var isCallable$3 = isCallable$d;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$3(detection) ? fails$6(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$4 = global$d;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$3;
var defineBuiltIn$1 = defineBuiltIn$2;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$4;
  } else if (STATIC) {
    target = global$4[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$4[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$1(sourceProperty, 'sham', true);
    }
    defineBuiltIn$1(target, key, sourceProperty, options);
  }
};

var uncurryThis$6 = functionUncurryThis;

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
var thisNumberValue$1 = uncurryThis$6(1.0.valueOf);

var wellKnownSymbol$3 = wellKnownSymbol$5;

var TO_STRING_TAG$1 = wellKnownSymbol$3('toStringTag');
var test = {};

test[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$2 = isCallable$d;
var classofRaw = classofRaw$1;
var wellKnownSymbol$2 = wellKnownSymbol$5;

var TO_STRING_TAG = wellKnownSymbol$2('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$2 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$2(O.callee) ? 'Arguments' : result;
};

var classof$1 = classof$2;

var $String$1 = String;

var toString$5 = function (argument) {
  if (classof$1(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String$1(argument);
};

var toIntegerOrInfinity$3 = toIntegerOrInfinity$6;
var toString$4 = toString$5;
var requireObjectCoercible$3 = requireObjectCoercible$6;

var $RangeError$1 = RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
var stringRepeat = function repeat(count) {
  var str = toString$4(requireObjectCoercible$3(this));
  var result = '';
  var n = toIntegerOrInfinity$3(count);
  if (n < 0 || n == Infinity) throw $RangeError$1('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

var $$1 = _export;
var uncurryThis$5 = functionUncurryThis;
var toIntegerOrInfinity$2 = toIntegerOrInfinity$6;
var thisNumberValue = thisNumberValue$1;
var $repeat = stringRepeat;
var fails$5 = fails$e;

var $RangeError = RangeError;
var $String = String;
var floor$1 = Math.floor;
var repeat = uncurryThis$5($repeat);
var stringSlice$4 = uncurryThis$5(''.slice);
var un$ToFixed = uncurryThis$5(1.0.toFixed);

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor$1(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor$1(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = $String(data[index]);
      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED = fails$5(function () {
  return un$ToFixed(0.00008, 3) !== '0.000' ||
    un$ToFixed(0.9, 0) !== '1' ||
    un$ToFixed(1.255, 2) !== '1.25' ||
    un$ToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails$5(function () {
  // V8 ~ Android 4.3-
  un$ToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$$1({ target: 'Number', proto: true, forced: FORCED }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity$2(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw $RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return $String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat('0', fractDigits - k) + result
        : stringSlice$4(result, 0, k - fractDigits) + '.' + stringSlice$4(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});

var anObject$5 = anObject$8;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$5(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var fails$4 = fails$e;
var global$3 = global$d;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$3.RegExp;

var UNSUPPORTED_Y$1 = fails$4(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$1 || fails$4(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$1 || fails$4(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$1
};

var objectDefineProperties = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var objectKeys$1 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$4 = anObject$8;
var toIndexedObject = toIndexedObject$4;
var objectKeys = objectKeys$1;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$4(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn = getBuiltIn$4;

var html$1 = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var anObject$3 = anObject$8;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement = documentCreateElement$1;
var sharedKey = sharedKey$2;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$3(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var fails$3 = fails$e;
var global$2 = global$d;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$2.RegExp;

var regexpUnsupportedDotAll = fails$3(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

var fails$2 = fails$e;
var global$1 = global$d;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$1.RegExp;

var regexpUnsupportedNcg = fails$2(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$5 = functionCall;
var uncurryThis$4 = functionUncurryThis;
var toString$3 = toString$5;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4.exports;
var create = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$3 = uncurryThis$4(''.charAt);
var indexOf = uncurryThis$4(''.indexOf);
var replace$1 = uncurryThis$4(''.replace);
var stringSlice$3 = uncurryThis$4(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$5(nativeExec, re1, 'a');
  call$5(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$3(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$5(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$5(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$1(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$3(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$3(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$5(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$3(match.input, charsAdded);
        match[0] = stringSlice$3(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$5(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $ = _export;
var exec = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

var NATIVE_BIND = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$2 = FunctionPrototype.apply;
var call$4 = FunctionPrototype.call;

// eslint-disable-next-line es-x/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call$4.bind(apply$2) : function () {
  return call$4.apply(apply$2, arguments);
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var uncurryThis$3 = functionUncurryThis;
var defineBuiltIn = defineBuiltIn$2;
var regexpExec$1 = regexpExec$2;
var fails$1 = fails$e;
var wellKnownSymbol$1 = wellKnownSymbol$5;
var createNonEnumerableProperty = createNonEnumerableProperty$3;

var SPECIES = wellKnownSymbol$1('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$1(KEY);

  var DELEGATES_TO_SYMBOL = !fails$1(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$1(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis$3(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis$3(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

var uncurryThis$2 = functionUncurryThis;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$6;
var toString$2 = toString$5;
var requireObjectCoercible$2 = requireObjectCoercible$6;

var charAt$2 = uncurryThis$2(''.charAt);
var charCodeAt = uncurryThis$2(''.charCodeAt);
var stringSlice$2 = uncurryThis$2(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$2(requireObjectCoercible$2($this));
    var position = toIntegerOrInfinity$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$2(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$2(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

var charAt$1 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$2 = function (S, index, unicode) {
  return index + (unicode ? charAt$1(S, index).length : 1);
};

var uncurryThis$1 = functionUncurryThis;
var toObject = toObject$2;

var floor = Math.floor;
var charAt = uncurryThis$1(''.charAt);
var replace = uncurryThis$1(''.replace);
var stringSlice$1 = uncurryThis$1(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$1(str, 0, position);
      case "'": return stringSlice$1(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$1(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var call$3 = functionCall;
var anObject$2 = anObject$8;
var isCallable$1 = isCallable$d;
var classof = classofRaw$1;
var regexpExec = regexpExec$2;

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$1(exec)) {
    var result = call$3(exec, R, S);
    if (result !== null) anObject$2(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call$3(regexpExec, R, S);
  throw $TypeError('RegExp#exec called on incompatible receiver');
};

var apply$1 = functionApply;
var call$2 = functionCall;
var uncurryThis = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var fails = fails$e;
var anObject$1 = anObject$8;
var isCallable = isCallable$d;
var toIntegerOrInfinity = toIntegerOrInfinity$6;
var toLength$1 = toLength$3;
var toString$1 = toString$5;
var requireObjectCoercible$1 = requireObjectCoercible$6;
var advanceStringIndex$1 = advanceStringIndex$2;
var getMethod$1 = getMethod$3;
var getSubstitution = getSubstitution$1;
var regExpExec$1 = regexpExecAbstract;
var wellKnownSymbol = wellKnownSymbol$5;

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic$1('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$1(this);
      var replacer = searchValue == undefined ? undefined : getMethod$1(searchValue, REPLACE);
      return replacer
        ? call$2(replacer, searchValue, O, replaceValue)
        : call$2(nativeReplace, toString$1(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$1(this);
      var S = toString$1(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString$1(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec$1(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString$1(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex$1(S, toLength$1(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$1(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          var replacement = toString$1(apply$1(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var call$1 = functionCall;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject = anObject$8;
var toLength = toLength$3;
var toString = toString$5;
var requireObjectCoercible = requireObjectCoercible$6;
var getMethod = getMethod$3;
var advanceStringIndex = advanceStringIndex$2;
var regExpExec = regexpExecAbstract;

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : getMethod(regexp, MATCH);
      return matcher ? call$1(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

Object.defineProperty(format, "__esModule", {
  value: true
});
var formatMoney_1 = format.formatMoney = formatMoney;
format.prettifyPhoneNumber = prettifyPhoneNumber;
format.formatPhone = formatPhone;









function formatMoney(input) {
  if (input === null || typeof input !== 'number') return;
  return "$".concat(input.toFixed(2));
}

function prettifyPhoneNumber() {
  let phoneNumberString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const cleaned = "".concat(phoneNumberString.replace(/\D/g, ''));
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return "(".concat(match[1], ") ").concat(match[2], "-").concat(match[3]);
  }

  return null;
}

function formatPhone(value) {
  return value ? "(".concat(value.slice(0, 3), ") ").concat(value.slice(3, 6), "-").concat(value.slice(6, 10)) : '';
}

var _path$b;
function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
function SvgIconEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.221 1.146a.5.5 0 01.708 0l2.925 2.925a.5.5 0 010 .708L4.779 14.854a.5.5 0 01-.354.146H1.5a.5.5 0 01-.5-.5v-2.925a.5.5 0 01.146-.354L11.221 1.146zM2 11.782V14h2.218l8.112-8.113-2.217-2.217L2 11.782zm8.82-8.82l2.217 2.218.756-.755-2.218-2.218-.755.756z",
    fill: "#1F1F1F"
  })));
}

var _circle$1, _circle2, _circle3;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
function SvgIconMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$1 || (_circle$1 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.75,
    cy: 8,
    r: 1.25,
    fill: "#1F1F1F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.25,
    cy: 8,
    r: 1.25,
    fill: "#1F1F1F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.25,
    cy: 8,
    fill: "#1F1F1F",
    r: 1.25
  })));
}

var _path$a, _path2$7;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
function SvgIconPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8a.5.5 0 01.5-.5h13a.5.5 0 010 1h-13A.5.5 0 011 8z",
    fill: "#1F1F1F"
  })), _path2$7 || (_path2$7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1a.5.5 0 01.5.5v13a.5.5 0 11-1 0v-13A.5.5 0 018 1z",
    fill: "#1F1F1F"
  })));
}

var _path$9, _path2$6;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
function SvgIconArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.646 2.646a.5.5 0 01.708 0l5 5a.5.5 0 010 .708l-5 5a.5.5 0 01-.708-.708L13.293 8 8.646 3.354a.5.5 0 010-.708z",
    fill: "#142138"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 8a.5.5 0 01.5-.5h12a.5.5 0 010 1H2a.5.5 0 01-.5-.5z",
    fill: "#142138"
  })));
}

var css_248z$h = ".MenuSimple_menuSimpleBtn__opiJJ {\n  align-items: flex-start;\n  background-color: #fff;\n  border: 1px dashed transparent;\n  box-sizing: border-box;\n  color: #142138;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 16px;\n  width: 100%;\n}\n.MenuSimple_menuSimpleBtn__opiJJ p {\n  letter-spacing: 0.2px;\n}\n.MenuSimple_menuSimpleBtn__opiJJ svg path {\n  fill: #142138;\n}\n.MenuSimple_menuSimpleBtn__opiJJ.MenuSimple_selected__MsPUe {\n  background-color: #f5f4f1;\n}\n.MenuSimple_menuSimpleBtn__opiJJ[disabled] {\n  pointer-events: none;\n}\n.MenuSimple_menuSimpleBtn__opiJJ[disabled] p {\n  color: #b2afa4;\n}\n.MenuSimple_menuSimpleBtn__opiJJ[disabled] svg path {\n  fill: #dad8d2;\n}\n.MenuSimple_menuSimpleBtn__opiJJ:focus-visible {\n  outline: none;\n  background-color: #f5f4f1;\n  border: 1px dashed #142138;\n}\n.MenuSimple_menuSimpleBtn__opiJJ:active {\n  background-color: #f5f4f1;\n}\n\n.MenuSimple_contentWrapper__eaYFj {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: row;\n}\n.MenuSimple_contentWrapper__eaYFj > svg {\n  height: 16px;\n  margin-right: 8px;\n  width: 16px;\n}\n\n.MenuSimple_textWrapper__97T9d {\n  align-items: start;\n  display: flex;\n  flex-direction: column;\n  margin: 0 16px 0 0;\n}\n\n.MenuSimple_header__mqLOe {\n  font: 600 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  margin: 0;\n}\n\n.MenuSimple_subheader__M6n9z {\n  font: 400 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  margin: 4px 0 0 0;\n  text-align: left;\n}\n\n.MenuSimple_arrowIcon__BlEjV path {\n  fill: #142138;\n}\n\n.MenuSimple_themed__ven59 {\n  background-color: #fff;\n  color: #1f1f1f;\n}\n.MenuSimple_themed__ven59 svg path {\n  fill: #1f1f1f;\n}\n.MenuSimple_themed__ven59.MenuSimple_selected__MsPUe {\n  background-color: #e6f7ee;\n}\n.MenuSimple_themed__ven59[disabled] p {\n  color: #a3a3a3;\n}\n.MenuSimple_themed__ven59[disabled] svg path {\n  fill: #a3a3a3;\n}\n.MenuSimple_themed__ven59:focus-visible {\n  background-color: #f2f2f2;\n  border: 1px dashed #142138;\n}\n.MenuSimple_themed__ven59:active {\n  background-color: #f2f2f2;\n}\n.MenuSimple_themed__ven59 .MenuSimple_arrowIcon__BlEjV path {\n  fill: #1f1f1f;\n}\n\n.MenuSimple_yelp__TQv10 {\n  background-color: #fff;\n  color: #1f1f1f;\n}\n.MenuSimple_yelp__TQv10 svg path {\n  fill: #1f1f1f;\n}\n.MenuSimple_yelp__TQv10.MenuSimple_selected__MsPUe {\n  background-color: #fdedeb;\n}\n.MenuSimple_yelp__TQv10[disabled] p {\n  color: #a3a3a3;\n}\n.MenuSimple_yelp__TQv10[disabled] svg path {\n  fill: #a3a3a3;\n}\n.MenuSimple_yelp__TQv10:focus-visible {\n  background-color: #f2f2f2;\n  border: 1px dashed #142138;\n}\n.MenuSimple_yelp__TQv10:active {\n  background-color: #f2f2f2;\n}\n.MenuSimple_yelp__TQv10 .MenuSimple_arrowIcon__BlEjV path {\n  fill: #1f1f1f;\n}\n\n@media (min-width: 768px) {\n  .MenuSimple_menuSimpleBtn__opiJJ:hover {\n    background-color: #f5f4f1;\n  }\n\n  .MenuSimple_themed__ven59:hover {\n    background-color: #f2f2f2;\n  }\n\n  .MenuSimple_yelp__TQv10:hover {\n    background-color: #f2f2f2;\n  }\n}";
var styles$h = {"menuSimpleBtn":"MenuSimple_menuSimpleBtn__opiJJ","selected":"MenuSimple_selected__MsPUe","contentWrapper":"MenuSimple_contentWrapper__eaYFj","textWrapper":"MenuSimple_textWrapper__97T9d","header":"MenuSimple_header__mqLOe","subheader":"MenuSimple_subheader__M6n9z","arrowIcon":"MenuSimple_arrowIcon__BlEjV","themed":"MenuSimple_themed__ven59","yelp":"MenuSimple_yelp__TQv10"};
styleInject(css_248z$h);

var MenuSimple = function (_a) {
    var _b;
    var _c = _a.dataTestId, dataTestId = _c === void 0 ? '' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, handleClick = _a.handleClick, Icon = _a.icon, label = _a.label, _e = _a.platform, platform = _e === void 0 ? 'brand' : _e, _f = _a.showArrow, showArrow = _f === void 0 ? false : _f, _g = _a.subhead, subhead = _g === void 0 ? '' : _g, _h = _a.selected, selected = _h === void 0 ? false : _h;
    return (React__default.createElement("button", { className: classNames(styles$h.menuSimpleBtn, styles$h[platform], (_b = {}, _b[styles$h.selected] = selected, _b)), disabled: disabled, onClick: handleClick, type: "button", "data-testid": dataTestId },
        React__default.createElement("div", { className: styles$h.contentWrapper },
            Icon && React__default.createElement(Icon, null),
            React__default.createElement("div", { className: styles$h.textWrapper },
                React__default.createElement("p", { className: styles$h.header }, label),
                subhead && React__default.createElement("p", { className: styles$h.subheader }, subhead))),
        showArrow && React__default.createElement(SvgIconArrowRight, { className: styles$h.arrowIcon })));
};

var css_248z$g = ".MenuCard_menuItem__IpE7J {\n  border-radius: 16px;\n  border: 1px solid #dad8d2;\n  display: flex;\n  position: relative;\n}\n\n.MenuCard_details__Ets7q {\n  display: block;\n  flex-direction: column;\n  justify-content: center;\n  padding: 24px 8px 24px 24px;\n  width: calc(100% - 168px);\n}\n\n.MenuCard_name__TFliw {\n  color: #142138;\n  font: 600 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  margin: 0 0 8px 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.MenuCard_description__RkMlM {\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  color: #142138;\n  display: -webkit-box;\n  font: 400 14px/20px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  margin: 0 0 8px 0;\n  overflow: hidden;\n}\n\n.MenuCard_price__yS76d {\n  color: #142138;\n  font: 400 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  margin: 0;\n}\n\n.MenuCard_image__T7aXS {\n  border-radius: 16px;\n  display: inline-block;\n  height: 136px;\n  width: 136px;\n}\n\n.MenuCard_themed__MZMfW .MenuCard_name__TFliw {\n  color: #142138;\n}\n.MenuCard_themed__MZMfW .MenuCard_description__RkMlM {\n  color: #142138;\n}\n\n.MenuCard_buttonWrapper__vMODL {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  position: absolute;\n  right: 44px;\n}\n\n.MenuCard_menu__whfAs {\n  position: absolute;\n  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);\n  border-radius: 8px;\n  overflow: hidden;\n  z-index: 1;\n  right: 0;\n  top: 50%;\n  transform: translate(calc(100% - 32px), -50%);\n}";
var styles$g = {"menuItem":"MenuCard_menuItem__IpE7J","details":"MenuCard_details__Ets7q","name":"MenuCard_name__TFliw","description":"MenuCard_description__RkMlM","price":"MenuCard_price__yS76d","image":"MenuCard_image__T7aXS","themed":"MenuCard_themed__MZMfW","buttonWrapper":"MenuCard_buttonWrapper__vMODL","menu":"MenuCard_menu__whfAs"};
styleInject(css_248z$g);

var MenuCard = function (_a) {
    var item = _a.item, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.iconButtonType, iconButtonType = _c === void 0 ? 'Add' : _c, _d = _a.actionMenu, actionMenu = _d === void 0 ? {} : _d, _e = _a.onClick, onClick = _e === void 0 ? function () { } : _e;
    var _f = useState(false), showMenu = _f[0], setShowMenu = _f[1];
    var name = item.name, description = item.description, price = item.price, image = item.image;
    var icon = SvgIconPlus;
    if (iconButtonType !== 'Add') {
        icon = iconButtonType === 'Edit' ? SvgIconEdit : SvgIconMore;
    }
    var keys = Object.keys(actionMenu);
    var enableMenu = showMenu && actionMenu && keys.length;
    var iconClicked = function () {
        if (actionMenu) {
            setShowMenu(!showMenu);
        }
        onClick(item);
    };
    return (React__default.createElement("div", { className: classNames(styles$g.menuItem, className) },
        React__default.createElement("div", { className: styles$g.details },
            React__default.createElement("h4", { className: styles$g.name }, name),
            React__default.createElement("p", { className: styles$g.description },
                " ",
                description),
            React__default.createElement("p", { className: styles$g.price }, formatMoney_1(price))),
        React__default.createElement("div", { className: styles$g.buttonWrapper },
            React__default.createElement(Button, { size: "small", icon: icon, onClick: iconClicked, isInverse: !!image, variant: iconButtonType === 'Menu' ? 'outline' : 'fill' })),
        image && React__default.createElement("img", { src: image.cropped_url, className: styles$g.image, alt: "preview" }),
        enableMenu && (React__default.createElement("div", { className: styles$g.menu }, keys.map(function (key) { return (React__default.createElement(MenuSimple, { key: key, label: key, handleClick: function () { return actionMenu[key](item); } })); })))));
};

var css_248z$f = ".MenuPrimary_menuPrimaryBtn__7MptG {\n  align-items: center;\n  background-color: #fff;\n  border: 1px dashed transparent;\n  box-sizing: border-box;\n  color: #142138;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 24px 16px;\n  width: 100%;\n}\n.MenuPrimary_menuPrimaryBtn__7MptG p {\n  letter-spacing: 0.2px;\n}\n.MenuPrimary_menuPrimaryBtn__7MptG[disabled] {\n  pointer-events: none;\n}\n.MenuPrimary_menuPrimaryBtn__7MptG[disabled] p {\n  color: #b2afa4;\n}\n.MenuPrimary_menuPrimaryBtn__7MptG[disabled] svg path {\n  fill: #dad8d2;\n}\n.MenuPrimary_menuPrimaryBtn__7MptG:focus-visible {\n  outline: none;\n  background-color: #f5f4f1;\n  border: 1px dashed #142138;\n}\n.MenuPrimary_menuPrimaryBtn__7MptG:active {\n  background-color: #f5f4f1;\n}\n\n.MenuPrimary_iconWrapper__CEaTT {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.MenuPrimary_iconWrapper__CEaTT > svg {\n  height: 40px;\n  margin-right: 16px;\n  width: 40px;\n}\n\n.MenuPrimary_textWrapper__z0S-F {\n  align-items: start;\n  display: flex;\n  flex-direction: column;\n  margin: 0 16px 0 0;\n}\n\n.MenuPrimary_menuPrimaryLabel__5JVfe {\n  font: 400 16px/20px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  margin: 0;\n}\n.MenuPrimary_menuPrimaryLabel__5JVfe.MenuPrimary_header__a26-w {\n  font: 600 16px/20px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n.MenuPrimary_subheader__EML-P {\n  font: 400 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  margin: 4px 0 0 0;\n  text-align: left;\n}\n\n.MenuPrimary_arrowIcon__8txSf path {\n  fill: #142138;\n}\n\n.MenuPrimary_themed__Qztzc {\n  background-color: #fff;\n  color: #1f1f1f;\n}\n.MenuPrimary_themed__Qztzc[disabled] p {\n  color: #a3a3a3;\n}\n.MenuPrimary_themed__Qztzc[disabled] svg path {\n  fill: #a3a3a3;\n}\n.MenuPrimary_themed__Qztzc:focus-visible {\n  background-color: #f2f2f2;\n  border: 1px dashed #142138;\n}\n.MenuPrimary_themed__Qztzc:active {\n  background-color: #f2f2f2;\n}\n.MenuPrimary_themed__Qztzc .MenuPrimary_arrowIcon__8txSf path {\n  fill: #1f1f1f;\n}\n\n@media (min-width: 768px) {\n  .MenuPrimary_menuPrimaryBtn__7MptG:hover {\n    background-color: #f5f4f1;\n  }\n\n  .MenuPrimary_themed__Qztzc:hover {\n    background-color: #f2f2f2;\n  }\n}";
var styles$f = {"menuPrimaryBtn":"MenuPrimary_menuPrimaryBtn__7MptG","iconWrapper":"MenuPrimary_iconWrapper__CEaTT","textWrapper":"MenuPrimary_textWrapper__z0S-F","menuPrimaryLabel":"MenuPrimary_menuPrimaryLabel__5JVfe","header":"MenuPrimary_header__a26-w","subheader":"MenuPrimary_subheader__EML-P","arrowIcon":"MenuPrimary_arrowIcon__8txSf","themed":"MenuPrimary_themed__Qztzc"};
styleInject(css_248z$f);

var MenuPrimary = function (_a) {
    var _b;
    var _c = _a.disabled, disabled = _c === void 0 ? false : _c, handleClick = _a.handleClick, Icon = _a.icon, label = _a.label, _d = _a.platform, platform = _d === void 0 ? 'brand' : _d, _e = _a.showArrow, showArrow = _e === void 0 ? false : _e, _f = _a.subhead, subhead = _f === void 0 ? '' : _f;
    return (React__default.createElement("button", { className: classNames(styles$f.menuPrimaryBtn, styles$f[platform]), disabled: disabled, onClick: handleClick, type: "button" },
        React__default.createElement("div", { className: styles$f.iconWrapper },
            Icon && React__default.createElement(Icon, null),
            React__default.createElement("div", { className: styles$f.textWrapper },
                React__default.createElement("p", { className: classNames(styles$f.menuPrimaryLabel, (_b = {},
                        _b[styles$f.header] = subhead,
                        _b)) }, label),
                subhead && React__default.createElement("p", { className: styles$f.subheader }, subhead))),
        showArrow && React__default.createElement(SvgIconArrowRight, { className: styles$f.arrowIcon })));
};

var css_248z$e = ".Modal_modalWrapper__7-H0D {\n  border-radius: 16px;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.Modal_modal__TquHL {\n  background-color: #fff;\n  box-sizing: border-box;\n  color: #142138;\n  font: 400 14px/20px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  height: 100vh;\n  overflow: scroll;\n  padding: 56px 16px 40px;\n  width: 100vw;\n}\n.Modal_modal__TquHL.Modal_center__N3OrQ {\n  text-align: center;\n}\n\n.Modal_iconWrapper__V4u4A {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  position: absolute;\n  right: 8px;\n  top: 8px;\n}\n\n.Modal_iconClose__RNk54 path {\n  fill: #142138;\n}\n\n.Modal_themed__VRMJF .Modal_modal__TquHL {\n  background-color: #fff;\n  color: #1f1f1f;\n}\n.Modal_themed__VRMJF .Modal_iconClose__RNk54 path {\n  fill: #1f1f1f;\n}\n\n.Modal_yelp__bc25M .Modal_modal__TquHL {\n  background-color: #fff;\n  color: #1f1f1f;\n}\n.Modal_yelp__bc25M .Modal_iconClose__RNk54 path {\n  fill: #1f1f1f;\n}\n\n/* Small devices and above (tablet, 768px and up) */\n@media (min-width: 768px) {\n  .Modal_modal__TquHL {\n    border-radius: 16px;\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);\n    height: auto;\n    max-height: calc(100vh - 160px);\n    max-width: 460px;\n    padding: 56px 40px 40px;\n    width: calc(100vw - 32px);\n  }\n\n  .Modal_iconWrapper__V4u4A {\n    right: 16px;\n    top: 16px;\n  }\n}";
var styles$e = {"modalWrapper":"Modal_modalWrapper__7-H0D","modal":"Modal_modal__TquHL","center":"Modal_center__N3OrQ","iconWrapper":"Modal_iconWrapper__V4u4A","iconClose":"Modal_iconClose__RNk54","themed":"Modal_themed__VRMJF","yelp":"Modal_yelp__bc25M"};
styleInject(css_248z$e);

var Modal = function (_a) {
    var _b;
    var _c = _a.className, className = _c === void 0 ? '' : _c, children = _a.children, onModalClose = _a.onModalClose, _d = _a.platform, platform = _d === void 0 ? 'brand' : _d, centerAlign = _a.centerAlign;
    return (React__default.createElement("div", { className: classNames(styles$e.modalWrapper, className, styles$e[platform]) },
        React__default.createElement("button", { className: styles$e.iconWrapper, onClick: onModalClose },
            React__default.createElement(SvgIconClose24, { className: styles$e.iconClose, "data-testid": "Close" })),
        React__default.createElement("div", { className: classNames(styles$e.modal, (_b = {},
                _b[styles$e.center] = centerAlign,
                _b)) }, children)));
};

var css_248z$d = ".ModalFooter_modalfooter__9Y8Tq {\n  margin-top: 24px;\n}\n.ModalFooter_modalfooter__9Y8Tq.ModalFooter_fixed__VhGSl {\n  background-color: #fff;\n  bottom: 0;\n  box-shadow: 0px -1px 2px rgba(0, 0, 0, 0.16);\n  margin-left: -16px;\n  margin-right: -16px;\n  padding: 16px;\n  position: sticky;\n}\n.ModalFooter_modalfooter__9Y8Tq.ModalFooter_fixed__VhGSl .ModalFooter_secondaryButton__Qzfxi {\n  margin-top: 8px;\n}\n.ModalFooter_modalfooter__9Y8Tq.ModalFooter_horizontal__T8WeW {\n  display: flex;\n}\n.ModalFooter_modalfooter__9Y8Tq.ModalFooter_horizontal__T8WeW .ModalFooter_button__s-ere {\n  flex: 0 1 50%;\n  margin-right: 4px;\n}\n.ModalFooter_modalfooter__9Y8Tq.ModalFooter_horizontal__T8WeW .ModalFooter_secondaryButton__Qzfxi {\n  margin: 0 0 0 4px;\n}\n\n.ModalFooter_message__V3hex {\n  margin-bottom: 16px;\n}\n\n.ModalFooter_secondaryButton__Qzfxi {\n  margin-top: 16px;\n}\n\n.ModalFooter_themed__YEVtT.ModalFooter_fixed__VhGSl::before {\n  background-color: #dbdbdb;\n}\n\n.ModalFooter_yelp__BqWem.ModalFooter_fixed__VhGSl::before {\n  background-color: #dbdbdb;\n}\n\n/* Small devices and above (tablet, 768px and up) */\n@media (min-width: 768px) {\n  .ModalFooter_modalfooter__9Y8Tq.ModalFooter_fixed__VhGSl {\n    margin-left: -40px;\n    margin-right: -40px;\n  }\n}";
var styles$d = {"modalfooter":"ModalFooter_modalfooter__9Y8Tq","fixed":"ModalFooter_fixed__VhGSl","secondaryButton":"ModalFooter_secondaryButton__Qzfxi","horizontal":"ModalFooter_horizontal__T8WeW","button":"ModalFooter_button__s-ere","message":"ModalFooter_message__V3hex","themed":"ModalFooter_themed__YEVtT","yelp":"ModalFooter_yelp__BqWem"};
styleInject(css_248z$d);

var ModalFooter = function (_a) {
    var _b;
    var _c = _a.className, className = _c === void 0 ? '' : _c, buttonPrimary = _a.buttonPrimary, buttonSecondary = _a.buttonSecondary, message = _a.message, _d = _a.platform, platform = _d === void 0 ? 'brand' : _d, bottomFixed = _a.bottomFixed, horizontalAlign = _a.horizontalAlign;
    return (React__default.createElement("div", { className: classNames(styles$d.modalfooter, className, styles$d[platform], (_b = {},
            _b[styles$d.fixed] = bottomFixed,
            _b[styles$d.horizontal] = horizontalAlign,
            _b)) },
        !!message && React__default.createElement("div", { className: styles$d.message }, message),
        React__default.createElement("div", { className: styles$d.button }, buttonPrimary),
        !!buttonSecondary && (React__default.createElement("div", { className: classNames(styles$d.button, styles$d.secondaryButton) }, buttonSecondary))));
};

var css_248z$c = ".ModalFrame_modalFrameWrapper__McUFX {\n  left: 50%;\n  overflow: hidden;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.ModalFrame_modalFrame__FIEK6 {\n  background-color: #fff;\n  box-sizing: border-box;\n  color: #142138;\n  display: flex;\n  flex-direction: column;\n  font: 400 14px/20px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  height: 100vh;\n  overflow: scroll;\n  padding: 24px 16px 0;\n  width: 100vw;\n}\n.ModalFrame_modalFrame__FIEK6.ModalFrame_noFooter__HwCDw {\n  padding-bottom: 40px;\n}\n.ModalFrame_modalFrame__FIEK6 > :first-child {\n  margin-right: 40px;\n  padding-bottom: 24px;\n  position: relative;\n}\n.ModalFrame_modalFrame__FIEK6 > :first-child::after {\n  background-color: #dad8d2;\n  bottom: 0;\n  content: \"\";\n  height: 1px;\n  left: 0;\n  margin-left: -16px;\n  position: absolute;\n  width: 100vw;\n}\n\n.ModalFrame_iconWrapper__Xr1UC {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  position: absolute;\n  right: 16px;\n  top: 24px;\n  z-index: 2;\n}\n\n.ModalFrame_iconClose__pNh1g path {\n  fill: #142138;\n}\n\n.ModalFrame_themed__OqS7G .ModalFrame_modalFrame__FIEK6 {\n  background-color: #fff;\n  color: #1f1f1f;\n}\n.ModalFrame_themed__OqS7G .ModalFrame_modalFrame__FIEK6 > :first-child::after {\n  background-color: #dbdbdb;\n}\n.ModalFrame_themed__OqS7G .ModalFrame_iconClose__pNh1g path {\n  fill: #1f1f1f;\n}\n\n.ModalFrame_yelp__G2B26 .ModalFrame_modalFrame__FIEK6 {\n  background-color: #fff;\n  color: #1f1f1f;\n}\n.ModalFrame_yelp__G2B26 .ModalFrame_modalFrame__FIEK6 > :first-child::after {\n  background-color: #dbdbdb;\n}\n.ModalFrame_yelp__G2B26 .ModalFrame_iconClose__pNh1g path {\n  fill: #1f1f1f;\n}\n\n/* Small devices and above (tablet, 768px and up) */\n@media (min-width: 768px) {\n  .ModalFrame_modalFrameWrapper__McUFX {\n    border-radius: 16px;\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);\n  }\n\n  .ModalFrame_modalFrame__FIEK6 {\n    border-radius: 16px;\n    height: auto;\n    max-height: calc(100vh - 160px);\n    max-width: 460px;\n    padding: 24px 40px 0;\n    width: calc(100vw - 32px);\n  }\n  .ModalFrame_modalFrame__FIEK6.ModalFrame_noFooter__HwCDw {\n    padding-bottom: 40px;\n  }\n  .ModalFrame_modalFrame__FIEK6 > :first-child {\n    padding-bottom: 24px;\n    position: relative;\n  }\n  .ModalFrame_modalFrame__FIEK6 > :first-child::after {\n    margin-left: -40px;\n    width: calc(100% + 120px);\n  }\n\n  .ModalFrame_iconWrapper__Xr1UC {\n    right: 40px;\n    top: 24px;\n  }\n}";
var styles$c = {"modalFrameWrapper":"ModalFrame_modalFrameWrapper__McUFX","modalFrame":"ModalFrame_modalFrame__FIEK6","noFooter":"ModalFrame_noFooter__HwCDw","iconWrapper":"ModalFrame_iconWrapper__Xr1UC","iconClose":"ModalFrame_iconClose__pNh1g","themed":"ModalFrame_themed__OqS7G","yelp":"ModalFrame_yelp__G2B26"};
styleInject(css_248z$c);

var ModalFrame = function (_a) {
    var _b;
    var _c = _a.className, className = _c === void 0 ? '' : _c, children = _a.children, onModalClose = _a.onModalClose, _d = _a.platform, platform = _d === void 0 ? 'brand' : _d, noFooter = _a.noFooter;
    return (React__default.createElement("div", { className: classNames(styles$c.modalFrameWrapper, className, styles$c[platform]) },
        React__default.createElement("button", { className: styles$c.iconWrapper, onClick: onModalClose },
            React__default.createElement(SvgIconClose24, { className: styles$c.iconClose, "data-testid": "Close" })),
        React__default.createElement("div", { className: classNames(styles$c.modalFrame, (_b = {},
                _b[styles$c.noFooter] = noFooter,
                _b)) }, children)));
};

function _extends$b() {
  _extends$b = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$b.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const observerMap = new Map();
const RootIds = new WeakMap();
let rootId = 0;
let unsupportedValue = undefined;
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(key => options[key] !== undefined).map(key => {
    return `${key}_${key === 'root' ? getRootId(options.root) : options[key]}`;
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  let id = optionsToId(options);
  let instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    const elements = new Map();
    let thresholds;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        const inView = entry.isIntersecting && thresholds.some(threshold => entry.intersectionRatio >= threshold); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(callback => {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  const {
    id,
    observer,
    elements
  } = createObserver(options); // Register the callback listener for this element

  let callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements.delete(element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

const _excluded = ["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"];

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


class InView extends React.Component {
  constructor(props) {
    super(props);
    this.node = null;
    this._unobserveCb = null;

    this.handleNode = node => {
      if (this.node) {
        // Clear the old observer, before we start observing a new element
        this.unobserve();

        if (!node && !this.props.triggerOnce && !this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          this.setState({
            inView: !!this.props.initialInView,
            entry: undefined
          });
        }
      }

      this.node = node ? node : null;
      this.observeNode();
    };

    this.handleChange = (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        this.unobserve();
      }

      if (!isPlainChildren(this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        this.setState({
          inView,
          entry
        });
      }

      if (this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        this.props.onChange(inView, entry);
      }
    };

    this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
  }

  componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }

  componentWillUnmount() {
    this.unobserve();
    this.node = null;
  }

  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold,
      root,
      rootMargin,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
  }

  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  }

  render() {
    if (!isPlainChildren(this.props)) {
      const {
        inView,
        entry
      } = this.state;
      return this.props.children({
        inView,
        entry,
        ref: this.handleNode
      });
    }

    const _this$props = this.props,
          {
      children,
      as
    } = _this$props,
          props = _objectWithoutPropertiesLoose$1(_this$props, _excluded);

    return React.createElement(as || 'div', _extends$b({
      ref: this.handleNode
    }, props), children);
  }

}

function _extends$a() {
  _extends$a = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$a.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const is = {
  arr: Array.isArray,
  obj: a => Object.prototype.toString.call(a) === '[object Object]',
  fun: a => typeof a === 'function',
  str: a => typeof a === 'string',
  num: a => typeof a === 'number',
  und: a => a === void 0,
  nul: a => a === null,
  set: a => a instanceof Set,
  map: a => a instanceof Map,

  equ(a, b) {
    if (typeof a !== typeof b) return false;
    if (is.str(a) || is.num(a)) return a === b;
    if (is.obj(a) && is.obj(b) && Object.keys(a).length + Object.keys(b).length === 0) return true;
    let i;

    for (i in a) if (!(i in b)) return false;

    for (i in b) if (a[i] !== b[i]) return false;

    return is.und(i) ? a === b : true;
  }

};
function merge(target, lowercase) {
  if (lowercase === void 0) {
    lowercase = true;
  }

  return object => (is.arr(object) ? object : Object.keys(object)).reduce((acc, element) => {
    const key = lowercase ? element[0].toLowerCase() + element.substring(1) : element;
    acc[key] = target(key);
    return acc;
  }, target);
}
function useForceUpdate() {
  const _useState = useState(false),
        f = _useState[1];

  const forceUpdate = useCallback(() => f(v => !v), []);
  return forceUpdate;
}
function withDefault(value, defaultValue) {
  return is.und(value) || is.nul(value) ? defaultValue : value;
}
function toArray(a) {
  return !is.und(a) ? is.arr(a) ? a : [a] : [];
}
function callProp(obj) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return is.fun(obj) ? obj(...args) : obj;
}

function getForwardProps(props) {
  props.to;
        props.from;
        props.config;
        props.onStart;
        props.onRest;
        props.onFrame;
        props.children;
        props.reset;
        props.reverse;
        props.force;
        props.immediate;
        props.delay;
        props.attach;
        props.destroyed;
        props.interpolateTo;
        props.ref;
        props.lazy;
        const forward = _objectWithoutPropertiesLoose(props, ["to", "from", "config", "onStart", "onRest", "onFrame", "children", "reset", "reverse", "force", "immediate", "delay", "attach", "destroyed", "interpolateTo", "ref", "lazy"]);

  return forward;
}

function interpolateTo(props) {
  const forward = getForwardProps(props);
  if (is.und(forward)) return _extends$a({
    to: forward
  }, props);
  const rest = Object.keys(props).reduce((a, k) => !is.und(forward[k]) ? a : _extends$a({}, a, {
    [k]: props[k]
  }), {});
  return _extends$a({
    to: forward
  }, rest);
}
function handleRef(ref, forward) {
  if (forward) {
    // If it's a function, assume it's a ref callback
    if (is.fun(forward)) forward(ref);else if (is.obj(forward)) {
      forward.current = ref;
    }
  }

  return ref;
}

class Animated {
  constructor() {
    this.payload = void 0;
    this.children = [];
  }

  getAnimatedValue() {
    return this.getValue();
  }

  getPayload() {
    return this.payload || this;
  }

  attach() {}

  detach() {}

  getChildren() {
    return this.children;
  }

  addChild(child) {
    if (this.children.length === 0) this.attach();
    this.children.push(child);
  }

  removeChild(child) {
    const index = this.children.indexOf(child);
    this.children.splice(index, 1);
    if (this.children.length === 0) this.detach();
  }

}
class AnimatedArray extends Animated {
  constructor() {
    super(...arguments);
    this.payload = [];

    this.attach = () => this.payload.forEach(p => p instanceof Animated && p.addChild(this));

    this.detach = () => this.payload.forEach(p => p instanceof Animated && p.removeChild(this));
  }

}
class AnimatedObject extends Animated {
  constructor() {
    super(...arguments);
    this.payload = {};

    this.attach = () => Object.values(this.payload).forEach(s => s instanceof Animated && s.addChild(this));

    this.detach = () => Object.values(this.payload).forEach(s => s instanceof Animated && s.removeChild(this));
  }

  getValue(animated) {
    if (animated === void 0) {
      animated = false;
    }

    const payload = {};

    for (const key in this.payload) {
      const value = this.payload[key];
      if (animated && !(value instanceof Animated)) continue;
      payload[key] = value instanceof Animated ? value[animated ? 'getAnimatedValue' : 'getValue']() : value;
    }

    return payload;
  }

  getAnimatedValue() {
    return this.getValue(true);
  }

}

let applyAnimatedValues;
function injectApplyAnimatedValues(fn, transform) {
  applyAnimatedValues = {
    fn,
    transform
  };
}
let colorNames;
function injectColorNames(names) {
  colorNames = names;
}
let requestFrame = cb => typeof window !== 'undefined' ? window.requestAnimationFrame(cb) : -1;
let interpolation;
function injectStringInterpolator(fn) {
  interpolation = fn;
}
let now = () => Date.now();
let animatedApi = node => node.current;
let createAnimatedStyle;
function injectCreateAnimatedStyle(factory) {
  createAnimatedStyle = factory;
}

/**
 * Wraps the `style` property with `AnimatedStyle`.
 */

class AnimatedProps extends AnimatedObject {
  constructor(props, callback) {
    super();
    this.update = void 0;
    this.payload = !props.style ? props : _extends$a({}, props, {
      style: createAnimatedStyle(props.style)
    });
    this.update = callback;
    this.attach();
  }

}

const isFunctionComponent = val => is.fun(val) && !(val.prototype instanceof React__default.Component);

const createAnimatedComponent = Component => {
  const AnimatedComponent = forwardRef((props, ref) => {
    const forceUpdate = useForceUpdate();
    const mounted = useRef(true);
    const propsAnimated = useRef(null);
    const node = useRef(null);
    const attachProps = useCallback(props => {
      const oldPropsAnimated = propsAnimated.current;

      const callback = () => {
        let didUpdate = false;

        if (node.current) {
          didUpdate = applyAnimatedValues.fn(node.current, propsAnimated.current.getAnimatedValue());
        }

        if (!node.current || didUpdate === false) {
          // If no referenced node has been found, or the update target didn't have a
          // native-responder, then forceUpdate the animation ...
          forceUpdate();
        }
      };

      propsAnimated.current = new AnimatedProps(props, callback);
      oldPropsAnimated && oldPropsAnimated.detach();
    }, []);
    useEffect(() => () => {
      mounted.current = false;
      propsAnimated.current && propsAnimated.current.detach();
    }, []);
    useImperativeHandle(ref, () => animatedApi(node));
    attachProps(props);

    const _getValue = propsAnimated.current.getValue();
          _getValue.scrollTop;
          _getValue.scrollLeft;
          const animatedProps = _objectWithoutPropertiesLoose(_getValue, ["scrollTop", "scrollLeft"]); // Functions cannot have refs, see:
    // See: https://github.com/react-spring/react-spring/issues/569


    const refFn = isFunctionComponent(Component) ? undefined : childRef => node.current = handleRef(childRef, ref);
    return React__default.createElement(Component, _extends$a({}, animatedProps, {
      ref: refFn
    }));
  });
  return AnimatedComponent;
};

let active = false;
const controllers = new Set();

const update = () => {
  if (!active) return false;
  let time = now();

  for (let controller of controllers) {
    let isActive = false;

    for (let configIdx = 0; configIdx < controller.configs.length; configIdx++) {
      let config = controller.configs[configIdx];
      let endOfAnimation, lastTime;

      for (let valIdx = 0; valIdx < config.animatedValues.length; valIdx++) {
        let animation = config.animatedValues[valIdx]; // If an animation is done, skip, until all of them conclude

        if (animation.done) continue;
        let from = config.fromValues[valIdx];
        let to = config.toValues[valIdx];
        let position = animation.lastPosition;
        let isAnimated = to instanceof Animated;
        let velocity = Array.isArray(config.initialVelocity) ? config.initialVelocity[valIdx] : config.initialVelocity;
        if (isAnimated) to = to.getValue(); // Conclude animation if it's either immediate, or from-values match end-state

        if (config.immediate) {
          animation.setValue(to);
          animation.done = true;
          continue;
        } // Break animation when string values are involved


        if (typeof from === 'string' || typeof to === 'string') {
          animation.setValue(to);
          animation.done = true;
          continue;
        }

        if (config.duration !== void 0) {
          /** Duration easing */
          position = from + config.easing((time - animation.startTime) / config.duration) * (to - from);
          endOfAnimation = time >= animation.startTime + config.duration;
        } else if (config.decay) {
          /** Decay easing */
          position = from + velocity / (1 - 0.998) * (1 - Math.exp(-(1 - 0.998) * (time - animation.startTime)));
          endOfAnimation = Math.abs(animation.lastPosition - position) < 0.1;
          if (endOfAnimation) to = position;
        } else {
          /** Spring easing */
          lastTime = animation.lastTime !== void 0 ? animation.lastTime : time;
          velocity = animation.lastVelocity !== void 0 ? animation.lastVelocity : config.initialVelocity; // If we lost a lot of frames just jump to the end.

          if (time > lastTime + 64) lastTime = time; // http://gafferongames.com/game-physics/fix-your-timestep/

          let numSteps = Math.floor(time - lastTime);

          for (let i = 0; i < numSteps; ++i) {
            let force = -config.tension * (position - to);
            let damping = -config.friction * velocity;
            let acceleration = (force + damping) / config.mass;
            velocity = velocity + acceleration * 1 / 1000;
            position = position + velocity * 1 / 1000;
          } // Conditions for stopping the spring animation


          let isOvershooting = config.clamp && config.tension !== 0 ? from < to ? position > to : position < to : false;
          let isVelocity = Math.abs(velocity) <= config.precision;
          let isDisplacement = config.tension !== 0 ? Math.abs(to - position) <= config.precision : true;
          endOfAnimation = isOvershooting || isVelocity && isDisplacement;
          animation.lastVelocity = velocity;
          animation.lastTime = time;
        } // Trails aren't done until their parents conclude


        if (isAnimated && !config.toValues[valIdx].done) endOfAnimation = false;

        if (endOfAnimation) {
          // Ensure that we end up with a round value
          if (animation.value !== to) position = to;
          animation.done = true;
        } else isActive = true;

        animation.setValue(position);
        animation.lastPosition = position;
      } // Keep track of updated values only when necessary


      if (controller.props.onFrame) controller.values[config.name] = config.interpolation.getValue();
    } // Update callbacks in the end of the frame


    if (controller.props.onFrame) controller.props.onFrame(controller.values); // Either call onEnd or next frame

    if (!isActive) {
      controllers.delete(controller);
      controller.stop(true);
    }
  } // Loop over as long as there are controllers ...


  if (controllers.size) {
    requestFrame(update);
  } else {
    active = false;
  }

  return active;
};

const start = controller => {
  if (!controllers.has(controller)) controllers.add(controller);

  if (!active) {
    active = true;
    requestFrame(update);
  }
};

const stop = controller => {
  if (controllers.has(controller)) controllers.delete(controller);
};

function createInterpolator(range, output, extrapolate) {
  if (typeof range === 'function') {
    return range;
  }

  if (Array.isArray(range)) {
    return createInterpolator({
      range,
      output: output,
      extrapolate
    });
  }

  if (interpolation && typeof range.output[0] === 'string') {
    return interpolation(range);
  }

  const config = range;
  const outputRange = config.output;
  const inputRange = config.range || [0, 1];
  const extrapolateLeft = config.extrapolateLeft || config.extrapolate || 'extend';
  const extrapolateRight = config.extrapolateRight || config.extrapolate || 'extend';

  const easing = config.easing || (t => t);

  return input => {
    const range = findRange(input, inputRange);
    return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
  };
}

function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
  let result = map ? map(input) : input; // Extrapolate

  if (result < inputMin) {
    if (extrapolateLeft === 'identity') return result;else if (extrapolateLeft === 'clamp') result = inputMin;
  }

  if (result > inputMax) {
    if (extrapolateRight === 'identity') return result;else if (extrapolateRight === 'clamp') result = inputMax;
  }

  if (outputMin === outputMax) return outputMin;
  if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax; // Input Range

  if (inputMin === -Infinity) result = -result;else if (inputMax === Infinity) result = result - inputMin;else result = (result - inputMin) / (inputMax - inputMin); // Easing

  result = easing(result); // Output Range

  if (outputMin === -Infinity) result = -result;else if (outputMax === Infinity) result = result + outputMin;else result = result * (outputMax - outputMin) + outputMin;
  return result;
}

function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i) if (inputRange[i] >= input) break;

  return i - 1;
}

class AnimatedInterpolation extends AnimatedArray {
  constructor(parents, range, output, extrapolate) {
    super();
    this.calc = void 0;
    this.payload = parents instanceof AnimatedArray && !(parents instanceof AnimatedInterpolation) ? parents.getPayload() : Array.isArray(parents) ? parents : [parents];
    this.calc = createInterpolator(range, output, extrapolate);
  }

  getValue() {
    return this.calc(...this.payload.map(value => value.getValue()));
  }

  updateConfig(range, output, extrapolate) {
    this.calc = createInterpolator(range, output, extrapolate);
  }

  interpolate(range, output, extrapolate) {
    return new AnimatedInterpolation(this, range, output, extrapolate);
  }

}

/**
 * Animated works by building a directed acyclic graph of dependencies
 * transparently when you render your Animated components.
 *
 *               new Animated.Value(0)
 *     .interpolate()        .interpolate()    new Animated.Value(1)
 *         opacity               translateY      scale
 *          style                         transform
 *         View#234                         style
 *                                         View#123
 *
 * A) Top Down phase
 * When an AnimatedValue is updated, we recursively go down through this
 * graph in order to find leaf nodes: the views that we flag as needing
 * an update.
 *
 * B) Bottom Up phase
 * When a view is flagged as needing an update, we recursively go back up
 * in order to build the new value that it needs. The reason why we need
 * this two-phases process is to deal with composite props such as
 * transform which can receive values from multiple parents.
 */
function addAnimatedStyles(node, styles) {
  if ('update' in node) {
    styles.add(node);
  } else {
    node.getChildren().forEach(child => addAnimatedStyles(child, styles));
  }
}

class AnimatedValue extends Animated {
  constructor(_value) {
    var _this;

    super();
    _this = this;
    this.animatedStyles = new Set();
    this.value = void 0;
    this.startPosition = void 0;
    this.lastPosition = void 0;
    this.lastVelocity = void 0;
    this.startTime = void 0;
    this.lastTime = void 0;
    this.done = false;

    this.setValue = function (value, flush) {
      if (flush === void 0) {
        flush = true;
      }

      _this.value = value;
      if (flush) _this.flush();
    };

    this.value = _value;
    this.startPosition = _value;
    this.lastPosition = _value;
  }

  flush() {
    if (this.animatedStyles.size === 0) {
      addAnimatedStyles(this, this.animatedStyles);
    }

    this.animatedStyles.forEach(animatedStyle => animatedStyle.update());
  }

  clearStyles() {
    this.animatedStyles.clear();
  }

  getValue() {
    return this.value;
  }

  interpolate(range, output, extrapolate) {
    return new AnimatedInterpolation(this, range, output, extrapolate);
  }

}

class AnimatedValueArray extends AnimatedArray {
  constructor(values) {
    super();
    this.payload = values.map(n => new AnimatedValue(n));
  }

  setValue(value, flush) {
    if (flush === void 0) {
      flush = true;
    }

    if (Array.isArray(value)) {
      if (value.length === this.payload.length) {
        value.forEach((v, i) => this.payload[i].setValue(v, flush));
      }
    } else {
      this.payload.forEach(p => p.setValue(value, flush));
    }
  }

  getValue() {
    return this.payload.map(v => v.getValue());
  }

  interpolate(range, output) {
    return new AnimatedInterpolation(this, range, output);
  }

}

let G = 0;

class Controller {
  constructor() {
    this.id = void 0;
    this.idle = true;
    this.hasChanged = false;
    this.guid = 0;
    this.local = 0;
    this.props = {};
    this.merged = {};
    this.animations = {};
    this.interpolations = {};
    this.values = {};
    this.configs = [];
    this.listeners = [];
    this.queue = [];
    this.localQueue = void 0;

    this.getValues = () => this.interpolations;

    this.id = G++;
  }
  /** update(props)
   *  This function filters input props and creates an array of tasks which are executed in .start()
   *  Each task is allowed to carry a delay, which means it can execute asnychroneously */


  update(args) {
    //this._id = n + this.id
    if (!args) return this; // Extract delay and the to-prop from props

    const _ref = interpolateTo(args),
          _ref$delay = _ref.delay,
          delay = _ref$delay === void 0 ? 0 : _ref$delay,
          to = _ref.to,
          props = _objectWithoutPropertiesLoose(_ref, ["delay", "to"]);

    if (is.arr(to) || is.fun(to)) {
      // If config is either a function or an array queue it up as is
      this.queue.push(_extends$a({}, props, {
        delay,
        to
      }));
    } else if (to) {
      // Otherwise go through each key since it could be delayed individually
      let ops = {};
      Object.entries(to).forEach((_ref2) => {
        let k = _ref2[0],
            v = _ref2[1];

        // Fetch delay and create an entry, consisting of the to-props, the delay, and basic props
        const entry = _extends$a({
          to: {
            [k]: v
          },
          delay: callProp(delay, k)
        }, props);

        const previous = ops[entry.delay] && ops[entry.delay].to;
        ops[entry.delay] = _extends$a({}, ops[entry.delay], entry, {
          to: _extends$a({}, previous, entry.to)
        });
      });
      this.queue = Object.values(ops);
    } // Sort queue, so that async calls go last


    this.queue = this.queue.sort((a, b) => a.delay - b.delay); // Diff the reduced props immediately (they'll contain the from-prop and some config)

    this.diff(props);
    return this;
  }
  /** start(onEnd)
   *  This function either executes a queue, if present, or starts the frameloop, which animates */


  start(onEnd) {
    // If a queue is present we must excecute it
    if (this.queue.length) {
      this.idle = false; // Updates can interrupt trailing queues, in that case we just merge values

      if (this.localQueue) {
        this.localQueue.forEach((_ref3) => {
          let _ref3$from = _ref3.from,
              from = _ref3$from === void 0 ? {} : _ref3$from,
              _ref3$to = _ref3.to,
              to = _ref3$to === void 0 ? {} : _ref3$to;
          if (is.obj(from)) this.merged = _extends$a({}, from, this.merged);
          if (is.obj(to)) this.merged = _extends$a({}, this.merged, to);
        });
      } // The guid helps us tracking frames, a new queue over an old one means an override
      // We discard async calls in that caseÍ


      const local = this.local = ++this.guid;
      const queue = this.localQueue = this.queue;
      this.queue = []; // Go through each entry and execute it

      queue.forEach((_ref4, index) => {
        let delay = _ref4.delay,
            props = _objectWithoutPropertiesLoose(_ref4, ["delay"]);

        const cb = finished => {
          if (index === queue.length - 1 && local === this.guid && finished) {
            this.idle = true;
            if (this.props.onRest) this.props.onRest(this.merged);
          }

          if (onEnd) onEnd();
        }; // Entries can be delayed, ansyc or immediate


        let async = is.arr(props.to) || is.fun(props.to);

        if (delay) {
          setTimeout(() => {
            if (local === this.guid) {
              if (async) this.runAsync(props, cb);else this.diff(props).start(cb);
            }
          }, delay);
        } else if (async) this.runAsync(props, cb);else this.diff(props).start(cb);
      });
    } // Otherwise we kick of the frameloop
    else {
        if (is.fun(onEnd)) this.listeners.push(onEnd);
        if (this.props.onStart) this.props.onStart();
        start(this);
      }

    return this;
  }

  stop(finished) {
    this.listeners.forEach(onEnd => onEnd(finished));
    this.listeners = [];
    return this;
  }
  /** Pause sets onEnd listeners free, but also removes the controller from the frameloop */


  pause(finished) {
    this.stop(true);
    if (finished) stop(this);
    return this;
  }

  runAsync(_ref5, onEnd) {
    var _this = this;

    _ref5.delay;
        let props = _objectWithoutPropertiesLoose(_ref5, ["delay"]);

    const local = this.local; // If "to" is either a function or an array it will be processed async, therefor "to" should be empty right now
    // If the view relies on certain values "from" has to be present

    let queue = Promise.resolve(undefined);

    if (is.arr(props.to)) {
      for (let i = 0; i < props.to.length; i++) {
        const index = i;

        const fresh = _extends$a({}, props, interpolateTo(props.to[index]));

        if (is.arr(fresh.config)) fresh.config = fresh.config[index];
        queue = queue.then(() => {
          //this.stop()
          if (local === this.guid) return new Promise(r => this.diff(fresh).start(r));
        });
      }
    } else if (is.fun(props.to)) {
      let index = 0;
      let last;
      queue = queue.then(() => props.to( // next(props)
      p => {
        const fresh = _extends$a({}, props, interpolateTo(p));

        if (is.arr(fresh.config)) fresh.config = fresh.config[index];
        index++; //this.stop()

        if (local === this.guid) return last = new Promise(r => this.diff(fresh).start(r));
        return;
      }, // cancel()
      function (finished) {
        if (finished === void 0) {
          finished = true;
        }

        return _this.stop(finished);
      }).then(() => last));
    }

    queue.then(onEnd);
  }

  diff(props) {
    this.props = _extends$a({}, this.props, props);
    let _this$props = this.props,
        _this$props$from = _this$props.from,
        from = _this$props$from === void 0 ? {} : _this$props$from,
        _this$props$to = _this$props.to,
        to = _this$props$to === void 0 ? {} : _this$props$to,
        _this$props$config = _this$props.config,
        config = _this$props$config === void 0 ? {} : _this$props$config,
        reverse = _this$props.reverse,
        attach = _this$props.attach,
        reset = _this$props.reset,
        immediate = _this$props.immediate; // Reverse values when requested

    if (reverse) {
      var _ref6 = [to, from];
      from = _ref6[0];
      to = _ref6[1];
    } // This will collect all props that were ever set, reset merged props when necessary


    this.merged = _extends$a({}, from, this.merged, to);
    this.hasChanged = false; // Attachment handling, trailed springs can "attach" themselves to a previous spring

    let target = attach && attach(this); // Reduces input { name: value } pairs into animated values

    this.animations = Object.entries(this.merged).reduce((acc, _ref7) => {
      let name = _ref7[0],
          value = _ref7[1];
      // Issue cached entries, except on reset
      let entry = acc[name] || {}; // Figure out what the value is supposed to be

      const isNumber = is.num(value);
      const isString = is.str(value) && !value.startsWith('#') && !/\d/.test(value) && !colorNames[value];
      const isArray = is.arr(value);
      const isInterpolation = !isNumber && !isArray && !isString;
      let fromValue = !is.und(from[name]) ? from[name] : value;
      let toValue = isNumber || isArray ? value : isString ? value : 1;
      let toConfig = callProp(config, name);
      if (target) toValue = target.animations[name].parent;
      let parent = entry.parent,
          interpolation$$1 = entry.interpolation,
          toValues = toArray(target ? toValue.getPayload() : toValue),
          animatedValues;
      let newValue = value;
      if (isInterpolation) newValue = interpolation({
        range: [0, 1],
        output: [value, value]
      })(1);
      let currentValue = interpolation$$1 && interpolation$$1.getValue(); // Change detection flags

      const isFirst = is.und(parent);
      const isActive = !isFirst && entry.animatedValues.some(v => !v.done);
      const currentValueDiffersFromGoal = !is.equ(newValue, currentValue);
      const hasNewGoal = !is.equ(newValue, entry.previous);
      const hasNewConfig = !is.equ(toConfig, entry.config); // Change animation props when props indicate a new goal (new value differs from previous one)
      // and current values differ from it. Config changes trigger a new update as well (though probably shouldn't?)

      if (reset || hasNewGoal && currentValueDiffersFromGoal || hasNewConfig) {
        // Convert regular values into animated values, ALWAYS re-use if possible
        if (isNumber || isString) parent = interpolation$$1 = entry.parent || new AnimatedValue(fromValue);else if (isArray) parent = interpolation$$1 = entry.parent || new AnimatedValueArray(fromValue);else if (isInterpolation) {
          let prev = entry.interpolation && entry.interpolation.calc(entry.parent.value);
          prev = prev !== void 0 && !reset ? prev : fromValue;

          if (entry.parent) {
            parent = entry.parent;
            parent.setValue(0, false);
          } else parent = new AnimatedValue(0);

          const range = {
            output: [prev, value]
          };

          if (entry.interpolation) {
            interpolation$$1 = entry.interpolation;
            entry.interpolation.updateConfig(range);
          } else interpolation$$1 = parent.interpolate(range);
        }
        toValues = toArray(target ? toValue.getPayload() : toValue);
        animatedValues = toArray(parent.getPayload());
        if (reset && !isInterpolation) parent.setValue(fromValue, false);
        this.hasChanged = true; // Reset animated values

        animatedValues.forEach(value => {
          value.startPosition = value.value;
          value.lastPosition = value.value;
          value.lastVelocity = isActive ? value.lastVelocity : undefined;
          value.lastTime = isActive ? value.lastTime : undefined;
          value.startTime = now();
          value.done = false;
          value.animatedStyles.clear();
        }); // Set immediate values

        if (callProp(immediate, name)) {
          parent.setValue(isInterpolation ? toValue : value, false);
        }

        return _extends$a({}, acc, {
          [name]: _extends$a({}, entry, {
            name,
            parent,
            interpolation: interpolation$$1,
            animatedValues,
            toValues,
            previous: newValue,
            config: toConfig,
            fromValues: toArray(parent.getValue()),
            immediate: callProp(immediate, name),
            initialVelocity: withDefault(toConfig.velocity, 0),
            clamp: withDefault(toConfig.clamp, false),
            precision: withDefault(toConfig.precision, 0.01),
            tension: withDefault(toConfig.tension, 170),
            friction: withDefault(toConfig.friction, 26),
            mass: withDefault(toConfig.mass, 1),
            duration: toConfig.duration,
            easing: withDefault(toConfig.easing, t => t),
            decay: toConfig.decay
          })
        });
      } else {
        if (!currentValueDiffersFromGoal) {
          // So ... the current target value (newValue) appears to be different from the previous value,
          // which normally constitutes an update, but the actual value (currentValue) matches the target!
          // In order to resolve this without causing an animation update we silently flag the animation as done,
          // which it technically is. Interpolations also needs a config update with their target set to 1.
          if (isInterpolation) {
            parent.setValue(1, false);
            interpolation$$1.updateConfig({
              output: [newValue, newValue]
            });
          }

          parent.done = true;
          this.hasChanged = true;
          return _extends$a({}, acc, {
            [name]: _extends$a({}, acc[name], {
              previous: newValue
            })
          });
        }

        return acc;
      }
    }, this.animations);

    if (this.hasChanged) {
      // Make animations available to frameloop
      this.configs = Object.values(this.animations);
      this.values = {};
      this.interpolations = {};

      for (let key in this.animations) {
        this.interpolations[key] = this.animations[key].interpolation;
        this.values[key] = this.animations[key].interpolation.getValue();
      }
    }

    return this;
  }

  destroy() {
    this.stop();
    this.props = {};
    this.merged = {};
    this.animations = {};
    this.interpolations = {};
    this.values = {};
    this.configs = [];
    this.local = 0;
  }

}

/** API
 * const props = useSprings(number, [{ ... }, { ... }, ...])
 * const [props, set] = useSprings(number, (i, controller) => ({ ... }))
 */

const useSprings = (length, props) => {
  const mounted = useRef(false);
  const ctrl = useRef();
  const isFn = is.fun(props); // The controller maintains the animation values, starts and stops animations

  const _useMemo = useMemo(() => {
    // Remove old controllers
    if (ctrl.current) {
      ctrl.current.map(c => c.destroy());
      ctrl.current = undefined;
    }

    let ref;
    return [new Array(length).fill().map((_, i) => {
      const ctrl = new Controller();
      const newProps = isFn ? callProp(props, i, ctrl) : props[i];
      if (i === 0) ref = newProps.ref;
      ctrl.update(newProps);
      if (!ref) ctrl.start();
      return ctrl;
    }), ref];
  }, [length]),
        controllers = _useMemo[0],
        ref = _useMemo[1];

  ctrl.current = controllers; // The hooks reference api gets defined here ...

  useImperativeHandle(ref, () => ({
    start: () => Promise.all(ctrl.current.map(c => new Promise(r => c.start(r)))),
    stop: finished => ctrl.current.forEach(c => c.stop(finished)),

    get controllers() {
      return ctrl.current;
    }

  })); // This function updates the controllers

  const updateCtrl = useMemo(() => updateProps => ctrl.current.map((c, i) => {
    c.update(isFn ? callProp(updateProps, i, c) : updateProps[i]);
    if (!ref) c.start();
  }), [length]); // Update controller if props aren't functional

  useEffect(() => {
    if (mounted.current) {
      if (!isFn) updateCtrl(props);
    } else if (!ref) ctrl.current.forEach(c => c.start());
  }); // Update mounted flag and destroy controller on unmount

  useEffect(() => (mounted.current = true, () => ctrl.current.forEach(c => c.destroy())), []); // Return animated props, or, anim-props + the update-setter above

  const propValues = ctrl.current.map(c => c.getValues());
  return isFn ? [propValues, updateCtrl, finished => ctrl.current.forEach(c => c.pause(finished))] : propValues;
};

/** API
 * const props = useSpring({ ... })
 * const [props, set] = useSpring(() => ({ ... }))
 */

const useSpring = props => {
  const isFn = is.fun(props);

  const _useSprings = useSprings(1, isFn ? props : [props]),
        result = _useSprings[0],
        set = _useSprings[1],
        pause = _useSprings[2];

  return isFn ? [result[0], set, pause] : result;
};

class AnimatedStyle extends AnimatedObject {
  constructor(style) {
    if (style === void 0) {
      style = {};
    }

    super();

    if (style.transform && !(style.transform instanceof Animated)) {
      style = applyAnimatedValues.transform(style);
    }

    this.payload = style;
  }

}

// http://www.w3.org/TR/css3-color/#svg-color
const colors = {
  transparent: 0x00000000,
  aliceblue: 0xf0f8ffff,
  antiquewhite: 0xfaebd7ff,
  aqua: 0x00ffffff,
  aquamarine: 0x7fffd4ff,
  azure: 0xf0ffffff,
  beige: 0xf5f5dcff,
  bisque: 0xffe4c4ff,
  black: 0x000000ff,
  blanchedalmond: 0xffebcdff,
  blue: 0x0000ffff,
  blueviolet: 0x8a2be2ff,
  brown: 0xa52a2aff,
  burlywood: 0xdeb887ff,
  burntsienna: 0xea7e5dff,
  cadetblue: 0x5f9ea0ff,
  chartreuse: 0x7fff00ff,
  chocolate: 0xd2691eff,
  coral: 0xff7f50ff,
  cornflowerblue: 0x6495edff,
  cornsilk: 0xfff8dcff,
  crimson: 0xdc143cff,
  cyan: 0x00ffffff,
  darkblue: 0x00008bff,
  darkcyan: 0x008b8bff,
  darkgoldenrod: 0xb8860bff,
  darkgray: 0xa9a9a9ff,
  darkgreen: 0x006400ff,
  darkgrey: 0xa9a9a9ff,
  darkkhaki: 0xbdb76bff,
  darkmagenta: 0x8b008bff,
  darkolivegreen: 0x556b2fff,
  darkorange: 0xff8c00ff,
  darkorchid: 0x9932ccff,
  darkred: 0x8b0000ff,
  darksalmon: 0xe9967aff,
  darkseagreen: 0x8fbc8fff,
  darkslateblue: 0x483d8bff,
  darkslategray: 0x2f4f4fff,
  darkslategrey: 0x2f4f4fff,
  darkturquoise: 0x00ced1ff,
  darkviolet: 0x9400d3ff,
  deeppink: 0xff1493ff,
  deepskyblue: 0x00bfffff,
  dimgray: 0x696969ff,
  dimgrey: 0x696969ff,
  dodgerblue: 0x1e90ffff,
  firebrick: 0xb22222ff,
  floralwhite: 0xfffaf0ff,
  forestgreen: 0x228b22ff,
  fuchsia: 0xff00ffff,
  gainsboro: 0xdcdcdcff,
  ghostwhite: 0xf8f8ffff,
  gold: 0xffd700ff,
  goldenrod: 0xdaa520ff,
  gray: 0x808080ff,
  green: 0x008000ff,
  greenyellow: 0xadff2fff,
  grey: 0x808080ff,
  honeydew: 0xf0fff0ff,
  hotpink: 0xff69b4ff,
  indianred: 0xcd5c5cff,
  indigo: 0x4b0082ff,
  ivory: 0xfffff0ff,
  khaki: 0xf0e68cff,
  lavender: 0xe6e6faff,
  lavenderblush: 0xfff0f5ff,
  lawngreen: 0x7cfc00ff,
  lemonchiffon: 0xfffacdff,
  lightblue: 0xadd8e6ff,
  lightcoral: 0xf08080ff,
  lightcyan: 0xe0ffffff,
  lightgoldenrodyellow: 0xfafad2ff,
  lightgray: 0xd3d3d3ff,
  lightgreen: 0x90ee90ff,
  lightgrey: 0xd3d3d3ff,
  lightpink: 0xffb6c1ff,
  lightsalmon: 0xffa07aff,
  lightseagreen: 0x20b2aaff,
  lightskyblue: 0x87cefaff,
  lightslategray: 0x778899ff,
  lightslategrey: 0x778899ff,
  lightsteelblue: 0xb0c4deff,
  lightyellow: 0xffffe0ff,
  lime: 0x00ff00ff,
  limegreen: 0x32cd32ff,
  linen: 0xfaf0e6ff,
  magenta: 0xff00ffff,
  maroon: 0x800000ff,
  mediumaquamarine: 0x66cdaaff,
  mediumblue: 0x0000cdff,
  mediumorchid: 0xba55d3ff,
  mediumpurple: 0x9370dbff,
  mediumseagreen: 0x3cb371ff,
  mediumslateblue: 0x7b68eeff,
  mediumspringgreen: 0x00fa9aff,
  mediumturquoise: 0x48d1ccff,
  mediumvioletred: 0xc71585ff,
  midnightblue: 0x191970ff,
  mintcream: 0xf5fffaff,
  mistyrose: 0xffe4e1ff,
  moccasin: 0xffe4b5ff,
  navajowhite: 0xffdeadff,
  navy: 0x000080ff,
  oldlace: 0xfdf5e6ff,
  olive: 0x808000ff,
  olivedrab: 0x6b8e23ff,
  orange: 0xffa500ff,
  orangered: 0xff4500ff,
  orchid: 0xda70d6ff,
  palegoldenrod: 0xeee8aaff,
  palegreen: 0x98fb98ff,
  paleturquoise: 0xafeeeeff,
  palevioletred: 0xdb7093ff,
  papayawhip: 0xffefd5ff,
  peachpuff: 0xffdab9ff,
  peru: 0xcd853fff,
  pink: 0xffc0cbff,
  plum: 0xdda0ddff,
  powderblue: 0xb0e0e6ff,
  purple: 0x800080ff,
  rebeccapurple: 0x663399ff,
  red: 0xff0000ff,
  rosybrown: 0xbc8f8fff,
  royalblue: 0x4169e1ff,
  saddlebrown: 0x8b4513ff,
  salmon: 0xfa8072ff,
  sandybrown: 0xf4a460ff,
  seagreen: 0x2e8b57ff,
  seashell: 0xfff5eeff,
  sienna: 0xa0522dff,
  silver: 0xc0c0c0ff,
  skyblue: 0x87ceebff,
  slateblue: 0x6a5acdff,
  slategray: 0x708090ff,
  slategrey: 0x708090ff,
  snow: 0xfffafaff,
  springgreen: 0x00ff7fff,
  steelblue: 0x4682b4ff,
  tan: 0xd2b48cff,
  teal: 0x008080ff,
  thistle: 0xd8bfd8ff,
  tomato: 0xff6347ff,
  turquoise: 0x40e0d0ff,
  violet: 0xee82eeff,
  wheat: 0xf5deb3ff,
  white: 0xffffffff,
  whitesmoke: 0xf5f5f5ff,
  yellow: 0xffff00ff,
  yellowgreen: 0x9acd32ff
};

// const INTEGER = '[-+]?\\d+';
const NUMBER = '[-+]?\\d*\\.?\\d+';
const PERCENTAGE = NUMBER + '%';

function call() {
  for (var _len = arguments.length, parts = new Array(_len), _key = 0; _key < _len; _key++) {
    parts[_key] = arguments[_key];
  }

  return '\\(\\s*(' + parts.join(')\\s*,\\s*(') + ')\\s*\\)';
}

const rgb = new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER));
const rgba = new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER));
const hsl = new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE));
const hsla = new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
const hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex6 = /^#([0-9a-fA-F]{6})$/;
const hex8 = /^#([0-9a-fA-F]{8})$/;

/*
https://github.com/react-community/normalize-css-color

BSD 3-Clause License

Copyright (c) 2016, React Community
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this
  list of conditions and the following disclaimer.

* Redistributions in binary form must reproduce the above copyright notice,
  this list of conditions and the following disclaimer in the documentation
  and/or other materials provided with the distribution.

* Neither the name of the copyright holder nor the names of its
  contributors may be used to endorse or promote products derived from
  this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/
function normalizeColor(color) {
  let match;

  if (typeof color === 'number') {
    return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
  } // Ordered based on occurrences on Facebook codebase


  if (match = hex6.exec(color)) return parseInt(match[1] + 'ff', 16) >>> 0;
  if (colors.hasOwnProperty(color)) return colors[color];

  if (match = rgb.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    0x000000ff) >>> // a
    0;
  }

  if (match = rgba.exec(color)) {
    return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    parse1(match[4])) >>> // a
    0;
  }

  if (match = hex3.exec(color)) {
    return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    'ff', // a
    16) >>> 0;
  } // https://drafts.csswg.org/css-color-4/#hex-notation


  if (match = hex8.exec(color)) return parseInt(match[1], 16) >>> 0;

  if (match = hex4.exec(color)) {
    return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
  }

  if (match = hsl.exec(color)) {
    return (hslToRgb(parse360(match[1]), // h
    parsePercentage(match[2]), // s
    parsePercentage(match[3]) // l
    ) | 0x000000ff) >>> // a
    0;
  }

  if (match = hsla.exec(color)) {
    return (hslToRgb(parse360(match[1]), // h
    parsePercentage(match[2]), // s
    parsePercentage(match[3]) // l
    ) | parse1(match[4])) >>> // a
    0;
  }

  return null;
}

function hue2rgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}

function hslToRgb(h, s, l) {
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const r = hue2rgb(p, q, h + 1 / 3);
  const g = hue2rgb(p, q, h);
  const b = hue2rgb(p, q, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}

function parse255(str) {
  const int = parseInt(str, 10);
  if (int < 0) return 0;
  if (int > 255) return 255;
  return int;
}

function parse360(str) {
  const int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}

function parse1(str) {
  const num = parseFloat(str);
  if (num < 0) return 0;
  if (num > 1) return 255;
  return Math.round(num * 255);
}

function parsePercentage(str) {
  // parseFloat conveniently ignores the final %
  const int = parseFloat(str);
  if (int < 0) return 0;
  if (int > 100) return 1;
  return int / 100;
}

function colorToRgba(input) {
  let int32Color = normalizeColor(input);
  if (int32Color === null) return input;
  int32Color = int32Color || 0;
  let r = (int32Color & 0xff000000) >>> 24;
  let g = (int32Color & 0x00ff0000) >>> 16;
  let b = (int32Color & 0x0000ff00) >>> 8;
  let a = (int32Color & 0x000000ff) / 255;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
} // Problem: https://github.com/animatedjs/animated/pull/102
// Solution: https://stackoverflow.com/questions/638565/parsing-scientific-notation-sensibly/658662


const stringShapeRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g; // Covers rgb, rgba, hsl, hsla
// Taken from https://gist.github.com/olmokramer/82ccce673f86db7cda5e

const colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi; // Covers color names (transparent, blue, etc.)

const colorNamesRegex = new RegExp(`(${Object.keys(colors).join('|')})`, 'g');
/**
 * Supports string shapes by extracting numbers so new values can be computed,
 * and recombines those values into new strings of the same shape.  Supports
 * things like:
 *
 *   rgba(123, 42, 99, 0.36)           // colors
 *   -45deg                            // values with units
 *   0 2px 2px 0px rgba(0, 0, 0, 0.12) // box shadows
 */

const createStringInterpolator = config => {
  // Replace colors with rgba
  const outputRange = config.output.map(rangeValue => rangeValue.replace(colorRegex, colorToRgba)).map(rangeValue => rangeValue.replace(colorNamesRegex, colorToRgba));
  const outputRanges = outputRange[0].match(stringShapeRegex).map(() => []);
  outputRange.forEach(value => {
    value.match(stringShapeRegex).forEach((number, i) => outputRanges[i].push(+number));
  });
  const interpolations = outputRange[0].match(stringShapeRegex).map((_value, i) => createInterpolator(_extends$a({}, config, {
    output: outputRanges[i]
  })));
  return input => {
    let i = 0;
    return outputRange[0] // 'rgba(0, 100, 200, 0)'
    // ->
    // 'rgba(${interpolations[0](input)}, ${interpolations[1](input)}, ...'
    .replace(stringShapeRegex, () => interpolations[i++](input)) // rgba requires that the r,g,b are integers.... so we want to round them, but we *dont* want to
    // round the opacity (4th column).
    .replace(/rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, (_, p1, p2, p3, p4) => `rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`);
  };
};

let isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

const prefixKey = (prefix, key) => prefix + key.charAt(0).toUpperCase() + key.substring(1);

const prefixes = ['Webkit', 'Ms', 'Moz', 'O'];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop) => {
  prefixes.forEach(prefix => acc[prefixKey(prefix, prop)] = acc[prop]);
  return acc;
}, isUnitlessNumber);

function dangerousStyleValue(name, value, isCustomProperty) {
  if (value == null || typeof value === 'boolean' || value === '') return '';
  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers

  return ('' + value).trim();
}

const attributeCache = {};
injectCreateAnimatedStyle(style => new AnimatedStyle(style));
injectStringInterpolator(createStringInterpolator);
injectColorNames(colors);
injectApplyAnimatedValues((instance, props) => {
  if (instance.nodeType && instance.setAttribute !== undefined) {
    const style = props.style,
          children = props.children,
          scrollTop = props.scrollTop,
          scrollLeft = props.scrollLeft,
          attributes = _objectWithoutPropertiesLoose(props, ["style", "children", "scrollTop", "scrollLeft"]);

    const filter = instance.nodeName === 'filter' || instance.parentNode && instance.parentNode.nodeName === 'filter';
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft; // Set textContent, if children is an animatable value

    if (children !== void 0) instance.textContent = children; // Set styles ...

    for (let styleName in style) {
      if (!style.hasOwnProperty(styleName)) continue;
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = dangerousStyleValue(styleName, style[styleName], isCustomProperty);
      if (styleName === 'float') styleName = 'cssFloat';
      if (isCustomProperty) instance.style.setProperty(styleName, styleValue);else instance.style[styleName] = styleValue;
    } // Set attributes ...


    for (let name in attributes) {
      // Attributes are written in dash case
      const dashCase = filter ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, n => '-' + n.toLowerCase()));
      if (typeof instance.getAttribute(dashCase) !== 'undefined') instance.setAttribute(dashCase, attributes[name]);
    }

    return;
  } else return false;
}, style => style);

const domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
// Extend animated with all the available THREE elements
const apply = merge(createAnimatedComponent, false);
const extendedAnimated = apply(domElements);

var css_248z$b = ".ModalHeader_modalheader__tZF3E {\n  margin-bottom: 24px;\n}\n\n.ModalHeader_title__uAaKM {\n  font: 600 20px/24px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n.ModalHeader_title__uAaKM.ModalHeader_withSubtitle__RYkRJ {\n  margin-bottom: 8px;\n}\n\n.ModalHeader_subtitle__6zbu4 {\n  font: 400 14px/20px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n.ModalHeader_stickyHeader__X6Fle {\n  background-color: #fff;\n  border-bottom: solid 1px #dad8d2;\n  box-sizing: border-box;\n  display: none;\n  margin-left: -16px;\n  padding: 24px 40px 24px 16px;\n  position: fixed;\n  width: 100vw;\n  z-index: 1;\n}\n.ModalHeader_stickyHeader__X6Fle.ModalHeader_isVisible__tzZT4 {\n  display: block;\n}\n\n.ModalHeader_themed__qYWxR .ModalHeader_stickyHeader__X6Fle {\n  border-color: #dbdbdb;\n}\n\n.ModalHeader_yelp__CPDKl .ModalHeader_stickyHeader__X6Fle {\n  border-color: #dbdbdb;\n}\n\n/* Small devices and above (tablet, 768px and up) */\n@media (min-width: 768px) {\n  .ModalHeader_stickyHeader__X6Fle {\n    border-top-left-radius: 16px;\n    border-top-right-radius: 16px;\n    margin-left: -40px;\n    padding: 24px 40px;\n    width: 100%;\n  }\n}";
var styles$b = {"modalheader":"ModalHeader_modalheader__tZF3E","title":"ModalHeader_title__uAaKM","withSubtitle":"ModalHeader_withSubtitle__RYkRJ","subtitle":"ModalHeader_subtitle__6zbu4","stickyHeader":"ModalHeader_stickyHeader__X6Fle","isVisible":"ModalHeader_isVisible__tzZT4","themed":"ModalHeader_themed__qYWxR","yelp":"ModalHeader_yelp__CPDKl"};
styleInject(css_248z$b);

var ModalHeader = function (_a) {
    var _b, _c;
    var _d = _a.className, className = _d === void 0 ? '' : _d, title = _a.title, subtitle = _a.subtitle, _e = _a.platform, platform = _e === void 0 ? 'brand' : _e, _f = _a.isSticky, isSticky = _f === void 0 ? false : _f;
    var _g = useState(false), showStickyHeader = _g[0], setShowStickyHeader = _g[1];
    function handleIntersection(inView) {
        if (!isSticky)
            return;
        if (!inView) {
            setShowStickyHeader(true);
        }
        else {
            setShowStickyHeader(false);
        }
    }
    var defaultProps = { transform: 'translateY(-100%)' };
    var _h = useSpring(function () { return (__assign(__assign({}, defaultProps), { config: { tension: 350, friction: 32 } })); }), springProps = _h[0], set = _h[1];
    if (showStickyHeader) {
        set({ transform: 'translateY(-33%)' });
    }
    else {
        set(defaultProps);
    }
    return (React__default.createElement("div", { className: classNames(styles$b.modalheader, className, styles$b[platform]) },
        React__default.createElement(extendedAnimated.div, { className: classNames(styles$b.stickyHeader, (_b = {}, _b[styles$b.isVisible] = showStickyHeader, _b)), style: { transform: springProps.transform } },
            React__default.createElement("div", { className: styles$b.title }, title)),
        React__default.createElement(InView, { onChange: handleIntersection, threshold: 1 },
            title && (React__default.createElement("div", { className: classNames(styles$b.title, (_c = {}, _c[styles$b.withSubtitle] = !!subtitle, _c)) }, title)),
            subtitle && React__default.createElement("div", { className: styles$b.subtitle }, subtitle))));
};

var css_248z$a = "@-webkit-keyframes RadioButton_rotation__M2gyt {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes RadioButton_rotation__M2gyt {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n.RadioButton_radioButtonWrapper__lrU-r {\n  position: relative;\n}\n\n.RadioButton_radioButtonVisible__UJ-r3 {\n  align-items: center;\n  background-color: #fff;\n  border: 1px solid #dad8d2;\n  border-radius: 8px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: center;\n  padding: 16px;\n  top: 0;\n  width: 100%;\n}\n\n.RadioButton_icon__FlIx1 {\n  height: 32px;\n  width: 32px;\n}\n\n.RadioButton_swatch__ftkUK {\n  border-radius: 50%;\n  height: 24px;\n  width: 24px;\n}\n\n.RadioButton_label__jE2mA {\n  color: #142138;\n  font: 600 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  letter-spacing: 0.2px;\n  margin-top: 4px;\n  text-align: center;\n}\n\n.RadioButton_sublabel__zZ6Og {\n  color: #142138;\n  font: 400 12px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  margin-top: 4px;\n  text-align: center;\n}\n\n.RadioButton_noMargin__8lGoZ {\n  margin: 0;\n}\n\n.RadioButton_radioButtonInput__IlVjW {\n  cursor: pointer;\n  height: 100%;\n  left: 0;\n  margin: 0;\n  opacity: 0;\n  position: absolute;\n  width: 100%;\n  z-index: 1;\n}\n.RadioButton_radioButtonInput__IlVjW:checked + .RadioButton_radioButtonVisible__UJ-r3 {\n  border: 2px solid #142138;\n  padding: 15px;\n}\n.RadioButton_radioButtonInput__IlVjW:hover + .RadioButton_radioButtonVisible__UJ-r3 {\n  background-color: #f5f4f1;\n  border-color: #223ba8;\n}\n.RadioButton_radioButtonInput__IlVjW:focus + .RadioButton_radioButtonVisible__UJ-r3 {\n  outline: 1px dashed;\n  outline-offset: 1px;\n  outline-color: #142138;\n}\n.RadioButton_radioButtonInput__IlVjW:disabled + .RadioButton_radioButtonVisible__UJ-r3, .RadioButton_radioButtonInput__IlVjW:disabled:hover + .RadioButton_radioButtonVisible__UJ-r3 {\n  background-color: #f5f4f1;\n  border-color: #dad8d2;\n}\n.RadioButton_radioButtonInput__IlVjW:disabled + .RadioButton_radioButtonVisible__UJ-r3 .RadioButton_label__jE2mA,\n.RadioButton_radioButtonInput__IlVjW:disabled + .RadioButton_radioButtonVisible__UJ-r3 .RadioButton_sublabel__zZ6Og, .RadioButton_radioButtonInput__IlVjW:disabled:hover + .RadioButton_radioButtonVisible__UJ-r3 .RadioButton_label__jE2mA,\n.RadioButton_radioButtonInput__IlVjW:disabled:hover + .RadioButton_radioButtonVisible__UJ-r3 .RadioButton_sublabel__zZ6Og {\n  color: #6e6e6e;\n}\n.RadioButton_radioButtonInput__IlVjW.RadioButton_themed__PpD5- + .RadioButton_radioButtonVisible__UJ-r3 {\n  border-color: #dbdbdb;\n}\n.RadioButton_radioButtonInput__IlVjW.RadioButton_themed__PpD5- + .RadioButton_radioButtonVisible__UJ-r3 .RadioButton_label__jE2mA,\n.RadioButton_radioButtonInput__IlVjW.RadioButton_themed__PpD5- + .RadioButton_radioButtonVisible__UJ-r3 .RadioButton_sublabel__zZ6Og {\n  color: #1f1f1f;\n}\n.RadioButton_radioButtonInput__IlVjW.RadioButton_themed__PpD5-:checked + .RadioButton_radioButtonVisible__UJ-r3 {\n  border-color: #1f1f1f;\n}\n.RadioButton_radioButtonInput__IlVjW.RadioButton_themed__PpD5-:hover + .RadioButton_radioButtonVisible__UJ-r3 {\n  background-color: #f2f2f2;\n  border-color: #008854;\n}\n.RadioButton_radioButtonInput__IlVjW.RadioButton_themed__PpD5-:focus + .RadioButton_radioButtonVisible__UJ-r3 {\n  outline-color: #1f1f1f;\n}\n.RadioButton_radioButtonInput__IlVjW.RadioButton_themed__PpD5-:disabled + .RadioButton_radioButtonVisible__UJ-r3, .RadioButton_radioButtonInput__IlVjW.RadioButton_themed__PpD5-:disabled:hover + .RadioButton_radioButtonVisible__UJ-r3 {\n  background-color: #f2f2f2;\n  border-color: #dbdbdb;\n}\n.RadioButton_radioButtonInput__IlVjW.RadioButton_themed__PpD5-:disabled + .RadioButton_radioButtonVisible__UJ-r3 .RadioButton_label__jE2mA,\n.RadioButton_radioButtonInput__IlVjW.RadioButton_themed__PpD5-:disabled + .RadioButton_radioButtonVisible__UJ-r3 .RadioButton_sublabel__zZ6Og, .RadioButton_radioButtonInput__IlVjW.RadioButton_themed__PpD5-:disabled:hover + .RadioButton_radioButtonVisible__UJ-r3 .RadioButton_label__jE2mA,\n.RadioButton_radioButtonInput__IlVjW.RadioButton_themed__PpD5-:disabled:hover + .RadioButton_radioButtonVisible__UJ-r3 .RadioButton_sublabel__zZ6Og {\n  color: #6e6e6e;\n}\n.RadioButton_radioButtonInput__IlVjW.RadioButton_yelp__aotpX + .RadioButton_radioButtonVisible__UJ-r3 {\n  border-color: #dbdbdb;\n}\n.RadioButton_radioButtonInput__IlVjW.RadioButton_yelp__aotpX + .RadioButton_radioButtonVisible__UJ-r3 .RadioButton_label__jE2mA,\n.RadioButton_radioButtonInput__IlVjW.RadioButton_yelp__aotpX + .RadioButton_radioButtonVisible__UJ-r3 .RadioButton_sublabel__zZ6Og {\n  color: #1f1f1f;\n}\n.RadioButton_radioButtonInput__IlVjW.RadioButton_yelp__aotpX:checked + .RadioButton_radioButtonVisible__UJ-r3 {\n  border-color: #b91608;\n}\n.RadioButton_radioButtonInput__IlVjW.RadioButton_yelp__aotpX:hover + .RadioButton_radioButtonVisible__UJ-r3 {\n  background-color: #f2f2f2;\n  border-color: #b91608;\n}\n.RadioButton_radioButtonInput__IlVjW.RadioButton_yelp__aotpX:focus + .RadioButton_radioButtonVisible__UJ-r3 {\n  outline-color: #1f1f1f;\n}\n.RadioButton_radioButtonInput__IlVjW.RadioButton_yelp__aotpX:disabled + .RadioButton_radioButtonVisible__UJ-r3, .RadioButton_radioButtonInput__IlVjW.RadioButton_yelp__aotpX:disabled:hover + .RadioButton_radioButtonVisible__UJ-r3 {\n  background-color: #f2f2f2;\n  border-color: #dbdbdb;\n}\n.RadioButton_radioButtonInput__IlVjW.RadioButton_yelp__aotpX:disabled + .RadioButton_radioButtonVisible__UJ-r3 .RadioButton_label__jE2mA,\n.RadioButton_radioButtonInput__IlVjW.RadioButton_yelp__aotpX:disabled + .RadioButton_radioButtonVisible__UJ-r3 .RadioButton_sublabel__zZ6Og, .RadioButton_radioButtonInput__IlVjW.RadioButton_yelp__aotpX:disabled:hover + .RadioButton_radioButtonVisible__UJ-r3 .RadioButton_label__jE2mA,\n.RadioButton_radioButtonInput__IlVjW.RadioButton_yelp__aotpX:disabled:hover + .RadioButton_radioButtonVisible__UJ-r3 .RadioButton_sublabel__zZ6Og {\n  color: #6e6e6e;\n}";
var styles$a = {"radioButtonWrapper":"RadioButton_radioButtonWrapper__lrU-r","radioButtonVisible":"RadioButton_radioButtonVisible__UJ-r3","icon":"RadioButton_icon__FlIx1","swatch":"RadioButton_swatch__ftkUK","label":"RadioButton_label__jE2mA","sublabel":"RadioButton_sublabel__zZ6Og","noMargin":"RadioButton_noMargin__8lGoZ","radioButtonInput":"RadioButton_radioButtonInput__IlVjW","themed":"RadioButton_themed__PpD5-","yelp":"RadioButton_yelp__aotpX","rotation":"RadioButton_rotation__M2gyt"};
styleInject(css_248z$a);

var RadioButton = function (_a) {
    var _b, _c, _d;
    var _e = _a.checked, checked = _e === void 0 ? false : _e, _f = _a.className, className = _f === void 0 ? '' : _f, dataTestId = _a.dataTestId, _g = _a.disabled, disabled = _g === void 0 ? false : _g, id = _a.id, name = _a.name, _h = _a.onChange, onChange = _h === void 0 ? function () { } : _h, _j = _a.platform, platform = _j === void 0 ? 'brand' : _j, value = _a.value, Icon = _a.icon, label = _a.label, sublabel = _a.sublabel, swatch = _a.swatch;
    var _k = useState(checked), isChecked = _k[0], setIsChecked = _k[1];
    var swatchStyle = swatch && {
        backgroundColor: swatch
    };
    useEffect(function () {
        setIsChecked(checked);
    }, [checked]);
    var handleOnChange = function (event) {
        onChange(event);
    };
    return (React__default.createElement("div", { className: classNames(className, styles$a.radioButtonWrapper) },
        React__default.createElement("input", { checked: isChecked, readOnly: true, className: classNames(styles$a.radioButtonInput, styles$a[platform], (_b = {},
                _b[styles$a.disabled] = disabled,
                _b)), "data-testid": dataTestId, disabled: disabled, id: id, name: name, onChange: handleOnChange, type: "radio", value: value }),
        React__default.createElement("label", { className: styles$a.radioButtonVisible },
            Icon && React__default.createElement(Icon, { className: styles$a.icon }),
            swatch && React__default.createElement("div", { className: styles$a.swatch, style: __assign({}, swatchStyle) }),
            label && (React__default.createElement("div", { className: classNames(styles$a.label, (_c = {}, _c[styles$a.noMargin] = !(Icon || swatch), _c)) }, label)),
            sublabel && (React__default.createElement("div", { className: classNames(styles$a.sublabel, (_d = {},
                    _d[styles$a.noMargin] = !(Icon || swatch || label),
                    _d)) }, sublabel)))));
};

var _path$8, _path2$5;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
function SvgIconSearch24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.302 14.6l6.553 6.553a.496.496 0 01-.702.702L14.6 15.302l.702-.702z",
    fill: "#1F1F1F"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3a7 7 0 100 14 7 7 0 000-14zm-8 7a8 8 0 1116 0 8 8 0 01-16 0z",
    fill: "#1F1F1F"
  })));
}

var css_248z$9 = ".SearchPrimary_searchprimary__Bzhs- {\n  position: relative;\n}\n.SearchPrimary_searchprimary__Bzhs- svg path {\n  fill: #6e6e6e;\n}\n\n.SearchPrimary_themed__Si3pn svg path {\n  fill: #6e6e6e;\n}\n.SearchPrimary_themed__Si3pn .SearchPrimary_searchInput__S7yX3 {\n  background-color: #f2f2f2;\n  color: #1f1f1f;\n}\n.SearchPrimary_themed__Si3pn .SearchPrimary_searchInput__S7yX3:hover {\n  border: 1px solid #1f1f1f;\n}\n.SearchPrimary_themed__Si3pn .SearchPrimary_searchInput__S7yX3:focus-visible {\n  border: 1px solid #1f1f1f;\n}\n.SearchPrimary_themed__Si3pn .SearchPrimary_searchInput__S7yX3:focus-visible + .SearchPrimary_leadingIcon__PyKAg path {\n  fill: #1f1f1f;\n}\n.SearchPrimary_themed__Si3pn .SearchPrimary_searchInput__S7yX3:active {\n  border: 1px solid #1f1f1f;\n}\n.SearchPrimary_themed__Si3pn .SearchPrimary_searchInput__S7yX3:not(:placeholder-shown) + .SearchPrimary_leadingIcon__PyKAg path {\n  fill: #1f1f1f;\n}\n.SearchPrimary_themed__Si3pn .SearchPrimary_searchInput__S7yX3[disabled] {\n  background-color: #dbdbdb;\n  color: #6e6e6e;\n  pointer-events: none;\n}\n.SearchPrimary_themed__Si3pn .SearchPrimary_searchInput__S7yX3[disabled] + .SearchPrimary_leadingIcon__PyKAg path {\n  fill: #6e6e6e;\n}\n.SearchPrimary_themed__Si3pn .SearchPrimary_searchInput__S7yX3::placeholder {\n  color: #6e6e6e;\n}\n\n.SearchPrimary_leadingIcon__PyKAg {\n  height: 16px;\n  left: 16px;\n  position: absolute;\n  top: 12px;\n  width: 16px;\n}\n\n.SearchPrimary_searchInput__S7yX3 {\n  background-color: #f5f4f1;\n  border: 1px solid transparent;\n  border-radius: 24px;\n  box-sizing: border-box;\n  color: #142138;\n  font: 400 16px/24px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  height: 40px;\n  outline: none;\n  padding: 8px 12px 8px 40px;\n  text-overflow: ellipsis;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, transform 0.2s;\n  width: 100%;\n  -webkit-appearance: none;\n}\n.SearchPrimary_searchInput__S7yX3:hover {\n  border: 1px solid #142138;\n}\n.SearchPrimary_searchInput__S7yX3:focus-visible {\n  border: 1px solid #142138;\n}\n.SearchPrimary_searchInput__S7yX3:focus-visible + .SearchPrimary_leadingIcon__PyKAg path {\n  fill: #142138;\n}\n.SearchPrimary_searchInput__S7yX3 :active {\n  border: 1px solid #142138;\n}\n.SearchPrimary_searchInput__S7yX3:not(:placeholder-shown) + .SearchPrimary_leadingIcon__PyKAg path {\n  fill: #142138;\n}\n.SearchPrimary_searchInput__S7yX3[disabled] {\n  background-color: #dad8d2;\n  color: #6e6e6e;\n  pointer-events: none;\n}\n.SearchPrimary_searchInput__S7yX3[disabled] + .SearchPrimary_leadingIcon__PyKAg path {\n  fill: #6e6e6e;\n}\n.SearchPrimary_searchInput__S7yX3::placeholder {\n  color: #6e6e6e;\n}\n.SearchPrimary_searchInput__S7yX3::-webkit-search-cancel-button {\n  -webkit-appearance: none;\n  background: url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M2.64645 2.64645C2.84171 2.45118 3.15829 2.45118 3.35355 2.64645L13.3536 12.6464C13.5488 12.8417 13.5488 13.1583 13.3536 13.3536C13.1583 13.5488 12.8417 13.5488 12.6464 13.3536L2.64645 3.35355C2.45118 3.15829 2.45118 2.84171 2.64645 2.64645Z%22 fill%3D%22%231F1F1F%22%2F%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M13.3536 2.64645C13.5488 2.84171 13.5488 3.15829 13.3536 3.35355L3.35355 13.3536C3.15829 13.5488 2.84171 13.5488 2.64645 13.3536C2.45118 13.1583 2.45118 12.8417 2.64645 12.6464L12.6464 2.64645C12.8417 2.45118 13.1583 2.45118 13.3536 2.64645Z%22 fill%3D%22%231F1F1F%22%2F%3E%3C%2Fsvg%3E\") no-repeat 50% 50%;\n  background-size: contain;\n  cursor: pointer;\n  height: 16px;\n  pointer-events: all;\n  width: 16px;\n}\n\n.SearchPrimary_med__76nml .SearchPrimary_leadingIcon__PyKAg {\n  left: 16px;\n  top: 16px;\n}\n.SearchPrimary_med__76nml .SearchPrimary_searchInput__S7yX3 {\n  height: 48px;\n  padding: 12px 16px 12px 40px;\n}\n\n.SearchPrimary_large__oVYLm .SearchPrimary_leadingIcon__PyKAg {\n  height: 24px;\n  left: 24px;\n  top: 16px;\n  width: 24px;\n}\n.SearchPrimary_large__oVYLm .SearchPrimary_searchInput__S7yX3 {\n  border-radius: 28px;\n  height: 56px;\n  padding: 16px 24px 16px 56px;\n}\n.SearchPrimary_large__oVYLm input[type=search].SearchPrimary_searchInput__S7yX3::-webkit-search-cancel-button {\n  background: url(\"data:image/svg+xml,%3Csvg width%3D%2224%22 height%3D%2224%22 viewBox%3D%220 0 24 24%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M4.14645 4.14645C4.34171 3.95118 4.65829 3.95118 4.85355 4.14645L19.8536 19.1464C20.0488 19.3417 20.0488 19.6583 19.8536 19.8536C19.6583 20.0488 19.3417 20.0488 19.1464 19.8536L4.14645 4.85355C3.95118 4.65829 3.95118 4.34171 4.14645 4.14645Z%22 fill%3D%22%231F1F1F%22%2F%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M19.8536 4.14645C20.0488 4.34171 20.0488 4.65829 19.8536 4.85355L4.85355 19.8536C4.65829 20.0488 4.34171 20.0488 4.14645 19.8536C3.95118 19.6583 3.95118 19.3417 4.14645 19.1464L19.1464 4.14645C19.3417 3.95118 19.6583 3.95118 19.8536 4.14645Z%22 fill%3D%22%231F1F1F%22%2F%3E%3C%2Fsvg%3E\") no-repeat 50% 50%;\n  height: 24px;\n  width: 24px;\n}";
var styles$9 = {"searchprimary":"SearchPrimary_searchprimary__Bzhs-","themed":"SearchPrimary_themed__Si3pn","searchInput":"SearchPrimary_searchInput__S7yX3","leadingIcon":"SearchPrimary_leadingIcon__PyKAg","med":"SearchPrimary_med__76nml","large":"SearchPrimary_large__oVYLm"};
styleInject(css_248z$9);

var iconLookup = {
    small: SvgIconSearch16,
    med: SvgIconSearch16,
    large: SvgIconSearch24
};
var SearchPrimary = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.inputRef, inputRef = _c === void 0 ? React__default.createRef() : _c, _d = _a.onChange, onChange = _d === void 0 ? function () { } : _d, _e = _a.onClick, onClick = _e === void 0 ? function () { } : _e, _f = _a.onMouseLeave, onMouseLeave = _f === void 0 ? function () { } : _f, _g = _a.placeholder, placeholder = _g === void 0 ? 'Search' : _g, _h = _a.platform, platform = _h === void 0 ? 'brand' : _h, _j = _a.size, size = _j === void 0 ? 'small' : _j, value = _a.value;
    var Icon = iconLookup[size];
    return (React__default.createElement("div", { className: classNames(styles$9.searchprimary, styles$9[size], styles$9[platform]) },
        React__default.createElement("input", { type: "search", name: "search", autoComplete: "off", disabled: disabled, ref: inputRef, onChange: onChange, onClick: onClick, className: classNames(styles$9.searchInput), value: value, placeholder: placeholder, onMouseLeave: onMouseLeave }),
        React__default.createElement(Icon, { className: styles$9.leadingIcon })));
};

var css_248z$8 = ".SelectSimple_select__sTZXp {\n  appearance: none;\n  border: none;\n  background-color: transparent;\n  color: #6e6e6e;\n  cursor: pointer;\n  font: 400 16px/20px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  padding: 12px 0;\n}\n.SelectSimple_select__sTZXp:hover {\n  color: #142138;\n}\n.SelectSimple_select__sTZXp:focus, .SelectSimple_select__sTZXp:focus-visible {\n  outline: thin dashed #142138;\n}\n.SelectSimple_select__sTZXp.SelectSimple_withValue__wZO8c {\n  color: #142138;\n}\n.SelectSimple_select__sTZXp:disabled {\n  color: #b2afa4;\n}\n\n.SelectSimple_left__IKQlz {\n  background-position: left center;\n  padding-left: 24px;\n}\n\n.SelectSimple_right__uP-tb {\n  background-position: right center;\n  padding-right: 24px;\n}\n\n.SelectSimple_left__IKQlz,\n.SelectSimple_right__uP-tb {\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M2.13003 6.16367C2.31579 5.95934 2.63201 5.94428 2.83634 6.13003L8 10.8243L13.1637 6.13003C13.368 5.94428 13.6842 5.95934 13.87 6.16367C14.0557 6.368 14.0407 6.68422 13.8363 6.86997L8.33634 11.87C8.14563 12.0433 7.85438 12.0433 7.66367 11.87L2.16367 6.86997C1.95934 6.68422 1.94428 6.368 2.13003 6.16367Z%22 fill%3D%22%231F1F1F%22%2F%3E%3C%2Fsvg%3E\");\n  background-repeat: no-repeat;\n}\n.SelectSimple_left__IKQlz:focus,\n.SelectSimple_right__uP-tb:focus {\n  background-image: url(\"data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath fill-rule%3D%22evenodd%22 clip-rule%3D%22evenodd%22 d%3D%22M13.87 10.8363C13.6842 11.0407 13.368 11.0557 13.1637 10.87L8 6.17573L2.83634 10.87C2.63201 11.0557 2.31579 11.0407 2.13003 10.8363C1.94428 10.632 1.95934 10.3158 2.16367 10.13L7.66367 5.13003C7.85438 4.95666 8.14563 4.95666 8.33634 5.13003L13.8363 10.13C14.0407 10.3158 14.0557 10.632 13.87 10.8363Z%22 fill%3D%22%231F1F1F%22%2F%3E%3C%2Fsvg%3E\");\n}\n\n.SelectSimple_small__4LqVz {\n  font: 400 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n.SelectSimple_themed__1jkhl {\n  color: #6e6e6e;\n}\n.SelectSimple_themed__1jkhl:hover {\n  color: #1f1f1f;\n}\n.SelectSimple_themed__1jkhl.SelectSimple_withValue__wZO8c {\n  color: #1f1f1f;\n}\n.SelectSimple_themed__1jkhl:disabled {\n  color: #a3a3a3;\n}";
var styles$8 = {"select":"SelectSimple_select__sTZXp","withValue":"SelectSimple_withValue__wZO8c","left":"SelectSimple_left__IKQlz","right":"SelectSimple_right__uP-tb","small":"SelectSimple_small__4LqVz","themed":"SelectSimple_themed__1jkhl"};
styleInject(css_248z$8);

var SelectSimple = function (_a) {
    var _b;
    var _c = _a.alignIcon, alignIcon = _c === void 0 ? 'right' : _c, children = _a.children, _d = _a.className, className = _d === void 0 ? '' : _d, onChange = _a.onChange, disabled = _a.disabled, placeholder = _a.placeholder, _e = _a.platform, platform = _e === void 0 ? 'brand' : _e, _f = _a.size, size = _f === void 0 ? 'medium' : _f, value = _a.value;
    return (React__default.createElement("select", { className: classNames(styles$8.select, className, styles$8[size], styles$8[alignIcon], styles$8[platform], (_b = {},
            _b[styles$8.withValue] = !!value,
            _b)), value: value || '', disabled: disabled, onChange: function (event) { return onChange(event.currentTarget.value); } },
        placeholder && (React__default.createElement("option", { value: "", disabled: true, hidden: true }, placeholder)),
        children));
};

var Platforms;
(function (Platforms) {
    Platforms["Brand"] = "brand";
    Platforms["Themed"] = "themed";
})(Platforms || (Platforms = {}));

// icon-carot-16.svg and icon-carotUp-16.svg in base 64 data URI format
var ICON_CARET = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjEzMDAzIDYuMTYzNjdDMi4zMTU3OSA1Ljk1OTM0IDIuNjMyMDEgNS45NDQyOCAyLjgzNjM0IDYuMTMwMDNMOCAxMC44MjQzTDEzLjE2MzcgNi4xMzAwM0MxMy4zNjggNS45NDQyOCAxMy42ODQyIDUuOTU5MzQgMTMuODcgNi4xNjM2N0MxNC4wNTU3IDYuMzY4IDE0LjA0MDcgNi42ODQyMiAxMy44MzYzIDYuODY5OTdMOC4zMzYzNCAxMS44N0M4LjE0NTYzIDEyLjA0MzMgNy44NTQzOCAxMi4wNDMzIDcuNjYzNjcgMTEuODdMMi4xNjM2NyA2Ljg2OTk3QzEuOTU5MzQgNi42ODQyMiAxLjk0NDI4IDYuMzY4IDIuMTMwMDMgNi4xNjM2N1oiIGZpbGw9IiMxRjFGMUYiLz4KPC9zdmc+Cg==';
var ICON_CARET_UP = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy44NyAxMC44MzYzQzEzLjY4NDIgMTEuMDQwNyAxMy4zNjggMTEuMDU1NyAxMy4xNjM3IDEwLjg3TDggNi4xNzU3M0wyLjgzNjM0IDEwLjg3QzIuNjMyMDEgMTEuMDU1NyAyLjMxNTc5IDExLjA0MDcgMi4xMzAwMyAxMC44MzYzQzEuOTQ0MjggMTAuNjMyIDEuOTU5MzQgMTAuMzE1OCAyLjE2MzY3IDEwLjEzTDcuNjYzNjcgNS4xMzAwM0M3Ljg1NDM4IDQuOTU2NjYgOC4xNDU2MyA0Ljk1NjY2IDguMzM2MzQgNS4xMzAwM0wxMy44MzYzIDEwLjEzQzE0LjA0MDcgMTAuMzE1OCAxNC4wNTU3IDEwLjYzMiAxMy44NyAxMC44MzYzWiIgZmlsbD0iIzFGMUYxRiIvPgo8L3N2Zz4K';

var Select = styled.select(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  appearance: none;\n  border-radius: ", ";\n  cursor: pointer;\n  font: ", ";\n  padding: 11px ", " 11px ", ";\n  width: 100%;\n\n  ", "\n"], ["\n  appearance: none;\n  border-radius: ", ";\n  cursor: pointer;\n  font: ", ";\n  padding: 11px ", " 11px ", ";\n  width: 100%;\n\n  ", "\n"])), space.x1, paragraph.reg.x16, space.x5, space.x2, function (_a) {
    var platform = _a.platform, value = _a.value;
    var colors = semanticColors[platform];
    return ("\n        background-color: ".concat(colors.surface.primary, ";\n        background-image: url(").concat(ICON_CARET, ");\n        background-repeat: no-repeat;\n        background-position: calc(100% - ").concat(space.x2, ") center;\n        border: 1px solid ").concat(colors.border.primary, ";\n        color: ").concat(!!value ? "".concat(colors.content.primary) : "".concat(colors.content.secondary), ";\n\n        &:hover {\n          outline: thin solid ").concat(colors.border.tertiary, ";\n        }\n\n        &:focus,\n        &:focus-visible {\n          background-image: url(").concat(ICON_CARET_UP, ");\n          outline: thin solid ").concat(colors.border.tertiary, ";\n        }\n\n        &:disabled {\n          background-color: ").concat(colors.surface.tertiary, ";\n          background-image: none;\n          color: ").concat(colors.content.secondary, ";\n          cursor: default;\n\n          &:hover {\n            outline: none;\n          }\n        }\n      "));
});
var HelpText = styled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var platform = _a.platform;
    return "\n    color: ".concat(semanticColors[platform].content.secondary, ";\n    font: ").concat(label.reg.x12, ";\n    margin-top: ").concat(space.x1, ";\n    width: 100%;\n  ");
});
var Label = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: ", ";\n\n  ", "\n"], ["\n  margin-bottom: ", ";\n\n  ", "\n"])), space.x1, function (_a) {
    var disabled = _a.disabled, platform = _a.platform;
    var colors = semanticColors[platform];
    return ("\n        color: ".concat(disabled ? colors.content.secondary : colors.content.primary, ";\n        font: ").concat(label.reg.x14, ";\n      "));
});
var templateObject_1$1, templateObject_2$1, templateObject_3;

var SelectStandard = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, helpText = _a.helpText, label = _a.label, onChange = _a.onChange, placeholder = _a.placeholder, _c = _a.platform, platform = _c === void 0 ? Platforms.Brand : _c, _d = _a.value, value = _d === void 0 ? '' : _d;
    var handleOnChange = function (event) {
        onChange(event.currentTarget.value);
    };
    return (React__default.createElement("div", { className: className },
        label &&
            React__default.createElement(Label, { disabled: disabled, platform: platform }, label),
        React__default.createElement(Select, { disabled: disabled, onChange: handleOnChange, platform: platform, value: value },
            placeholder && (React__default.createElement("option", { value: "", disabled: true, hidden: true }, placeholder)),
            children),
        helpText && React__default.createElement(HelpText, { platform: platform }, helpText)));
};

var _path$7;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
function SvgIconMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8a.5.5 0 01-.5.5h-13a.5.5 0 010-1h13a.5.5 0 01.5.5z",
    fill: "#1F1F1F"
  })));
}

var css_248z$7 = ".Stepper_stepperCount__eJ-f2 {\n  align-items: center;\n  background-color: #f5f4f1;\n  border-radius: 24px;\n  box-sizing: border-box;\n  display: inline-flex;\n  padding: 16px;\n}\n.Stepper_stepperCount__eJ-f2.Stepper_outline__X-A9T {\n  background-color: #fff;\n  border: solid 1px #dad8d2;\n  padding: 15px;\n}\n\n.Stepper_stepperIcon__C15UK {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  height: 16px;\n  padding: 0;\n  width: 16px;\n}\n.Stepper_stepperIcon__C15UK.Stepper_disabled__SDN6J {\n  cursor: initial;\n}\n.Stepper_stepperIcon__C15UK.Stepper_disabled__SDN6J svg {\n  display: none;\n}\n.Stepper_stepperIcon__C15UK:hover svg path {\n  fill: #223ba8;\n}\n.Stepper_stepperIcon__C15UK:focus {\n  outline: 1px dashed;\n  outline-offset: 2px;\n}\n\n.Stepper_count__rMNDz {\n  color: #142138;\n  font: 500 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  min-width: 20px;\n  padding: 0 16px;\n  text-align: center;\n}\n\n.Stepper_stepperCount__eJ-f2.Stepper_themed__Xl-LW {\n  background-color: #f2f2f2;\n}\n.Stepper_stepperCount__eJ-f2.Stepper_themed__Xl-LW.Stepper_outline__X-A9T {\n  background-color: #fff;\n  border-color: #dbdbdb;\n}\n.Stepper_stepperCount__eJ-f2.Stepper_themed__Xl-LW .Stepper_stepperIcon__C15UK svg path {\n  fill: #1f1f1f;\n}\n.Stepper_stepperCount__eJ-f2.Stepper_themed__Xl-LW .Stepper_stepperIcon__C15UK:hover svg path {\n  fill: #008854;\n}\n.Stepper_stepperCount__eJ-f2.Stepper_themed__Xl-LW .Stepper_stepperIcon__C15UK:focus {\n  outline-color: #1f1f1f;\n}\n.Stepper_stepperCount__eJ-f2.Stepper_themed__Xl-LW .Stepper_count__rMNDz {\n  color: #1f1f1f;\n}\n\n.Stepper_stepperCount__eJ-f2.Stepper_yelp__uYBvE {\n  background-color: #f2f2f2;\n}\n.Stepper_stepperCount__eJ-f2.Stepper_yelp__uYBvE.Stepper_outline__X-A9T {\n  background-color: #fff;\n  border-color: #dbdbdb;\n}\n.Stepper_stepperCount__eJ-f2.Stepper_yelp__uYBvE .Stepper_stepperIcon__C15UK svg path {\n  fill: #1f1f1f;\n}\n.Stepper_stepperCount__eJ-f2.Stepper_yelp__uYBvE .Stepper_stepperIcon__C15UK:hover svg path {\n  fill: #b91608;\n}\n.Stepper_stepperCount__eJ-f2.Stepper_yelp__uYBvE .Stepper_stepperIcon__C15UK:focus {\n  outline-color: #1f1f1f;\n}\n.Stepper_stepperCount__eJ-f2.Stepper_yelp__uYBvE .Stepper_count__rMNDz {\n  color: #1f1f1f;\n}";
var styles$7 = {"stepperCount":"Stepper_stepperCount__eJ-f2","outline":"Stepper_outline__X-A9T","stepperIcon":"Stepper_stepperIcon__C15UK","disabled":"Stepper_disabled__SDN6J","count":"Stepper_count__rMNDz","themed":"Stepper_themed__Xl-LW","yelp":"Stepper_yelp__uYBvE"};
styleInject(css_248z$7);

var MIN_QUANTITY = 1;
var MAX_QUANTITY = 99;
var Stepper = function (_a) {
    var _b, _c, _d;
    var _e = _a.platform, platform = _e === void 0 ? 'brand' : _e, _f = _a.className, className = _f === void 0 ? '' : _f, _g = _a.onUpdateQuantity, onUpdateQuantity = _g === void 0 ? function () { } : _g, quantity = _a.quantity, _h = _a.minQuantity, minQuantity = _h === void 0 ? MIN_QUANTITY : _h, _j = _a.maxQuantity, maxQuantity = _j === void 0 ? MAX_QUANTITY : _j, dataTestId = _a.dataTestId, _k = _a.variant, variant = _k === void 0 ? 'fill' : _k;
    var _l = useState(quantity), newQuantity = _l[0], setNewQuantity = _l[1];
    var isMinDisabled = !!(newQuantity <= minQuantity);
    var isMaxDisabled = !!(newQuantity >= maxQuantity);
    function updateQuantity(value) {
        var displayValue = Math.min(Math.max(value, minQuantity), maxQuantity);
        onUpdateQuantity(displayValue);
        setNewQuantity(displayValue);
    }
    function handleDecrement() {
        updateQuantity(newQuantity - 1);
    }
    function handleIncrement() {
        updateQuantity(newQuantity + 1);
    }
    return (React__default.createElement("div", { className: classNames(styles$7.stepperCount, styles$7[platform], className, (_b = {},
            _b[styles$7.outline] = variant === 'outline',
            _b)) },
        React__default.createElement("button", { className: classNames(styles$7.stepperIcon, (_c = {},
                _c[styles$7.disabled] = isMinDisabled,
                _c)), "data-testid": "minus", onClick: handleDecrement, disabled: isMinDisabled },
            React__default.createElement(SvgIconMinus, null)),
        React__default.createElement("div", { className: styles$7.count, "data-testid": dataTestId }, newQuantity),
        React__default.createElement("button", { className: classNames(styles$7.stepperIcon, (_d = {},
                _d[styles$7.disabled] = isMaxDisabled,
                _d)), "data-testid": "plus", onClick: handleIncrement, disabled: isMaxDisabled },
            React__default.createElement(SvgIconPlus, null))));
};

var _path$6;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
function SvgIconCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.354.646a.5.5 0 010 .708l-4 4a.5.5 0 01-.708 0l-2-2a.5.5 0 11.708-.708L3 4.293 6.646.646a.5.5 0 01.708 0z",
    fill: "#fff"
  })));
}

var _path$5, _path2$4;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
function SvgIconClose8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.146 1.146a.5.5 0 01.708 0l5 5a.5.5 0 11-.708.708l-5-5a.5.5 0 010-.708z",
    fill: "#1F1F1F"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.854 1.146a.5.5 0 010 .708l-5 5a.5.5 0 11-.708-.708l5-5a.5.5 0 01.708 0z",
    fill: "#1F1F1F"
  })));
}

var css_248z$6 = ".Switch_toggle__B-Fwi {\n  background-color: transparent;\n  border: 0;\n  padding: 0;\n}\n\n.Switch_toggleButton__nk1Sf {\n  align-items: center;\n  background-color: #dad8d2;\n  border-radius: 25px;\n  box-sizing: content-box;\n  display: inline-flex;\n  height: 32px;\n  justify-content: space-around;\n  position: relative;\n  transition: 250ms;\n  width: 56px;\n}\n.Switch_toggleButton__nk1Sf path {\n  fill: #f5f4f1;\n}\n\n.Switch_toggleButton__nk1Sf::before {\n  background-color: #fff;\n  border-radius: 25px;\n  box-sizing: border-box;\n  content: \"\";\n  height: 28px;\n  left: 2px;\n  position: absolute;\n  top: 50%;\n  transform: translate(0, -50%);\n  transition: inherit;\n  width: 28px;\n  will-change: transform;\n}\n\n.Switch_toggle__B-Fwi:focus .Switch_toggleButton__nk1Sf {\n  outline: #142138 dashed 1px;\n  outline-offset: 2px;\n}\n\n.Switch_toggle__B-Fwi[aria-pressed=true] .Switch_toggleButton__nk1Sf {\n  background-color: #142138;\n}\n\n.Switch_toggle__B-Fwi[disabled] .Switch_toggleButton__nk1Sf {\n  cursor: not-allowed;\n  background-color: #f5f4f1;\n}\n.Switch_toggle__B-Fwi[disabled] .Switch_toggleButton__nk1Sf::before {\n  background-color: #dad8d2;\n}\n\n.Switch_toggle__B-Fwi:hover .Switch_toggleButton__nk1Sf,\n.Switch_toggle__B-Fwi[aria-pressed=true]:hover .Switch_toggleButton__nk1Sf {\n  background-color: #223ba8;\n}\n\n.Switch_toggle__B-Fwi:focus,\n.Switch_toggle__B-Fwi:focus:not(:focus-visible) .Switch_toggleButton__nk1Sf {\n  outline: 0;\n}\n\n.Switch_toggle__B-Fwi[aria-pressed=true] .Switch_toggleButton__nk1Sf::before {\n  transform: translate(85%, -50%);\n}\n\n.Switch_themed__-AqzM .Switch_toggleButton__nk1Sf {\n  background-color: #dbdbdb;\n}\n.Switch_themed__-AqzM .Switch_toggleButton__nk1Sf::before {\n  background-color: #fff;\n}\n.Switch_themed__-AqzM .Switch_toggle__B-Fwi:focus .Switch_toggleButton__nk1Sf {\n  outline-color: #1f1f1f;\n}\n.Switch_themed__-AqzM .Switch_toggle__B-Fwi[aria-pressed=true] .Switch_toggleButton__nk1Sf {\n  background-color: #13aa6d;\n}\n.Switch_themed__-AqzM .Switch_toggle__B-Fwi[disabled] .Switch_toggleButton__nk1Sf {\n  background-color: #f2f2f2;\n}\n.Switch_themed__-AqzM .Switch_toggle__B-Fwi[disabled] .Switch_toggleButton__nk1Sf::before {\n  background-color: #dbdbdb;\n}\n.Switch_themed__-AqzM .Switch_toggle__B-Fwi:hover .Switch_toggleButton__nk1Sf,\n.Switch_themed__-AqzM .Switch_toggle__B-Fwi[aria-pressed=true]:hover .Switch_toggleButton__nk1Sf {\n  background-color: #008854;\n}";
var styles$6 = {"toggle":"Switch_toggle__B-Fwi","toggleButton":"Switch_toggleButton__nk1Sf","themed":"Switch_themed__-AqzM"};
styleInject(css_248z$6);

var Switch = function (_a) {
    var _b;
    var _c = _a.className, className = _c === void 0 ? '' : _c, onToggle = _a.onToggle, isToggled = _a.isToggled, _d = _a.platform, platform = _d === void 0 ? 'brand' : _d;
    var isThemed = platform === 'themed';
    return (React__default.createElement("div", { className: classNames(className, (_b = {}, _b[styles$6.themed] = isThemed, _b)) },
        React__default.createElement("button", { className: styles$6.toggle, type: "button", id: "toggle", "aria-pressed": isToggled, onClick: function () { return onToggle(!isToggled); }, "data-testid": "toggleButton" },
            React__default.createElement("span", { className: styles$6.toggleButton, "data-testid": "NotificationButton", hidden: true },
                React__default.createElement(SvgIconCheckmark, null),
                React__default.createElement(SvgIconClose8, null)))));
};

var css_248z$5 = ".Table_table__t0p7g {\n  border-spacing: 0;\n  color: #6e6e6e;\n  font: 500 12px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  text-align: left;\n  width: 100%;\n}\n.Table_table__t0p7g td,\n.Table_table__t0p7g th {\n  padding-right: 16px;\n}\n.Table_table__t0p7g th {\n  white-space: nowrap;\n}\n\n.Table_themed__Xyqaw {\n  color: #6e6e6e;\n}\n.Table_themed__Xyqaw td {\n  color: #1f1f1f;\n  border-color: #dbdbdb;\n}\n.Table_themed__Xyqaw .Table_emptyCard__GlZx0 {\n  color: #6e6e6e;\n  background-color: #f2f2f2;\n}\n.Table_themed__Xyqaw .Table_emptyIcon__kpuuG path {\n  fill: #6e6e6e;\n}\n\ntd {\n  color: #142138;\n  font: 400 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  padding: 24px 0;\n  border-bottom: solid 1px;\n  border-color: #dad8d2;\n  vertical-align: top;\n}\n\n.Table_emptyCard__GlZx0 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  color: #6e6e6e;\n  background-color: #f5f4f1;\n  padding: 40px;\n  border-radius: 16px;\n  font: 400 16px/20px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  width: 100%;\n  margin-top: 40px;\n  box-sizing: border-box;\n}\n\n.Table_emptyIcon__kpuuG {\n  margin-bottom: 16px;\n}\n.Table_emptyIcon__kpuuG path {\n  fill: #6e6e6e;\n}\n\n.Table_loadingSpinner__EKGUe {\n  height: 32px;\n  position: relative;\n  width: 32px;\n}\n\n.Table_loadingWrapper__BadUs {\n  display: flex;\n  justify-content: center;\n  margin: 40px 0;\n}";
var styles$5 = {"table":"Table_table__t0p7g","themed":"Table_themed__Xyqaw","emptyCard":"Table_emptyCard__GlZx0","emptyIcon":"Table_emptyIcon__kpuuG","loadingSpinner":"Table_loadingSpinner__EKGUe","loadingWrapper":"Table_loadingWrapper__BadUs"};
styleInject(css_248z$5);

var hasNoTableData = function (children) {
    return !(Array.isArray(children) &&
        children.length > 1 &&
        children[1].props.children &&
        Array.isArray(children[1].props.children) &&
        children[1].props.children.length > 0);
};
var TableContext = createContext({ platform: 'brand' });
var Table = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, _d = _a.onSort, onSort = _d === void 0 ? function () { } : _d, _e = _a.platform, platform = _e === void 0 ? 'brand' : _e, EmptyIcon = _a.emptyIcon, _f = _a.emptyMessage, emptyMessage = _f === void 0 ? 'No Data' : _f;
    var content;
    if (isLoading) {
        content = (React__default.createElement("div", { className: styles$5.loadingWrapper },
            React__default.createElement("div", { className: styles$5.loadingSpinner },
                React__default.createElement(LoadingSpinner, { isCentered: true, size: 'large' }))));
    }
    else if (hasNoTableData(children)) {
        content = (React__default.createElement("div", { className: styles$5.emptyCard },
            EmptyIcon && React__default.createElement(EmptyIcon, { className: styles$5.emptyIcon }),
            emptyMessage));
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("table", { className: classNames(styles$5.table, styles$5[platform], className) },
            React__default.createElement(TableContext.Provider, { value: { platform: platform, onSort: onSort } }, children)),
        content));
};

var _path$4;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
function SvgIconSwitch16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.13 10.164a.5.5 0 01.706-.034L8 13.824l4.164-3.694a.5.5 0 01.672.74l-4.5 4a.5.5 0 01-.672 0l-4.5-4a.5.5 0 01-.034-.706zM12.87 5.836a.5.5 0 01-.706.034L8 2.176 3.836 5.87a.5.5 0 01-.672-.74l4.5-4a.5.5 0 01.672 0l4.5 4a.5.5 0 01.034.706z",
    fill: "#1F1F1F"
  })));
}

var StyledTableHeader = styled.th(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  border-bottom: solid 1px;\n  box-sizing: border-box;\n  font: ", ";\n  letter-spacing: 1.2px;\n  padding: ", " 0;\n  text-transform: uppercase;\n\n  ", "\n"], ["\n  ", "\n  border-bottom: solid 1px;\n  box-sizing: border-box;\n  font: ", ";\n  letter-spacing: 1.2px;\n  padding: ", " 0;\n  text-transform: uppercase;\n\n  ", "\n"])), function (_a) {
    var shouldTruncate = _a.shouldTruncate, customWidth = _a.customWidth;
    return "\n  ".concat(shouldTruncate
        ? "width: ".concat(customWidth ? "".concat(customWidth, "px") : 'auto', "; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;")
        : '', "\n");
}, caption.md.x12, space.x3, function (_a) {
    var platform = _a.platform;
    var colors = semanticColors[platform];
    return "\n      border-color: ".concat(colors.border.tertiary, ";\n      color: ").concat(colors.content.secondary, ";\n    ");
});
var StyledIconSwitch = styled(SvgIconSwitch16)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: ", ";\n  vertical-align: bottom;\n\n  ", "\n"], ["\n  margin-right: ", ";\n  vertical-align: bottom;\n\n  ", "\n"])), space.x1, function (_a) {
    var platform = _a.platform;
    return "\n      path {\n        fill: ".concat(semanticColors[platform].content.secondary, ";\n      }\n  ");
});
var templateObject_1, templateObject_2;

var TableHeader = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.isSortable, isSortable = _c === void 0 ? false : _c, _d = _a.shouldTruncate, shouldTruncate = _d === void 0 ? false : _d, _e = _a.customWidth, customWidth = _e === void 0 ? 'auto' : _e;
    var _f = useState('asc'), sortOrder = _f[0], setSortOrder = _f[1];
    var _g = useContext(TableContext), onSort = _g.onSort, platform = _g.platform;
    return (React__default.createElement(StyledTableHeader, { className: className, customWidth: customWidth, onClick: function () {
            if (isSortable && onSort) {
                onSort(children, sortOrder);
                setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
            }
        }, platform: platform, shouldTruncate: shouldTruncate },
        isSortable && React__default.createElement(StyledIconSwitch, { platform: platform }),
        children));
};

var css_248z$4 = ".Tabs_tabs__tVTpi {\n  color: #142138;\n  position: relative;\n}\n.Tabs_tabs__tVTpi hr {\n  border-style: solid;\n  border-width: 0 0 1px 0;\n  border-color: #dad8d2;\n  margin: 0 0 8px 0;\n}\n\n.Tabs_labels__caneW {\n  display: flex;\n  text-align: center;\n  color: #6e6e6e;\n}\n.Tabs_labels__caneW span {\n  cursor: pointer;\n  padding: 14px 0;\n  font: 500 16px/20px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-variant-ligatures: none;\n  margin-right: 40px;\n}\n.Tabs_labels__caneW span:last-of-type {\n  margin-right: 0;\n}\n.Tabs_labels__caneW span:hover {\n  color: #142138;\n}\n\nspan.Tabs_selected__3Maj- {\n  color: #142138;\n  margin-bottom: 2px;\n}\n\n.Tabs_selectionMarker__h1sWH {\n  height: 2px;\n  width: 0px;\n  background-color: #142138;\n  position: absolute;\n  top: 48px;\n  left: 0;\n  transition: left 0.3s, width 0.3s;\n}\n\n.Tabs_fill__JSbjx {\n  justify-content: space-between;\n}\n.Tabs_fill__JSbjx span {\n  flex: 1;\n}\n\n.Tabs_themed__h7VT0.Tabs_tabs__tVTpi {\n  color: #1f1f1f;\n}\n.Tabs_themed__h7VT0.Tabs_tabs__tVTpi hr {\n  border-color: #dbdbdb;\n}\n.Tabs_themed__h7VT0.Tabs_tabs__tVTpi .Tabs_labels__caneW {\n  color: #6e6e6e;\n}\n.Tabs_themed__h7VT0.Tabs_tabs__tVTpi span:hover {\n  color: #1f1f1f;\n}\n.Tabs_themed__h7VT0.Tabs_tabs__tVTpi span.Tabs_selected__3Maj- {\n  color: #1f1f1f;\n}\n.Tabs_themed__h7VT0.Tabs_tabs__tVTpi .Tabs_selectionMarker__h1sWH {\n  background-color: #1f1f1f;\n}\n\n.Tabs_yelp__Q2EGN.Tabs_tabs__tVTpi {\n  color: #1f1f1f;\n}\n.Tabs_yelp__Q2EGN.Tabs_tabs__tVTpi hr {\n  border-color: #dbdbdb;\n}\n.Tabs_yelp__Q2EGN.Tabs_tabs__tVTpi .Tabs_labels__caneW {\n  color: #6e6e6e;\n}\n.Tabs_yelp__Q2EGN.Tabs_tabs__tVTpi span:hover {\n  color: #1f1f1f;\n}\n.Tabs_yelp__Q2EGN.Tabs_tabs__tVTpi span.Tabs_selected__3Maj- {\n  color: #1f1f1f;\n}\n.Tabs_yelp__Q2EGN.Tabs_tabs__tVTpi .Tabs_selectionMarker__h1sWH {\n  background-color: #1f1f1f;\n}\n\n.Tabs_small__sTJri .Tabs_labels__caneW span {\n  font: 500 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  margin-right: 24px;\n}\n.Tabs_small__sTJri .Tabs_labels__caneW span:last-of-type {\n  margin-right: 0;\n}\n.Tabs_small__sTJri .Tabs_selectionMarker__h1sWH {\n  top: 44px;\n}";
var styles$4 = {"tabs":"Tabs_tabs__tVTpi","labels":"Tabs_labels__caneW","selected":"Tabs_selected__3Maj-","selectionMarker":"Tabs_selectionMarker__h1sWH","fill":"Tabs_fill__JSbjx","themed":"Tabs_themed__h7VT0","yelp":"Tabs_yelp__Q2EGN","small":"Tabs_small__sTJri"};
styleInject(css_248z$4);

var Tabs = function (_a) {
    var _b = _a.platform, platform = _b === void 0 ? 'brand' : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.variant, variant = _d === void 0 ? 'hug' : _d, tabs = _a.tabs;
    var _e = useState(0), currentTabIndex = _e[0], setCurrentTabIndex = _e[1];
    var selectionMarkerRef = useRef(null);
    var REFS = [];
    // Handle sliding selection bar under tabs
    var selectTab = function (index) {
        var firstLabel = REFS[0].current;
        var label = REFS[index].current;
        var marker = selectionMarkerRef.current;
        if (firstLabel && label && marker) {
            var newLeft = label.getBoundingClientRect().left - firstLabel.getBoundingClientRect().left;
            marker.style.left = "".concat(newLeft, "px");
            marker.style.width = "".concat(label.offsetWidth, "px");
        }
    };
    useLayoutEffect(function () {
        selectTab(currentTabIndex);
    }, [currentTabIndex, variant, size]);
    return (React__default.createElement("div", { className: classNames(styles$4.tabs, styles$4[platform], styles$4[size]) },
        React__default.createElement("div", { className: classNames(styles$4.labels, styles$4[variant]) }, tabs.map(function (tab, index) {
            var _a;
            var ref = useRef(null);
            REFS.push(ref);
            return (React__default.createElement("span", { key: tab.name, ref: ref, className: classNames((_a = {}, _a[styles$4.selected] = index === currentTabIndex, _a)), onClick: function () { return setCurrentTabIndex(index); } }, tab.label));
        })),
        React__default.createElement("div", { className: styles$4.selectionMarker, ref: selectionMarkerRef }),
        React__default.createElement("hr", null),
        tabs[currentTabIndex].body));
};
Tabs.defaultProps = {
    platform: 'brand',
    size: 'medium',
    variant: 'hug'
};

var css_248z$3 = ".Tag_tag__3Wkgw {\n  align-items: center;\n  background-color: #fff;\n  border-radius: 4px;\n  box-sizing: border-box;\n  color: #142138;\n  display: flex;\n  font: 500 10px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  height: 24px;\n  letter-spacing: 0.8px;\n  padding: 4px 8px;\n  text-indent: 0.8px;\n  text-transform: uppercase;\n  transition: background-color 0.2s, color 0.2s, border-color 0.2s, transform 0.2s;\n  width: fit-content;\n}\n\n.Tag_icon__QtnDd {\n  height: 16px;\n  padding-right: 4px;\n}\n\n.Tag_large__lIwHJ {\n  font: 500 12px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  height: 32px;\n  letter-spacing: 1.2px;\n  padding: 8px;\n  text-indent: 1.2px;\n}\n\n.Tag_light__kWL1X {\n  background-color: #f5f4f1;\n}\n\n.Tag_outlined__RSMLS {\n  background-color: transparent;\n  border: 1px solid #dad8d2;\n}\n\n.Tag_success__vNT2- {\n  background-color: transparent;\n  border: 1px solid #0e7a4a;\n  color: #0e7a4a;\n}\n.Tag_success__vNT2- .Tag_icon__QtnDd path {\n  fill: #0e7a4a;\n}\n\n.Tag_caution__q-Laz {\n  background-color: transparent;\n  border: 1px solid #cc1b00;\n  color: #cc1b00;\n}\n.Tag_caution__q-Laz .Tag_icon__QtnDd path {\n  fill: #cc1b00;\n}\n\n.Tag_themed__vign3.Tag_tag__3Wkgw {\n  background-color: #fff;\n  color: #1f1f1f;\n}\n.Tag_themed__vign3.Tag_light__kWL1X {\n  background-color: #f2f2f2;\n}\n.Tag_themed__vign3.Tag_outlined__RSMLS {\n  background-color: transparent;\n  border: 1px solid #dbdbdb;\n}\n.Tag_themed__vign3.Tag_success__vNT2- {\n  background-color: transparent;\n  border: 1px solid #0e7a4a;\n  color: #0e7a4a;\n}\n.Tag_themed__vign3.Tag_success__vNT2- .Tag_icon__QtnDd path {\n  fill: #0e7a4a;\n}\n.Tag_themed__vign3.Tag_caution__q-Laz {\n  background-color: transparent;\n  border: 1px solid #cc1b00;\n  color: #cc1b00;\n}\n.Tag_themed__vign3.Tag_caution__q-Laz .Tag_icon__QtnDd path {\n  fill: #cc1b00;\n}";
var styles$3 = {"tag":"Tag_tag__3Wkgw","icon":"Tag_icon__QtnDd","large":"Tag_large__lIwHJ","light":"Tag_light__kWL1X","outlined":"Tag_outlined__RSMLS","success":"Tag_success__vNT2-","caution":"Tag_caution__q-Laz","themed":"Tag_themed__vign3"};
styleInject(css_248z$3);

// Generated with util/create-component.js
function Tag(_a) {
    var icon = _a.icon, id = _a.id, _b = _a.label, label = _b === void 0 ? 'label' : _b, _c = _a.platform, platform = _c === void 0 ? 'brand' : _c, _d = _a.size, size = _d === void 0 ? 'small' : _d, _e = _a.variant, variant = _e === void 0 ? 'white' : _e;
    return (React__default.createElement("div", { id: id, className: classNames(styles$3.tag, styles$3[platform], styles$3[size], styles$3[variant]) },
        icon && (React__default.createElement("div", { className: styles$3.icon }, icon)),
        label));
}

var _path$3, _path2$3;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
function SvgIconBadgeinfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15A7 7 0 108 1a7 7 0 000 14zm0 1A8 8 0 108 0a8 8 0 000 16z",
    fill: "#142138"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.75h1v4.5h-1v-4.5zM7.5 4.75h1v1h-1v-1z",
    fill: "#142138"
  })));
}

var _path$2, _path2$2;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
function SvgIconBadgecheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15A7 7 0 108 1a7 7 0 000 14zm0 1A8 8 0 108 0a8 8 0 000 16z",
    fill: "#0E7A4A"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.354 5.646a.5.5 0 010 .708l-4 4a.5.5 0 01-.708 0l-2-2a.5.5 0 11.708-.708L7 9.293l3.646-3.647a.5.5 0 01.708 0z",
    fill: "#0E7A4A"
  })));
}

var _g, _defs;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
function SvgIconCaution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-caution_svg__clip0_1921_236)",
    fill: "#CC1B00"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.88 13.147L8.69 1.928c-.316-.57-1.064-.57-1.38 0l-6.19 11.22c-.365.66.135 1.352.69 1.352h12.38c.555 0 1.055-.691.69-1.353zM6.435 1.445a1.768 1.768 0 013.13 0l6.19 11.22c.696 1.26-.174 2.835-1.565 2.835H1.81c-1.391 0-2.26-1.575-1.565-2.836l6.19-11.219z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.5h-1V6h1v4.5zM8.5 12.5h-1v-1h1v1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-caution_svg__clip0_1921_236"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}

var css_248z$2 = ".TagNotice_tagNotice__c6x3Z {\n  display: flex;\n}\n\n.TagNotice_small__9BlN- {\n  font: 400 12px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n.TagNotice_large__VjqES {\n  font: 400 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n\n.TagNotice_icon__Uu0kA {\n  margin-right: 8px;\n  height: 16px;\n  width: 16px;\n}\n\n.TagNotice_neutral__Cx4-W {\n  color: #142138;\n}\n\n.TagNotice_success__RDkpz {\n  color: #0e7a4a;\n}\n\n.TagNotice_caution__Clo-W {\n  color: #cc1b00;\n}\n\n.TagNotice_themed__Ca5E-.TagNotice_neutral__Cx4-W {\n  color: #1f1f1f;\n}\n.TagNotice_themed__Ca5E-.TagNotice_neutral__Cx4-W .TagNotice_icon__Uu0kA path {\n  fill: #1f1f1f;\n}\n.TagNotice_themed__Ca5E-.TagNotice_success__RDkpz {\n  color: #0e7a4a;\n}\n.TagNotice_themed__Ca5E-.TagNotice_success__RDkpz .TagNotice_icon__Uu0kA path {\n  fill: #0e7a4a;\n}\n.TagNotice_themed__Ca5E-.TagNotice_caution__Clo-W {\n  color: #cc1b00;\n}\n.TagNotice_themed__Ca5E-.TagNotice_caution__Clo-W .TagNotice_icon__Uu0kA path {\n  fill: #cc1b00;\n}";
var styles$2 = {"tagNotice":"TagNotice_tagNotice__c6x3Z","small":"TagNotice_small__9BlN-","large":"TagNotice_large__VjqES","icon":"TagNotice_icon__Uu0kA","neutral":"TagNotice_neutral__Cx4-W","success":"TagNotice_success__RDkpz","caution":"TagNotice_caution__Clo-W","themed":"TagNotice_themed__Ca5E-"};
styleInject(css_248z$2);

// Generated with util/create-component.js
function TagNotice(_a) {
    var id = _a.id, _b = _a.label, label = _b === void 0 ? 'neutral message' : _b, _c = _a.platform, platform = _c === void 0 ? 'brand' : _c, _d = _a.size, size = _d === void 0 ? 'small' : _d, _e = _a.variant, variant = _e === void 0 ? 'neutral' : _e;
    var getIconType = function () {
        if (variant === 'neutral')
            return React__default.createElement(SvgIconBadgeinfo, null);
        if (variant === 'success')
            return React__default.createElement(SvgIconBadgecheck, null);
        if (variant === 'caution')
            return React__default.createElement(SvgIconCaution, null);
    };
    return (React__default.createElement("div", { id: id, className: classNames(styles$2.tagNotice, styles$2[platform], styles$2[size], styles$2[variant]) },
        React__default.createElement("div", { className: styles$2.icon }, getIconType()),
        label));
}

var _circle, _path$1, _path2$1;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
function SvgIconMembergold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FAF6E0"
  })), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14zm0 2c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z",
    fill: "#EAAE00"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.412 14.315a.306.306 0 00-.178-.095l-4.115-.628-1.84-3.91a.305.305 0 00-.558 0l-1.84 3.91-3.645.556-.47.072a.324.324 0 00-.263.37c.01.07.042.136.091.186l2.977 3.044-.703 4.299a.325.325 0 00.255.376c.067.012.136.001.197-.033L16 20.433l3.302 1.82.378.21c.152.083.34.022.42-.138a.342.342 0 00.032-.206l-.06-.367-.643-3.932 2.977-3.044a.338.338 0 00.006-.461z",
    fill: "#EAAE00"
  })));
}

var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgLogoMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.961 20.278c5.127 0 9.283-4.09 9.283-9.135S16.088 2.01 10.961 2.01c-5.126 0-9.282 4.09-9.282 9.134 0 5.045 4.156 9.135 9.282 9.135z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.776 10.98c0-5.934-4.84-10.745-10.804-10.745C5.002.235.162 5.045.162 10.98c0 .152.005.298.01.445-.01.475.04 1.538.54 2.94.452 1.36 1.17 2.6 2.096 3.656 1.476 1.827 3.761 3.795 7.309 5.6.534.274 1.17.274 1.704 0 3.548-1.81 5.838-3.773 7.309-5.6a10.652 10.652 0 002.097-3.657c.498-1.396.55-2.464.54-2.94.004-.15.01-.297.01-.444zM6.59 6.149a.87.87 0 011.252.025l2.28 2.458L9.134 9.7 6.62 7.393a.858.858 0 01-.03-1.244zm10.514 8.863a.151.151 0 01-.208 0l-2.128-2.393a.373.373 0 00-.529 0 .368.368 0 000 .526l2.148 2.373a.268.268 0 010 .374.272.272 0 01-.377 0l-2.387-2.135a.373.373 0 00-.53 0 .368.368 0 000 .526l2.408 2.115a.149.149 0 010 .207.162.162 0 01-.158.035s-1.664-.617-2.509-1.456c-.519-.516-.778-1.139-.789-1.72l-.005.005c-.005-.582.077-.967-.427-1.477l-.636-.587-.672.617c-.504.637-.387 1.067-.387 1.588l-.005-.005c-.01.617-.285 1.275-.835 1.821-1.028 1.022-2.931 1.579-3.756.754-.83-.824-.27-2.716.759-3.738.55-.547 1.211-.82 1.832-.83l-.005-.005c.524-.005.941.101 1.557-.41l4.657-5.018a.87.87 0 011.252-.025c.351.349.336.91-.026 1.244l-3.445 3.162.56.602c.509.49.896.415 1.48.42l-.004.005c.59.01 1.211.268 1.73.784.845.84 1.46 2.489 1.46 2.489.026.045.016.106-.025.152z",
    fill: "#F94E4E"
  })));
}

var css_248z$1 = ".Toast_toast__KyhX3 {\n  background-color: #fff;\n  border: 1px solid #dad8d2;\n  border-radius: 8px;\n  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);\n  color: #142138;\n  display: flex;\n  font: 400 14px/20px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  padding: 16px;\n  width: 100%;\n}\n\n.Toast_iconCloseWrapper__09-eJ {\n  background: none;\n  border: none;\n  display: flex;\n  margin-bottom: auto;\n  margin-left: auto;\n  padding: 0 0 8px 0;\n}\n\n.Toast_iconClose__sOA-E path {\n  fill: #142138;\n}\n\n.Toast_title__HoPyn {\n  color: #142138;\n  font: 600 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  padding-right: 4px;\n}\n\n.Toast_message__G6h2P {\n  margin: 8px 8px 8px 0;\n}\n\n.Toast_link__6vCW5 {\n  color: #142138;\n  font: 400 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  text-decoration: underline;\n}\n.Toast_link__6vCW5:hover, .Toast_link__6vCW5:active {\n  color: #223ba8;\n}\n.Toast_link__6vCW5:focus, .Toast_link__6vCW5:focus-visible {\n  outline: thin dashed #142138;\n}\n\n.Toast_toastButton__FuW8T {\n  background: none;\n  border: 0;\n  color: #142138;\n  font: 400 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  padding: 0;\n  text-decoration: underline;\n}\n.Toast_toastButton__FuW8T:hover, .Toast_toastButton__FuW8T:active {\n  color: #223ba8;\n  cursor: pointer;\n}\n\n.Toast_badge__UFIEU {\n  padding-right: 16px;\n}\n\n.Toast_inlineOnMobile__sV8G6 {\n  align-items: center;\n}\n.Toast_inlineOnMobile__sV8G6 .Toast_logo__lc8af svg {\n  margin-top: 4px;\n}\n.Toast_inlineOnMobile__sV8G6 .Toast_title__HoPyn {\n  display: inline;\n}\n.Toast_inlineOnMobile__sV8G6 .Toast_message__G6h2P {\n  display: inline;\n  margin: 0;\n}\n.Toast_inlineOnMobile__sV8G6 .Toast_link__6vCW5 {\n  display: inline;\n}\n.Toast_inlineOnMobile__sV8G6 .Toast_iconCloseWrapper__09-eJ {\n  margin-bottom: -4px;\n}\n\n.Toast_logo__lc8af svg {\n  margin-top: -4px;\n  padding-right: 8px;\n  width: 14px;\n}\n\n.Toast_themed__fSjCL {\n  background-color: #fff;\n  border-color: #dbdbdb;\n  color: #1f1f1f;\n}\n.Toast_themed__fSjCL .Toast_iconClose__sOA-E path {\n  fill: #1f1f1f;\n}\n.Toast_themed__fSjCL .Toast_title__HoPyn {\n  color: #1f1f1f;\n}\n.Toast_themed__fSjCL .Toast_link__6vCW5 {\n  color: #1f1f1f;\n}\n.Toast_themed__fSjCL .Toast_link__6vCW5:hover, .Toast_themed__fSjCL .Toast_link__6vCW5:active {\n  color: #008854;\n}\n.Toast_themed__fSjCL .Toast_link__6vCW5:focus, .Toast_themed__fSjCL .Toast_link__6vCW5:focus-visible {\n  outline: thin dashed #1f1f1f;\n}\n.Toast_themed__fSjCL .Toast_toastButton__FuW8T {\n  color: #1f1f1f;\n}\n.Toast_themed__fSjCL .Toast_toastButton__FuW8T:hover, .Toast_themed__fSjCL .Toast_toastButton__FuW8T:active {\n  color: #008854;\n}\n\n/* Small devices and above (tablet, 768px and up) */\n@media (min-width: 768px) {\n  .Toast_logo__lc8af svg {\n    margin-top: 0;\n    padding-right: 16px;\n    width: 22px;\n  }\n\n  .Toast_toast__KyhX3 {\n    max-width: 328px;\n  }\n\n  .Toast_inlineOnMobile__sV8G6 {\n    align-items: flex-start;\n  }\n  .Toast_inlineOnMobile__sV8G6 .Toast_title__HoPyn {\n    display: block;\n    padding-right: 0;\n  }\n  .Toast_inlineOnMobile__sV8G6 .Toast_message__G6h2P {\n    display: block;\n    margin: 8px 8px 8px 0;\n  }\n  .Toast_inlineOnMobile__sV8G6 .Toast_link__6vCW5 {\n    display: block;\n  }\n  .Toast_inlineOnMobile__sV8G6 .Toast_iconCloseWrapper__09-eJ {\n    margin-left: 24px;\n  }\n}";
var styles$1 = {"toast":"Toast_toast__KyhX3","iconCloseWrapper":"Toast_iconCloseWrapper__09-eJ","iconClose":"Toast_iconClose__sOA-E","title":"Toast_title__HoPyn","message":"Toast_message__G6h2P","link":"Toast_link__6vCW5","toastButton":"Toast_toastButton__FuW8T","badge":"Toast_badge__UFIEU","inlineOnMobile":"Toast_inlineOnMobile__sV8G6","logo":"Toast_logo__lc8af","themed":"Toast_themed__fSjCL"};
styleInject(css_248z$1);

// Generated with util/create-component.js
function Toast(_a) {
    var _b;
    var _c = _a.ariaLabel, ariaLabel = _c === void 0 ? 'click here to learn more' : _c, id = _a.id, _d = _a.dataTestId, dataTestId = _d === void 0 ? 'toastLink' : _d, _e = _a.title, title = _e === void 0 ? 'Title' : _e, _f = _a.message, message = _f === void 0 ? 'Lorem ipsum dolor sit amet, consectetur adipiscing elit' : _f, _g = _a.linkText, linkText = _g === void 0 ? 'Learn More' : _g, _h = _a.linkTo, linkTo = _h === void 0 ? 'https://eat.chownow.com' : _h, _j = _a.platform, platform = _j === void 0 ? 'themed' : _j, _k = _a.showBadge, showBadge = _k === void 0 ? false : _k, _l = _a.showLogo, showLogo = _l === void 0 ? false : _l, _m = _a.inlineOnMobile, inlineOnMobile = _m === void 0 ? false : _m, _o = _a.useOutlink, useOutlink = _o === void 0 ? true : _o, handleClick = _a.handleClick, handleOnClickClose = _a.handleOnClickClose;
    return (React__default.createElement("div", { id: id, className: classNames(styles$1.toast, styles$1[platform], (_b = {},
            _b[styles$1.badge] = showBadge,
            _b[styles$1.inlineOnMobile] = inlineOnMobile,
            _b)) },
        showBadge && (React__default.createElement("div", { className: styles$1.badge },
            React__default.createElement(SvgIconMembergold, { "data-testid": "badge" }))),
        showLogo && (React__default.createElement("div", { className: styles$1.logo },
            React__default.createElement(SvgLogoMark, { "data-testid": "logo" }))),
        React__default.createElement("div", { className: styles$1.toastContent },
            React__default.createElement("div", { className: styles$1.title }, title),
            React__default.createElement("div", { className: styles$1.message }, message),
            linkText && (React__default.createElement("div", { className: styles$1.link, "data-testid": dataTestId }, useOutlink ? (React__default.createElement(Outlink, { to: linkTo, ariaLabel: ariaLabel, handleClick: handleClick, platform: platform }, linkText)) : (React__default.createElement("button", { className: styles$1.toastButton, "aria-label": ariaLabel, onClick: handleClick, type: "button" }, linkText))))),
        React__default.createElement("button", { className: styles$1.iconCloseWrapper, onClick: handleOnClickClose, type: "button" },
            React__default.createElement(SvgIconClose16, { "aria-label": "close toast", className: styles$1.closeIcon, role: "img" }))));
}

var css_248z = ".ToggleButton_toggleWrapper__N-lA3 {\n  background-color: #f5f4f1;\n  border-radius: 26px;\n  box-sizing: border-box;\n  display: flex;\n  height: 48px;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  position: relative;\n}\n.ToggleButton_toggleWrapper__N-lA3.ToggleButton_small__wtxHL {\n  height: 40px;\n}\n\n.ToggleButton_toggleSlide__iKznL {\n  background-color: #142138;\n  border-radius: 26px;\n  height: 100%;\n  position: absolute;\n  width: 50%;\n}\n\n.ToggleButton_toggleOption__1cegZ {\n  align-items: center;\n  background-color: transparent;\n  border: none;\n  border-radius: 26px;\n  color: #142138;\n  cursor: pointer;\n  display: flex;\n  font: 400 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n  padding: 0;\n  text-transform: capitalize;\n  z-index: 1;\n}\n.ToggleButton_toggleOption__1cegZ:hover {\n  color: #223ba8;\n}\n.ToggleButton_toggleOption__1cegZ:focus-visible {\n  outline: 1px dashed;\n  outline-offset: 1px;\n  outline-color: #142138;\n}\n.ToggleButton_toggleOption__1cegZ.ToggleButton_isActive__HjXhA {\n  color: #fff;\n  font: 500 14px/16px \"Matter\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n}\n.ToggleButton_toggleOption__1cegZ.ToggleButton_disabled__X0NL- {\n  color: #6e6e6e;\n  cursor: initial;\n}\n\n.ToggleButton_toggleWrapper__N-lA3.ToggleButton_themed__JQnPY {\n  background-color: #f2f2f2;\n}\n.ToggleButton_toggleWrapper__N-lA3.ToggleButton_themed__JQnPY .ToggleButton_toggleSlide__iKznL {\n  background-color: #13aa6d;\n}\n.ToggleButton_toggleWrapper__N-lA3.ToggleButton_themed__JQnPY .ToggleButton_toggleOption__1cegZ {\n  color: #1f1f1f;\n}\n.ToggleButton_toggleWrapper__N-lA3.ToggleButton_themed__JQnPY .ToggleButton_toggleOption__1cegZ:hover {\n  color: #008854;\n}\n.ToggleButton_toggleWrapper__N-lA3.ToggleButton_themed__JQnPY .ToggleButton_toggleOption__1cegZ:focus-visible {\n  outline-color: #1f1f1f;\n}\n.ToggleButton_toggleWrapper__N-lA3.ToggleButton_themed__JQnPY .ToggleButton_toggleOption__1cegZ.ToggleButton_isActive__HjXhA {\n  color: #fff;\n}\n.ToggleButton_toggleWrapper__N-lA3.ToggleButton_themed__JQnPY .ToggleButton_toggleOption__1cegZ.ToggleButton_disabled__X0NL- {\n  color: #6e6e6e;\n}\n\n.ToggleButton_toggleWrapper__N-lA3.ToggleButton_yelp__a2Y1u {\n  background-color: #f2f2f2;\n}\n.ToggleButton_toggleWrapper__N-lA3.ToggleButton_yelp__a2Y1u .ToggleButton_toggleSlide__iKznL {\n  background-color: #cd2e20;\n}\n.ToggleButton_toggleWrapper__N-lA3.ToggleButton_yelp__a2Y1u .ToggleButton_toggleOption__1cegZ {\n  color: #1f1f1f;\n}\n.ToggleButton_toggleWrapper__N-lA3.ToggleButton_yelp__a2Y1u .ToggleButton_toggleOption__1cegZ:hover {\n  color: #b91608;\n}\n.ToggleButton_toggleWrapper__N-lA3.ToggleButton_yelp__a2Y1u .ToggleButton_toggleOption__1cegZ:focus-visible {\n  outline-color: #1f1f1f;\n}\n.ToggleButton_toggleWrapper__N-lA3.ToggleButton_yelp__a2Y1u .ToggleButton_toggleOption__1cegZ.ToggleButton_isActive__HjXhA {\n  color: #fff;\n}\n.ToggleButton_toggleWrapper__N-lA3.ToggleButton_yelp__a2Y1u .ToggleButton_toggleOption__1cegZ.ToggleButton_disabled__X0NL- {\n  color: #6e6e6e;\n}";
var styles = {"toggleWrapper":"ToggleButton_toggleWrapper__N-lA3","small":"ToggleButton_small__wtxHL","toggleSlide":"ToggleButton_toggleSlide__iKznL","toggleOption":"ToggleButton_toggleOption__1cegZ","isActive":"ToggleButton_isActive__HjXhA","disabled":"ToggleButton_disabled__X0NL-","themed":"ToggleButton_themed__JQnPY","yelp":"ToggleButton_yelp__a2Y1u"};
styleInject(css_248z);

function usePrevious(value) {
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    });
    return ref.current;
}
var ToggleButton = function (_a) {
    var _b;
    var _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.firstActiveIndex, firstActiveIndex = _d === void 0 ? 0 : _d, _e = _a.handleClick, handleClick = _e === void 0 ? function () { } : _e, _f = _a.handleResetToPrevious, handleResetToPrevious = _f === void 0 ? function () { } : _f, _g = _a.isSmall, isSmall = _g === void 0 ? false : _g, _h = _a.platform, platform = _h === void 0 ? 'brand' : _h, _j = _a.shouldResetToPrevious, shouldResetToPrevious = _j === void 0 ? false : _j, _k = _a.toggleOptions, toggleOptions = _k === void 0 ? [] : _k;
    var _l = useState(firstActiveIndex), activeOptionIndex = _l[0], setActiveOptionIndex = _l[1];
    var _m = useState('0'), transform = _m[0], setTransform = _m[1];
    function handleTransformToggle(index) {
        if (index === 0) {
            setTransform('0');
        }
        else if (index === 1) {
            setTransform('100%');
        }
        else if (index === 2) {
            setTransform('200%');
        }
    }
    var prevIndex = usePrevious(activeOptionIndex);
    useEffect(function () {
        handleTransformToggle(firstActiveIndex);
        setActiveOptionIndex(firstActiveIndex);
    }, [firstActiveIndex]);
    useEffect(function () {
        if (shouldResetToPrevious && prevIndex) {
            setActiveOptionIndex(prevIndex);
            handleTransformToggle(prevIndex);
            handleResetToPrevious();
        }
    }, [shouldResetToPrevious]);
    function handleOptionClick(selectedOption, index) {
        setActiveOptionIndex(index);
        handleTransformToggle(index);
        handleClick(selectedOption);
    }
    return (React__default.createElement("div", { className: classNames(styles.toggleWrapper, className, styles[platform], (_b = {},
            _b[styles.small] = isSmall,
            _b)), "data-testid": "ToggleWrapper" },
        toggleOptions.map(function (option, index) {
            var _a;
            return (React__default.createElement("button", { className: classNames(styles.toggleOption, (_a = {},
                    _a[styles.isActive] = index === activeOptionIndex,
                    _a[styles.disabled] = option.isUnavailable,
                    _a)), key: option.label, onClick: function () { return handleOptionClick(option.label, index); }, "data-testid": option.dataTestId, type: "button", style: {
                    width: toggleOptions.length > 2 ? '33.33%' : '50%'
                }, disabled: option.isUnavailable },
                React__default.createElement("span", null, option.label),
                option.isUnavailable && React__default.createElement("span", null, "unavailable")));
        }),
        React__default.createElement("div", { className: styles.toggleSlide, style: {
                transform: "translateX(".concat(transform, ")"),
                transition: 'transform 0.8s cubic-bezier(0.22, 1, 0.36, 1)',
                width: toggleOptions.length > 2 ? '33.33%' : '50%'
            } })));
};

export { Alert, Banner, Button, ButtonSet, CardInfo, Checkbox, Cover, DashboardGrid, DropdownButton, DropdownButtonItem, Filter, FilterButton, FilterGroup, FilterList, Footer, Grid, Input, InputAddress, InputPassword, InputPayment, InputPromo, InputSearch, LoadingSpinner, MapGrid, MenuCard, MenuPrimary, MenuSimple, Modal, ModalFooter, ModalFrame, ModalHeader, Outlink, Radio, RadioButton, SearchPrimary, SelectSimple, SelectStandard, SocialList, StatusDot, Stepper, Switch, Table, TableHeader, Tabs, Tag, TagNotice, Toast, ToggleButton };
//# sourceMappingURL=index.es.js.map
